{
  "version": "analects-authored-editorial-20261007-v1",
  "acceptanceSha256": "94cba864fae84f0419b02110167cd1dda03b82718ef1eaa708bc298bae849e45",
  "difficultyCalibrated": false,
  "formalScoreAccepted": false,
  "items": [
    {
      "id": "cm-1-1a",
      "type": "comprehension",
      "refs": [
        1
      ],
      "concepts": [
        "xue"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "分辨「習」是實習演練而非溫習記誦",
      "stem": "依本頁楊注，「學而時習之」應怎樣理解？",
      "context": "子曰：“学而时习之，不亦说乎？”",
      "options": [
        {
          "id": "a",
          "text": "在適當的時候實習、演練所學"
        },
        {
          "id": "b",
          "text": "時常溫習、反覆記誦所學",
          "why": "本頁楊注把『時』解作一定或適當的時候，把『習』取作實習、演練；本題依這一指定讀法作答，並非否定溫習的學習價值。"
        },
        {
          "id": "c",
          "text": "依季節安排讀書的進度",
          "why": "本題依楊注，『時』是一定或適當的時候，『習』是實習演練；本章沒有把學習限定為按季節安排讀書。"
        },
        {
          "id": "d",
          "text": "習慣於學習這件事本身",
          "why": "「習」帶賓語「之」，指演練所學，不是養成習慣。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁楊注以禮、樂、射、御等功課需要實習演練為據，將『習』取作實習，並將『時』解作一定或適當的時候。a符合這一指定讀法；不能把它擴成所有溫習方法都沒有價值。",
      "review": {
        "version": "editorial-serial27-217eafdb335c77fa",
        "sha256": "217eafdb335c77fae34a9176b5e735d211c36690ae299bee7e6d195664a640b3",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-1-1b",
      "type": "comprehension",
      "refs": [
        1
      ],
      "concepts": [
        "xue",
        "junzi"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "依指定譯文辨明未被了解時不怨恨的態度",
      "stem": "依本頁譯文，「人不知，而不慍」描述哪一種態度？",
      "options": [
        {
          "id": "a",
          "text": "別人不了解自己，也不因此怨恨"
        },
        {
          "id": "b",
          "text": "抱怨當時無人理解自己的學問",
          "why": "全章語氣是喜悅與自持，「不慍」正是不抱怨。"
        },
        {
          "id": "c",
          "text": "說明學問要藏起來不讓人知道",
          "why": "這句說的是未被了解時的態度，並沒有要求把學問藏起來。"
        },
        {
          "id": "d",
          "text": "指出不被理解是因為學得不夠",
          "why": "本章沒有交代未被了解的原因，不能由此推出學問或德行不足。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁把『人不知』解作別人不了解我，把『慍』解作怨恨。因此a符合此處選定的讀法。注釋保留了省略賓語造成的解釋分歧；本題不把單一整章結構或不被理解的原因說成原文定論。",
      "review": {
        "version": "editorial-serial27-f19d3aaac4873efc",
        "sha256": "f19d3aaac4873efc28a504407af57e8cfb0db36a9288ca838149659334f9b65a",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-1-13",
      "type": "comprehension",
      "refs": [
        13
      ],
      "concepts": [
        "xin",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "看出承諾須先合義才談得上守信",
      "stem": "「信近於義，言可復也」——這句話對「守信」加了什麼前提？",
      "context": "有子曰：“信近于义，言可复也。恭近于礼，远耻辱也。”",
      "options": [
        {
          "id": "a",
          "text": "所許之事須合義，諾言才值得兌現"
        },
        {
          "id": "b",
          "text": "凡出口的話都須做到，不論內容",
          "why": "『不論內容』忽略了『近於義』對所守約言的限制。"
        },
        {
          "id": "c",
          "text": "承諾要留有餘地，不可說得太滿",
          "why": "「復」是實踐、兌現，不是留餘地。"
        },
        {
          "id": "d",
          "text": "守信的人自然會受到別人尊敬",
          "why": "本句以『近於義』限定約言，沒有保證守信就自然受到尊敬；此項也未回答所問的前提。"
        }
      ],
      "answerId": "a",
      "explanation": "楊注以『復』為實踐諾言。『近於義』先限定了約言的內容：承諾合乎義，才談得上正當地兌現，並非凡出口的話都須不問是非地實行。",
      "review": {
        "version": "editorial-serial27-cfce9aa00547e382",
        "sha256": "cfce9aa00547e38279ce4ee74ad1058f3497c6f22bd290daef688b11120cb452",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-1-16",
      "type": "comprehension",
      "refs": [
        16
      ],
      "concepts": [
        "zhiren"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "把焦慮的方向從被理解調轉為理解他人",
      "stem": "「不患人之不己知，患不知人也」，孔子要人把注意力放在哪裡？",
      "options": [
        {
          "id": "a",
          "text": "與其怕人不懂我，不如怕我不懂人"
        },
        {
          "id": "b",
          "text": "既不必了解別人，也不必被人了解",
          "why": "後半句明說「患不知人」，識人正是他要求的。"
        },
        {
          "id": "c",
          "text": "要努力讓更多人認識自己的才能",
          "why": "此項仍把重心放在別人是否認識自己，沒有回答後半句要求的『知人』；本句並非禁止正常溝通。"
        },
        {
          "id": "d",
          "text": "別人不了解你是你德行還不夠",
          "why": "本章不談原因，只調整用力的方向。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子把注意力從『別人不了解我』轉到『我是否了解別人』。本章的落點是知人；不能據此推論不必與人溝通，或把別人的評價完全等同自己的德行。",
      "review": {
        "version": "editorial-serial27-8a6fc705e4adc95c",
        "sha256": "8a6fc705e4adc95c242a2172a4e91d0402f0e9af1489e8a905b95408928cd79e",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-2-3",
      "type": "comprehension",
      "refs": [
        19
      ],
      "concepts": [
        "zheng",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "辨明免於刑罰不等於具有羞恥之心",
      "stem": "「道之以政，齊之以刑，民免而無恥」——「免」指的是什麼？",
      "context": "子曰：“道之以政，齐之以刑，民免而无耻；道之以德，齐之以礼，有耻且格。”",
      "options": [
        {
          "id": "a",
          "text": "免於罪刑，卻沒有羞恥之心"
        },
        {
          "id": "b",
          "text": "百姓被免除了賦稅和勞役",
          "why": "此處『免』承接政、刑的治理語境，本頁解作免罪、免刑或免禍，並非免除賦稅勞役。"
        },
        {
          "id": "c",
          "text": "統治者赦免了百姓的過錯",
          "why": "本頁把『民免』解作人民免於罪刑，原句並沒有說統治者赦免了百姓的過錯。"
        },
        {
          "id": "d",
          "text": "百姓免於被統治，各自為政",
          "why": "與全章講治理手段的對比毫不相干。"
        }
      ],
      "answerId": "a",
      "explanation": "此處『免』指免於罪刑或災禍。孔子區分外在規範使人避免受罰，與德禮使人自知羞恥的效果；不能將前者直接改寫為只求做壞事不被抓到。",
      "review": {
        "version": "editorial-serial27-479f3a89b7b3cc81",
        "sha256": "479f3a89b7b3cc8113bb789d4f26ea2c0d8dad96240815ca61fa496b64bdf697",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-2-4",
      "type": "comprehension",
      "refs": [
        20
      ],
      "concepts": [
        "xue",
        "tianming"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "分清「立」與「不惑」各指什麼",
      "stem": "依本頁楊注，「三十而立，四十而不惑」的兩級各指什麼？",
      "options": [
        {
          "id": "a",
          "text": "懂得禮儀而能立身；知識漸充而不致迷惑"
        },
        {
          "id": "b",
          "text": "成家立業；不再受人迷惑欺騙",
          "why": "本頁以懂禮而站得住說明『立』，以掌握知識說明『不惑』，沒有把兩級譯作成家與不受欺騙。"
        },
        {
          "id": "c",
          "text": "開始做官；不再更換自己的職務",
          "why": "全章講為學的階段，不是仕途年表。"
        },
        {
          "id": "d",
          "text": "確立志向；不再感到迷惘徬徨",
          "why": "原文已在十五歲說『志於學』；本頁對三十歲的『立』重在懂禮而站得住，不能換成最初確立志向。"
        }
      ],
      "answerId": "a",
      "explanation": "此章以志學、立、不惑、知天命、耳順、從心所欲不踰矩敘述不同年齡的進境。依楊注，『立』重在懂禮而站得住，『不惑』重在知識漸充而不疑惑，不是成家與官職的時間表。",
      "review": {
        "version": "editorial-serial27-dec83f3e5fade041",
        "sha256": "dec83f3e5fade0416926660deb3fe41b8c7050659257229028cdc2cae12becb6",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-2-7",
      "type": "comprehension",
      "refs": [
        23
      ],
      "concepts": [
        "xiao"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "看出供養之外還須敬意，不能只以能養說盡孝",
      "stem": "「今之孝者，是謂能養……不敬，何以別乎？」的要點是？",
      "context": "子游问孝。子曰：“今之孝者，是谓能养。至于犬马，皆能有养；不敬，何以别乎？”",
      "options": [
        {
          "id": "a",
          "text": "孝不能只以供養為足，還須敬意"
        },
        {
          "id": "b",
          "text": "養父母比養犬馬重要，不可顛倒",
          "why": "章意不在排序，而在「養」之外還缺什麼。"
        },
        {
          "id": "c",
          "text": "犬馬也懂奉養父母，人更應如此",
          "why": "楊注採人也能養犬馬的讀法，並另記犬馬能養活人一說可通；犬馬奉養自己父母一說則被明確否定。兩種可通讀法都以『敬』作人之孝的分界。"
        },
        {
          "id": "d",
          "text": "孝要看物質條件，家貧難盡孝",
          "why": "本章沒有說家貧便不能盡孝，而是指出只做到供養、缺少敬意，尚不足以說明孝。"
        }
      ],
      "answerId": "a",
      "explanation": "『不敬，何以別乎』把敬意提出為孝不可缺少的要求。本頁主譯以人也能飼養犬馬作比較；注中另保留犬馬能養活人的讀法。兩種讀法都不能把孝縮成物質供養，也不能據此認為敬意可以代替實際照料。",
      "review": {
        "version": "editorial-serial27-a28f764da8d24570",
        "sha256": "a28f764da8d245708d10327d17eae873418035547cacac3683ef7de44c691d62",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-2-8",
      "type": "comprehension",
      "refs": [
        24
      ],
      "concepts": [
        "xiao"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "依本頁主譯辨識色難，保留容色解釋的範圍",
      "stem": "依本頁楊伯峻採用的解釋，子夏問孝時所說『色難』，難的是什麼？",
      "options": [
        {
          "id": "a",
          "text": "子女侍親時經常保持愉悅的容色"
        },
        {
          "id": "b",
          "text": "分辨父母臉色，隨時揣摩心意",
          "why": "本頁注釋記載『侍奉父母的容色』一說，但未採用；譯文取子女侍親時自身的容色。本題依這一主譯作答，並不抹去注中記錄的另一說。"
        },
        {
          "id": "c",
          "text": "在外人面前替父母保住面子",
          "why": "本頁把色難解為侍親時的容色，沒有把它訓成在外人面前維持面子。"
        },
        {
          "id": "d",
          "text": "為父母操辦體面的飲食與喪祭",
          "why": "下文質疑能否只憑代勞供食便說盡孝，不等於否定這些照料；本頁也未把色難解為操辦喪祭。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁主譯把色難理解為子女侍親時的容色，並記另一種侍奉父母容色的解釋而未採用。原章不以代勞供食說盡孝，但不表示可以只憑一次臉色判定內心，也沒有說現實中的供養與照料都很容易。",
      "review": {
        "version": "editorial-serial27-7ed294a93c202575",
        "sha256": "7ed294a93c202575b4841598e73beeef0be5a0c0bf1957491bd324f3cb7f1df0",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-2-10",
      "type": "comprehension",
      "refs": [
        26
      ],
      "concepts": [
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "區分楊譯所採三項識人方法與注中另一讀法",
      "stem": "依本頁楊伯峻譯文，『視其所以，觀其所由，察其所安』依次考察什麼？",
      "options": [
        {
          "id": "a",
          "text": "交往的人、行事的方法、心所安處"
        },
        {
          "id": "b",
          "text": "外在名聲、官位高低、所得利益",
          "why": "這三項不是本頁楊譯對所以、所由、所安的解釋。"
        },
        {
          "id": "c",
          "text": "做事的動機、採用的手段、得到的結果",
          "why": "本頁楊譯並未將三項分別解作動機、手段與結果。"
        },
        {
          "id": "d",
          "text": "三句都指觀察對方的言論是否一致",
          "why": "本頁譯文分別考察交往對象、行事方法和心所安處，不能把三項都縮成核對言論是否一致。"
        }
      ],
      "answerId": "a",
      "explanation": "楊伯峻以『以』為『與』，將『所以』譯為所結交的朋友；『所由』是採用的方法，『所安』是心情安於何事。注中也說把所以解為所為可以通，這一異解應保留，但不是本題指定的楊譯。",
      "review": {
        "version": "editorial-serial27-b477dcb20ac262e4",
        "sha256": "b477dcb20ac262e4f006c899f78735dd38cc48dac505d0acdb02511d7d1262b7",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-2-15",
      "type": "comprehension",
      "refs": [
        31
      ],
      "concepts": [
        "xue"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "分清「罔」與「殆」是兩種不同的失",
      "stem": "依本頁楊伯峻譯文，『學而不思則罔，思而不學則殆』中的『罔』『殆』各指什麼？",
      "options": [
        {
          "id": "a",
          "text": "受欺受騙；疑惑而缺乏信心"
        },
        {
          "id": "b",
          "text": "忘記了所學；懶怠而不肯用功",
          "why": "本頁把『罔』解為受欺，把『殆』取作疑惑，並未解為忘記或懶怠。"
        },
        {
          "id": "c",
          "text": "學得太雜亂；想得太多而無用",
          "why": "毛病不在多寡，而在缺了另一半。"
        },
        {
          "id": "d",
          "text": "兩者程度不同，都指白費工夫",
          "why": "楊譯分別說明受欺與疑惑，不能只當程度不同的白費工夫，也未斷言殆必比罔更嚴重。"
        }
      ],
      "answerId": "a",
      "explanation": "楊注把『罔』解作誣罔、受欺；『殆』有疑惑與危險兩種可通讀法，本頁譯文採疑惑，譯作缺乏信心。題目須按指定讀法作答，同時保留另一解的注釋地位。",
      "review": {
        "version": "editorial-serial27-7ee03381e99a480c",
        "sha256": "7ee03381e99a480c18d109c60a1ccee98f87aaf68bc57507d6ec94db9c189bc3",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-2-17",
      "type": "comprehension",
      "refs": [
        33
      ],
      "concepts": [
        "xue",
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "認出末字「知」當讀作「智」",
      "stem": "依本頁楊注據《荀子》採取的讀法，『知之為知之，不知為不知，是知也』最後一個知如何解？",
      "options": [
        {
          "id": "a",
          "text": "同『智』，指如實對待知與不知的智慧"
        },
        {
          "id": "b",
          "text": "仍是知道：這就是所謂的知道",
          "why": "楊注採知通智；另記知如字讀時可解作對待知與不知的正確態度，不能把如字讀一概斥為同義反覆。"
        },
        {
          "id": "c",
          "text": "指知識：這就是真正的知識",
          "why": "題目所問的末字，本頁按『智』譯為聰明智慧，並未把它譯成知識內容。"
        },
        {
          "id": "d",
          "text": "指告知：這樣才好告訴別人",
          "why": "本章討論如何對待知與不知，末句不是向別人告知某件事。"
        }
      ],
      "answerId": "a",
      "explanation": "楊注以《荀子·子道》相關記載為據，讀末一知為智，重在如實承認已知與未知。現有本章只交代對話對象為子路，不宜把好逞強直接寫成此問已證實的原因。",
      "review": {
        "version": "editorial-serial27-31f36c9c4b03082e",
        "sha256": "31f36c9c4b03082e3ac8a70efc8911760970743eef67735aa5f458db5a66e529",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-3-4",
      "type": "comprehension",
      "refs": [
        44
      ],
      "concepts": [
        "li"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "依本頁訓解辨明易，理解喪禮儀文與哀戚的取捨",
      "stem": "依本頁楊注，「喪，與其易也，寧戚」的『易』指什麼？",
      "options": [
        {
          "id": "a",
          "text": "把喪禮的儀文辦得周到"
        },
        {
          "id": "b",
          "text": "輕忽草率地把喪事辦過去",
          "why": "本頁以把事情辦妥說明『易』，譯作儀文周到，並非轻忽草率。"
        },
        {
          "id": "c",
          "text": "更改舊有的喪禮制度與儀節",
          "why": "全章對比的是同一件事的兩種做法，不是改制。"
        },
        {
          "id": "d",
          "text": "容易、省事，指一切從簡辦理",
          "why": "本頁把此處『易』解作辦妥、儀文周到，沒有取容易省事之義；前句的『儉』不能代替這一訓解。"
        }
      ],
      "answerId": "a",
      "explanation": "楊注以『易』有辦妥事情之義，譯為儀文周到，並引《禮記·檀弓》的禮有餘而哀不足與禮不足而哀有餘作說明。這是在喪禮中凸顯哀戚的分量，不是宣稱儀文與哀情不能兼有。",
      "review": {
        "version": "editorial-serial27-daf79a3ee9a6b45a",
        "sha256": "daf79a3ee9a6b45a6b1d556cdb1749375e39f90d89272b242af0423703e69971",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-3-8",
      "type": "comprehension",
      "refs": [
        48
      ],
      "concepts": [
        "li",
        "wenzhi",
        "shijiao"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "理解「繪事後素」與「禮後」的類比關係",
      "stem": "依本頁楊譯，子夏由「繪事後素」引出「禮後乎」，兩者的類比是什麼？",
      "context": "子夏问曰：“‘巧笑倩兮，美目盼兮，素以为绚兮。’何谓也？”子曰：“绘事后素。”曰：“礼后乎？”",
      "options": [
        {
          "id": "a",
          "text": "禮以仁義為基礎，如繪畫先有素地"
        },
        {
          "id": "b",
          "text": "禮排在《詩》之後，應先學詩",
          "why": "「後」說的是本末先後的邏輯，不是課程排序。"
        },
        {
          "id": "c",
          "text": "禮不重要，可以放到最後再說",
          "why": "本頁把禮後解為禮樂在仁義之後，有基礎而後有禮，並不等於禮不重要。"
        },
        {
          "id": "d",
          "text": "作畫最後用白色勾邊以成其美",
          "why": "本頁取先有白色底子、然後畫花的讀法；本題所問還須說明它如何類比於禮，單列勾邊技法沒有回答。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁以先有白色底子後繪花，類比禮樂在仁義之後。注釋明說原句沒有交代『禮』在什麼之後，『仁義』是譯者依儒家文獻補入的，不是本章原有字句。子夏由畫理推問禮，孔子以『起予者商也』肯定其啟發。",
      "review": {
        "version": "editorial-serial27-bd5c92ff5ff63de9",
        "sha256": "bd5c92ff5ff63de908adea61bbeef36f3133a7cf0dac63d69738163a140df510",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-3-17",
      "type": "comprehension",
      "refs": [
        57
      ],
      "concepts": [
        "li"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "依本頁辨明兩個愛字的可惜義及不同對象",
      "stem": "依本頁楊譯，「爾愛其羊，我愛其禮」的兩個『愛』怎麼講？",
      "options": [
        {
          "id": "a",
          "text": "可惜、捨不得失去，重點各不同"
        },
        {
          "id": "b",
          "text": "喜愛：你喜歡羊，我喜歡禮",
          "why": "本頁把兩個『愛』都譯作可惜，重點是可惜羊與可惜禮的差別，未譯為喜歡。"
        },
        {
          "id": "c",
          "text": "愛護：你護牲畜，我護制度",
          "why": "本頁把『愛』譯為可惜，並說子貢主張連殘存的殺羊形式也去掉；沒有把他的動機定為保護牲畜生命。"
        },
        {
          "id": "d",
          "text": "看重：你重實利，我重虛文",
          "why": "孔子所可惜的是禮；本頁說他認為保留殘存形式比全不留下好，並未把禮判作無價值的虛文。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁將兩個『愛』都解作可惜。注釋說魯君已不親臨祖廟和聽政，仍殺活羊；子貢認為不必保留這個形式，孔子卻認為留有殘存形式比什麼也不留好。兩人可惜的對象不同。",
      "review": {
        "version": "editorial-serial27-7260fe0bb25b7b5f",
        "sha256": "7260fe0bb25b7b5f1f6f082456310a9db6f21cda80e450dba6150262f448a707",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-4-5",
      "type": "comprehension",
      "refs": [
        71
      ],
      "concepts": [
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "看清孔子限制的是取得方式而非富貴本身",
      "stem": "「富與貴，是人之所欲也；不以其道得之，不處也。」孔子的立場是？",
      "options": [
        {
          "id": "a",
          "text": "人皆欲之，惟取之不以道則不受"
        },
        {
          "id": "b",
          "text": "君子應當厭惡富貴，安於貧賤",
          "why": "開頭就說「人之所欲也」，孔子並不否認這份願望。"
        },
        {
          "id": "c",
          "text": "富貴本身有害，終究會敗壞德行",
          "why": "本章承認富貴是人所欲，限制的是取得方式是否合道；並沒有斷言富貴本身必然敗壞德行。"
        },
        {
          "id": "d",
          "text": "只要目的正當，手段就不必計較",
          "why": "正好相反，本句限制的就是手段。"
        }
      ],
      "answerId": "a",
      "explanation": "上半章並不否認對富貴的願望，而以取得方式是否合道作限制。下半章原文仍作得之；楊注提出去之的改讀，譯為不可用不正當方式擺脫貧賤。原文與校勘意見須分別保留。",
      "review": {
        "version": "editorial-serial27-877c95e0b020c1ad",
        "sha256": "877c95e0b020c1ad62e08819aed5806d6eda3b1896b69978ed1781c77bb18399",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-4-10",
      "type": "comprehension",
      "refs": [
        76
      ],
      "concepts": [
        "yili",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "分清「無適無莫」不是沒有立場",
      "stem": "依本頁楊譯，「無適也，無莫也，義之與比」應怎樣理解？",
      "options": [
        {
          "id": "a",
          "text": "不預設可否，一切向義靠攏"
        },
        {
          "id": "b",
          "text": "對天下事不表態，保持中立",
          "why": "『義之與比』要求依義作判斷，並不是對事情一概不表態。"
        },
        {
          "id": "c",
          "text": "不親近誰也不疏遠誰，一視同仁",
          "why": "注釋確實記錄以親疏解『適莫』的一說，但主譯採不預定怎樣做或不怎樣做；此項也沒有說明『義之與比』的判準。"
        },
        {
          "id": "d",
          "text": "凡事適可而止，不走任何極端",
          "why": "本章要求按具體事情是否合義作判斷，不能只以折衷或避開兩端代替這個判準。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁把『無適無莫』譯為不預先規定一定怎樣做或一定不怎樣做，接著以合理恰當作取捨。這是依義判斷而非毫無原則；注中其他適莫讀法仍須保留其異解地位。",
      "review": {
        "version": "editorial-serial27-537a83f7fc337d02",
        "sha256": "537a83f7fc337d02f5e2caf6a810ab55cdbb654d220d4be918fa632b7b748946",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-4-18",
      "type": "comprehension",
      "refs": [
        84
      ],
      "concepts": [
        "xiao"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "看出孝並不等於一味順從",
      "stem": "「事父母幾諫，見志不從，又敬不違，勞而不怨。」這章對「順從」的態度是？",
      "options": [
        {
          "id": "a",
          "text": "有錯要婉勸，勸不動仍敬不怨"
        },
        {
          "id": "b",
          "text": "父母的話一律照辦，不可異議",
          "why": "「幾諫」明說要勸；一律照辦正是本章排除的。"
        },
        {
          "id": "c",
          "text": "勸不聽便不必顧及說話的方式",
          "why": "幾諫與又敬要求勸諫的方式仍婉轉恭敬，不因未被採納就取消分寸。"
        },
        {
          "id": "d",
          "text": "勸諫無效就無須再敬重父母",
          "why": "楊注以不違為不觸忤、冒犯，不是凡事照辦；又敬仍要求保持恭敬，並未取消勸諫。"
        }
      ],
      "answerId": "a",
      "explanation": "『幾諫』是輕微婉轉地勸止，『不違』在本頁解作不觸犯，並非把父母的話一律照辦。心意未被採納，仍恭敬而不怨恨；『勞』解作憂愁，也不等於必須毫無難過之情。",
      "review": {
        "version": "editorial-serial27-5bf28445f077a7f4",
        "sha256": "5bf28445f077a7f406cb5a11a2e910907bc2e4bf11d96857f926ada6be114673",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-4-19",
      "type": "comprehension",
      "refs": [
        85
      ],
      "concepts": [
        "xiao"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "認出「方」指確定的去處",
      "stem": "依本頁譯文，「父母在，不遠遊，遊必有方」的『方』指什麼？",
      "options": [
        {
          "id": "a",
          "text": "一定的去處"
        },
        {
          "id": "b",
          "text": "正當的理由，不可無故遠行",
          "why": "「方」是方位、去向；理由是另一回事。"
        },
        {
          "id": "c",
          "text": "妥善的辦法，先安排好奉養",
          "why": "安排奉養合乎情理，但不是「方」的字義。"
        },
        {
          "id": "d",
          "text": "一定的期限，說好何時回來",
          "why": "期限也不是「方」；此字指的是所在。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁先譯『父母在世，不出遠門』，再說如果要出遠門，必須有一定去處。『方』回答去往何處，並非出行理由、奉養辦法或返回期限；不能只取後半句便說前半句的要求全被取消。",
      "review": {
        "version": "editorial-serial27-9a40beaa3531c2ad",
        "sha256": "9a40beaa3531c2adc6ee0fbfaf1d8d7d886d682f13cdb08f7838588f137f44b8",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-5-10",
      "type": "comprehension",
      "refs": [
        102
      ],
      "concepts": [
        "zhiren",
        "xue"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "看出宰予一事引出的是識人方法的修正",
      "stem": "孔子由宰予晝寢說「今吾於人也，聽其言而觀其行」，重點是？",
      "options": [
        {
          "id": "a",
          "text": "他改了識人法：聽言之外還要觀行"
        },
        {
          "id": "b",
          "text": "他從此不再相信任何人說的話",
          "why": "是加上觀行這一道，不是廢掉聽言。"
        },
        {
          "id": "c",
          "text": "他認為宰予的那套言論本身有錯",
          "why": "本章沒有列出宰予的那套言論內容；所引句子的重點是聽言之外還要觀行，不能換成判定某套言論本身有錯。"
        },
        {
          "id": "d",
          "text": "他要求學生們少說話而多做事",
          "why": "本句說的是孔子自己的判斷方式，主語是「吾於人也」。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子藉宰予晝寢一事說明識人方法的改變：不能只聽言語就相信行為，還須觀察行動。楊注提醒兩次子曰分屬不同時候的言語，不宜合成同一場當面訓話。",
      "review": {
        "version": "editorial-serial27-ab7ab5bb201c4b1a",
        "sha256": "ab7ab5bb201c4b1a21f8b322dc70675d3133fc23996e7f125806a2caeb88540f",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-5-15",
      "type": "comprehension",
      "refs": [
        107
      ],
      "concepts": [
        "xue"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨認孔子明說的敏而好學與不恥下問兩項理由",
      "stem": "孔文子何以謂之「文」？孔子給的理由是？",
      "options": [
        {
          "id": "a",
          "text": "敏而好學，且不恥於下問"
        },
        {
          "id": "b",
          "text": "文章寫得好，文采出眾動人",
          "why": "本章明說的理由是敏而好學、不恥下問，沒有以文章寫得好作答。"
        },
        {
          "id": "c",
          "text": "熟習典章制度，通曉古今文獻",
          "why": "孔子在本章指出的是好學與下問的態度，並沒有列出通曉典章文獻這一項理由。"
        },
        {
          "id": "d",
          "text": "待人溫文有禮，進退皆有分寸",
          "why": "溫文是另一路，本章明說「敏而好學，不恥下問」。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子對文諡給出的理由是敏而好學、不恥下問。此題要求依本章明文辨認理由，不能把文章寫得好或溫文有禮當作替代答案；人物的其他評價須另有來源。",
      "review": {
        "version": "editorial-serial27-eb7ad71eab6d607e",
        "sha256": "eb7ad71eab6d607e02d4955aa7f255c7126b78daf6d3fd3ff5c3879444924955",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-6-18",
      "type": "comprehension",
      "refs": [
        138
      ],
      "concepts": [
        "wenzhi",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "認出「史」與「野」同為偏失的一端",
      "stem": "依本頁楊譯，「文勝質則史」的『史』帶什麼評價，又指什麼？",
      "options": [
        {
          "id": "a",
          "text": "貶：文飾過度，流於虛浮"
        },
        {
          "id": "b",
          "text": "褒：有歷史感、有文化的底蘊",
          "why": "本頁把文勝質譯作未免虛浮，並不是稱讚歷史感或文化底蘊。"
        },
        {
          "id": "c",
          "text": "中性：指記錄史實的客觀態度",
          "why": "本頁以文采和朴實配合適當為要求，把文勝質說成虛浮，沒有把『史』解為客觀記錄史實。"
        },
        {
          "id": "d",
          "text": "貶：拘泥於古書而不通世務",
          "why": "本頁把文勝質之『史』譯為虛浮，未解作拘泥古書或不通世務；只有貶義方向相近仍不足以答對。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁楊譯把質勝文說成粗野，把文勝質說成虛浮。『史』在此處帶有貶義，與『野』共同構成偏失；『文質彬彬』要求兩者相稱，並非可以量化的各占一半。",
      "review": {
        "version": "editorial-serial27-c7e07dc6d35aca0a",
        "sha256": "c7e07dc6d35aca0af5adccfd9893aca84bf7439620ec6d4aa9b07f612b3ec07c",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-6-20",
      "type": "comprehension",
      "refs": [
        140
      ],
      "concepts": [
        "xue"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨認知、好、樂三種態度及本章對它們的比較",
      "stem": "「知之者不如好之者，好之者不如樂之者」，三者的分別是？",
      "options": [
        {
          "id": "a",
          "text": "懂得不如喜愛，喜愛不如以它為樂"
        },
        {
          "id": "b",
          "text": "三種階段必須依序完成，不能先喜歡後懂得",
          "why": "原句比較對所學或所做之事的不同態度，沒有規定每個人必須依同一先後階段發展。"
        },
        {
          "id": "c",
          "text": "學得快不如學得久，久不如輕鬆",
          "why": "原句比較懂得、喜愛與以之為樂的態度，沒有按學習速度或持續時間排次序。"
        },
        {
          "id": "d",
          "text": "知識不如興趣，興趣不如天賦",
          "why": "第三層是「樂」不是天賦，全章不談稟賦。"
        }
      ],
      "answerId": "a",
      "explanation": "三個『之』指向同一對象，本頁譯文以學問和事業補明它。原句更肯定喜愛與以之為樂，但沒有規定每個人必須依同一先後階段發展，也沒有說有樂便不再需要努力。",
      "review": {
        "version": "editorial-serial27-67fb3821ae992c49",
        "sha256": "67fb3821ae992c4977f9c9b19053e32a1cfa4ea5b45180153d9f8bb18489ba02",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-6-22",
      "type": "comprehension",
      "refs": [
        142
      ],
      "concepts": [
        "tianming",
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "辨明敬與遠並存，以及務民之義的人事重點",
      "stem": "「務民之義，敬鬼神而遠之，可謂知矣」——「遠之」是什麼態度？",
      "options": [
        {
          "id": "a",
          "text": "嚴肅對待而不求接近，把心力用於人事"
        },
        {
          "id": "b",
          "text": "否認鬼神的存在，破除迷信",
          "why": "本句說明對鬼神所採取的態度與人事實踐的重點，沒有論證鬼神是否存在。"
        },
        {
          "id": "c",
          "text": "疏遠祭祀，不必再行祭祀之禮",
          "why": "本句同時保留『敬』與『遠』；注以祈禱、淫祀作不遠之的例子，並沒有說一切祭祀之禮都應取消。"
        },
        {
          "id": "d",
          "text": "敬畏鬼神，凡事先問卜再決定",
          "why": "那正是「遠之」所排除的依賴。"
        }
      ],
      "answerId": "a",
      "explanation": "『務民之義』把實踐重點放在人事；『敬鬼神而遠之』則保留敬意而不接近。依楊注，遠讀去聲，有疏遠之意。這種處事態度不能直接改寫成肯定或否定鬼神存在的結論。",
      "review": {
        "version": "editorial-serial27-bfd8fbe9369c40a0",
        "sha256": "bfd8fbe9369c40a0641a176dba10048d691827912980281b23d0846a5202c131",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-6-30",
      "type": "comprehension",
      "refs": [
        150
      ],
      "concepts": [
        "ren",
        "shu"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "認出「為仁之方」是可當下操作的方法",
      "stem": "「能近取譬，可謂仁之方也已」——孔子給子貢的是什麼？",
      "context": "子曰：“夫仁者，己欲立而立人，己欲达而达人。能近取譬，可谓仁之方也已。”",
      "options": [
        {
          "id": "a",
          "text": "從切近事實取例，實踐己欲立而立人"
        },
        {
          "id": "b",
          "text": "一個崇高的目標：博施而能濟眾",
          "why": "前文把博施濟眾推至聖德的高度；此句的近取譬著重如何從自身經驗推及他人。孔子沒有因此否定博施濟眾。"
        },
        {
          "id": "c",
          "text": "一句勉勵：仁很難，要慢慢來",
          "why": "「方」是方法、門路，不是安慰。"
        },
        {
          "id": "d",
          "text": "一條戒律：不可以只顧自己",
          "why": "本章給的是正面的推法，不是禁令。"
        }
      ],
      "answerId": "a",
      "explanation": "『近取譬』把自己的願望作為理解他人的切近參照：自己想立足，也助人立足，自己想通達，也助人通達。此處說的是實行仁的方法；前文的博施濟眾仍作更高的德行描述保留。",
      "review": {
        "version": "editorial-serial27-626bfaf7e04e58b7",
        "sha256": "626bfaf7e04e58b75e9f66da19f939394913f6e0232f7e190237da6c684c0df1",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-7-1",
      "type": "comprehension",
      "refs": [
        151
      ],
      "concepts": [
        "xue",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "依指定譯注理解傳述、好古與創造性的關係",
      "stem": "結合本頁楊注，如何理解孔子自述『述而不作，信而好古』？",
      "options": [
        {
          "id": "a",
          "text": "重在傳述與好古，未必全無創造性"
        },
        {
          "id": "b",
          "text": "只轉述他人的話，自己不表意見",
          "why": "楊注對作字保留『大概』的判斷，並明說難謂孔子學說沒有創造性；不能把這句話等同沒有自己的主張。"
        },
        {
          "id": "c",
          "text": "只寫作而不創新，照抄古書成說",
          "why": "本頁把『述』譯為闡述，注又說很難認為孔子學說沒有創造性，不能將它等同照抄古書。"
        },
        {
          "id": "d",
          "text": "厚古薄今，反對一切制度變動",
          "why": "本句的信而好古沒有說反對一切制度變動；本頁注釋也保留孔子學說有創造性的理解。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子以傳述、信古與好古說明自己的取向。楊注把作與『不知而作』聯繫時使用『大概』，又指出孔子學說不能說完全沒有創造性。因此不宜把述而不作講成照抄古書，也不宜確定地縮成只是不創制某類制度。",
      "review": {
        "version": "editorial-serial27-4ccef0ab80a84fb6",
        "sha256": "4ccef0ab80a84fb68320e0b9aa1814ae2a0a8de3b4e897306572000cf454bb88",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-7-8",
      "type": "comprehension",
      "refs": [
        158
      ],
      "concepts": [
        "jiaoxue",
        "xue"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "認出「憤悱」是啟發得以生效的時機",
      "stem": "「不憤不啟，不悱不發」——「憤」與「悱」指學生的什麼狀態？",
      "options": [
        {
          "id": "a",
          "text": "想通而未通、想說而說不清"
        },
        {
          "id": "b",
          "text": "憤怒與抱怨，鬧情緒時不宜教",
          "why": "「憤」在此是求通而未得的心憤，與怒無關。"
        },
        {
          "id": "c",
          "text": "懶惰與敷衍，不用功的不必教",
          "why": "憤、悱描述想弄明白與想說清楚而尚未做到的狀態，並非懶惰敷衍的同義詞。"
        },
        {
          "id": "d",
          "text": "已經完全弄懂並能清楚地表達",
          "why": "本頁注釋的『未得』『未能』都表示尚未做到，與已完全弄懂並清楚表達的狀態相反。"
        }
      ],
      "answerId": "a",
      "explanation": "憤是想求通而尚未通，悱是想表達而尚未能表達；啟發承接的是這種求知狀態。本章末句仍說不能舉一反三便不復，楊譯亦保留不再教之意。不能將未能推知直接寫成不肯努力，更不能省掉這個需要討論的教學條件。",
      "review": {
        "version": "editorial-serial27-c5f9e61f8045c8ce",
        "sha256": "c5f9e61f8045c8ce5823f44b1ad6c26ade23035381d78aec381478a85639723d",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-7-16",
      "type": "comprehension",
      "refs": [
        166
      ],
      "concepts": [
        "yili",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "理解浮雲比喻所表達的富貴取捨態度",
      "stem": "「不義而富且貴，於我如浮雲」——「如浮雲」形容的是？",
      "options": [
        {
          "id": "a",
          "text": "不看重以不義方式得來的富貴"
        },
        {
          "id": "b",
          "text": "轉眼消散，不義之財留不長久",
          "why": "重點不在它會不會消失，而在孔子對它的態度。"
        },
        {
          "id": "c",
          "text": "高不可攀，形容自己求它不得",
          "why": "本句用不義限定所談的富貴，著重取捨態度；沒有說因為無法取得，才將它看作浮雲。"
        },
        {
          "id": "d",
          "text": "輕飄虛浮，形容那種人沒分量",
          "why": "喻體指向的是富貴，不是人。"
        }
      ],
      "answerId": "a",
      "explanation": "粗食、飲水、曲肱而枕仍可以有樂；不義的富貴則被比作浮雲。這個對照表現孔子對生活與取捨的態度，不能擴張為排斥所有富貴，也不能據此斷定他內心從未感到任何誘惑。",
      "review": {
        "version": "editorial-serial27-61f69ed91f9f6d33",
        "sha256": "61f69ed91f9f6d3376b28911b9a51038518b54cee15408eb5b64ee191c6eb58f",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-8-7",
      "type": "comprehension",
      "refs": [
        195
      ],
      "concepts": [
        "ren",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "理清弘毅與任重道遠的對應關係",
      "stem": "「士不可以不弘毅，任重而道遠」——按下文的直接照應，『任重』『道遠』分別由哪句解釋？",
      "options": [
        {
          "id": "a",
          "text": "仁以為己任解任重，死而後已解道遠"
        },
        {
          "id": "b",
          "text": "仁以為己任解道遠，死而後已解任重",
          "why": "次序顛倒了：擔子重是因為擔的是仁，路遠是因為要走到死。"
        },
        {
          "id": "c",
          "text": "兩句都在解釋前面的「弘毅」二字",
          "why": "下文『不亦重乎』『不亦遠乎』分別緊接仁以為己任與死而後已，直接照應任重、道遠，雖然整體仍與弘毅的要求相關。"
        },
        {
          "id": "d",
          "text": "兩句都在說做官任事的辛勞不易",
          "why": "下文明說以仁為己任、到死方休，不能將這份責任與路程都縮成做官的辛勞。"
        }
      ],
      "answerId": "a",
      "explanation": "『仁以為己任』解釋責任之重，『死而後已』解釋路程之遠。楊注以弘毅為強毅，說任重須強、致遠須決；本題依此理解，不把弘另解為心胸寬廣而不交代讀法差異。",
      "review": {
        "version": "editorial-serial27-9528ab3f4a5eecac",
        "sha256": "9528ab3f4a5eecac33e0c946e41ddc96b2b6e6e8a70d26ded39ad1030f7edf98",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-9-4",
      "type": "comprehension",
      "refs": [
        213
      ],
      "concepts": [
        "junzi",
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "準確解出毋意毋必毋固毋我四項",
      "stem": "依本頁譯文，「毋意，毋必，毋固，毋我」四者依次指什麼？",
      "options": [
        {
          "id": "a",
          "text": "不憑空揣測、不絕對肯定、不拘泥固執、不自以為是"
        },
        {
          "id": "b",
          "text": "沒有意見、沒必要、不固執、無我",
          "why": "本頁把『毋意』譯作不懸空揣測，『毋必』譯作不絕對肯定，並非沒有意見或沒必要。"
        },
        {
          "id": "c",
          "text": "不重意圖、不講必然、不守成規、不談自己",
          "why": "本頁譯文所說的是判斷與處事的偏失，不是取消意圖、必然或成規；毋我也不是禁止談及自己。"
        },
        {
          "id": "d",
          "text": "不隨意、不勉強、不僵化、不自私",
          "why": "依本頁楊譯，毋意是不懸空揣測，毋必是不絕對肯定，毋我是不唯我獨是；不能以較寬泛的隨意、勉強與自私逐一代替。"
        }
      ],
      "answerId": "a",
      "explanation": "四項分別指懸空揣測、絕對肯定、拘泥固執與唯我獨是。本題問指定譯義，重點是逐項辨明，不能因四個否定詞看來相近就將不同概念互換。",
      "review": {
        "version": "editorial-serial27-da02ed3f2fbb0db2",
        "sha256": "da02ed3f2fbb0db24de39f981ea866d0d6a8de24d18877b71c0604e34277adc6",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-9-17",
      "type": "comprehension",
      "refs": [
        226
      ],
      "concepts": [
        "xue",
        "tianming"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "區分本句直接解釋與後世思想發揮",
      "stem": "依本頁楊注，孔子川上之歎最直接表達什麼？",
      "options": [
        {
          "id": "a",
          "text": "感嘆時光如流水，晝夜不停而不返"
        },
        {
          "id": "b",
          "text": "感傷人生短暫，功業終究難成",
          "why": "時光不返的感嘆，不等於判定人生功業必然無法完成。"
        },
        {
          "id": "c",
          "text": "說明世事無常，不必過於執著",
          "why": "本句並未提出放棄努力或不執著的勸告，不能由世事變動直接推出這種行動主張。"
        },
        {
          "id": "d",
          "text": "以水比喻智者，呼應知者樂水",
          "why": "本頁把逝者解作時光；知者樂水屬另一章的比喻，不能替換此處直接所指。"
        }
      ],
      "answerId": "a",
      "explanation": "楊伯峻把本句直接理解為感嘆光陰如流水奔駛不返，並提醒未必有更深的意思。孟子、荀子、董仲舒等人的發揮可以另行比較，卻不能不加分辨地說成孔子已明定的原意。",
      "review": {
        "version": "editorial-serial27-5e0d9c671bc54cec",
        "sha256": "5e0d9c671bc54cec523e1244f04c498ccd061a3c3d85f4b64abeb8e430c9f3d5",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-9-29",
      "type": "comprehension",
      "refs": [
        238,
        404,
        326
      ],
      "concepts": [
        "ren",
        "zhiren",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "對讀相關章句，區分德行表述與未經證實的心理因果",
      "stem": "對讀『仁者不憂』與『內省不疚，夫何憂何懼』，為何不宜把前者解成天生不焦慮？",
      "options": [
        {
          "id": "a",
          "text": "相關表述著重反省與德行，未斷定天生氣質",
          "why": "12.4以內省不疚說明君子不憂懼；與仁者不憂對讀，可看出德行實踐的線索，卻不能推出先天不會焦慮。"
        },
        {
          "id": "b",
          "text": "凡知識較多的人，都必然沒有任何憂慮",
          "why": "兩章沒有以知識總量保證人沒有憂慮；9.29也分列知、仁、勇的不同表述。"
        },
        {
          "id": "c",
          "text": "只有天生溫和的人，才可能具有仁德",
          "why": "兩章都沒有把天生溫和設為取得仁德的條件。"
        },
        {
          "id": "d",
          "text": "仁者人緣必定很好，所以總有人解決困難",
          "why": "兩章沒有這項人際因果保證，不能用未給出的外援替代德行與反省。"
        }
      ],
      "answerId": "a",
      "explanation": "9.29及14.28列出仁者不憂，12.4則以內省不疚說明君子何以不憂懼。對讀可討論修養與反省的關係，但要保留兩章主語與語境的差別；不能把它們變成對天生氣質或現代焦慮症狀的判定。",
      "review": {
        "version": "editorial-serial27-ffedce6da3f0dc95",
        "sha256": "ffedce6da3f0dc9564b790c4cbe0b1e966ddddede23dce7534529122860d55b4",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-11-12",
      "type": "comprehension",
      "refs": [
        282
      ],
      "concepts": [
        "tianming",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "辨認反問句所引導的注意方向",
      "stem": "從『未能事人，焉能事鬼』『未知生，焉知死』的句式看，孔子首先把注意力引向哪裡？",
      "options": [
        {
          "id": "a",
          "text": "先面對人事，明白生的道理"
        },
        {
          "id": "b",
          "text": "拒絕回答，表示這類問題不可談",
          "why": "回答先指出人事與生的未明之處，沒有宣告鬼神與死亡問題一律禁止討論。"
        },
        {
          "id": "c",
          "text": "否認鬼神與死後世界確實存在",
          "why": "這兩個反問沒有對鬼神或死後世界是否存在作出判定，不能把注意方向當成存在與否的結論。"
        },
        {
          "id": "d",
          "text": "責備子路把問題問得太過淺陋",
          "why": "原文沒有以問題太淺陋作答，而是先指出未能事人、未知生；不能將這個重點換成對問題深淺的評語。"
        }
      ],
      "answerId": "a",
      "explanation": "兩個反問都先提出人與生，再反問鬼與死。這可支持先從人事與生入手的解讀；至於是否同時包含迴避或對知識界限的考量，需要另立論證，不能由這道句義題排除。",
      "review": {
        "version": "editorial-serial27-1ae61bd33af39a18",
        "sha256": "1ae61bd33af39a18efb6cdf81ef9fb1a08489010413a56cdee47a1fc2434d8db",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-12-1",
      "type": "comprehension",
      "refs": [
        323
      ],
      "concepts": [
        "ren",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "理解為仁由己所說的實踐主體與責任",
      "stem": "「為仁由己，而由人乎哉？」補在「克己復禮」之後，用意是？",
      "options": [
        {
          "id": "a",
          "text": "實踐仁德要由自己主動承擔"
        },
        {
          "id": "b",
          "text": "說明行仁不必顧及他人的感受",
          "why": "『由己』說的是由誰主動實踐，沒有取消本章復禮與四勿的要求，不能推出行仁不必顧及他人。"
        },
        {
          "id": "c",
          "text": "說明只要自己覺得對就算是仁",
          "why": "本章已用復禮與視聽言動四勿提出行動要求，不能替換成只要自己覺得對即可。"
        },
        {
          "id": "d",
          "text": "說明仁出於天生，後天學不來",
          "why": "孔子提出克己復禮與視、聽、言、動的具體要求，不是斷言仁德天生固定而無法學習。"
        }
      ],
      "answerId": "a",
      "explanation": "『為仁由己』說明實踐的主體與責任在自己；『克己復禮』及四勿又說明行動並非隨意。主動承擔不等於否定所有外部條件，也不等於只依個人好惡判定仁。",
      "review": {
        "version": "editorial-serial27-a208470688dea776",
        "sha256": "a208470688dea776d00317af879c6c4470d05625ad3f80f4f60bb868f3db11de",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-12-7",
      "type": "comprehension",
      "refs": [
        329
      ],
      "concepts": [
        "xin",
        "zheng"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨明必不得已假設下的取捨次序",
      "stem": "「足食，足兵，民信之矣」，被迫去取時的次序是？",
      "options": [
        {
          "id": "a",
          "text": "先去兵，再去食，信終不可去"
        },
        {
          "id": "b",
          "text": "先去信，再去兵，食最不能去",
          "why": "子貢在必不得已的治理取捨下追問，孔子先去兵、再去食，並保留民信；並非敘述孔子個人選擇挨餓。"
        },
        {
          "id": "c",
          "text": "先去食，再去信，兵最不能去",
          "why": "兵是最先捨的一項。"
        },
        {
          "id": "d",
          "text": "三者同等重要，無法排出次序",
          "why": "孔子明確排了序，這正是本章的分量所在。"
        }
      ],
      "answerId": "a",
      "explanation": "子貢在『必不得已』的條件下兩次追問，孔子先答去兵，再答去食，最後以民無信不立說明信的重要。這是對治理條件的取捨，不是敘述孔子個人選擇挨餓；本頁的信指百姓對政府的信任。",
      "review": {
        "version": "editorial-serial27-928c425a70af048e",
        "sha256": "928c425a70af048e6ae08016df0b1b4a69dae5f468805d6214b3ea9a15db0336",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-12-22",
      "type": "comprehension",
      "refs": [
        344
      ],
      "concepts": [
        "ren",
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "看出「舉直錯諸枉」是在解「知人」",
      "stem": "就樊遲向子夏的轉述看，『舉直錯諸枉，能使枉者直』直接補充回答了哪個問題？",
      "options": [
        {
          "id": "a",
          "text": "補說知人：辨直而舉用正直的人"
        },
        {
          "id": "b",
          "text": "解「愛人」：提拔正直者即是愛人",
          "why": "樊遲轉述時明說自己問知，所以直接承接的是知人；楊注仍指出使枉者直屬仁，不能因此否定仁的關聯。"
        },
        {
          "id": "c",
          "text": "兩者都不解，是另起的政事話題",
          "why": "樊遲向子夏明說自己向老師問知，接著轉述這句回答，直接顯示它承接前問。"
        },
        {
          "id": "d",
          "text": "解仁知合一，兩者本來不可分說",
          "why": "楊注承認這是仁智之事，但本題問直接承接哪一次提問；仁智相連不等於問答次序無法分辨。"
        }
      ],
      "answerId": "a",
      "explanation": "樊遲向子夏明說『鄉也吾見於夫子而問知』，可確定補說直接承接知人的問題。楊注又區分知誰直而舉用與使枉者直，分別指出智與仁的面向，因此答知人並不表示這段與仁無關。",
      "review": {
        "version": "editorial-serial27-6727f2b58cdd22d1",
        "sha256": "6727f2b58cdd22d13bc9c8a85e021f7dd172c25364a51e8770aa197241df3658",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-13-18",
      "type": "comprehension",
      "refs": [
        364
      ],
      "concepts": [
        "xiao",
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "理解本章以孝慈論直的古代倫理主張",
      "stem": "依本章及楊注，孔子說『直在其中』主要據何說明？",
      "options": [
        {
          "id": "a",
          "text": "把父子相互隱護與孝慈親情相連"
        },
        {
          "id": "b",
          "text": "包庇親人的罪行應該，法律不顧",
          "why": "此章討論父子關係中的直，未提出適用所有情境的法律主張；應保留古代互隱之說，再另行討論其界限。"
        },
        {
          "id": "c",
          "text": "兒子應先勸父自首，再議舉發",
          "why": "原文與本頁楊注都未提出先勸自首、再議舉發的程序，不能把這個另加的方案當成本章直接意思。"
        },
        {
          "id": "d",
          "text": "同意只有父子相互告發，才算正直",
          "why": "孔子明說父為子隱、子為父隱，與相互告發才算直的說法相反。"
        }
      ],
      "answerId": "a",
      "explanation": "葉公以告發父親證直，孔子則提出父子相互隱護而直在其中。楊注以孝慈說明其倫理背景。學習時要如實理解這個主張，並將對它的贊成、反對及適用界限留給有根據的開放討論，不能以理解題代替價值評判。",
      "review": {
        "version": "editorial-serial27-eff043d395ff8511",
        "sha256": "eff043d395ff85116048005d5afde95f06b4704648daf5d72a106d80c4c5d58d",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-13-23",
      "type": "comprehension",
      "refs": [
        369
      ],
      "concepts": [
        "zhongyong",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "辨明和的差異調節與同的盲從附和",
      "stem": "依本頁楊譯與注釋，「君子和而不同，小人同而不和」的『和』『同』差在哪裡？",
      "options": [
        {
          "id": "a",
          "text": "和能讓差異相成；同只是盲從附和"
        },
        {
          "id": "b",
          "text": "和是意見一致，同是表面上附和",
          "why": "「和」恰恰不要求意見一致，這是本章最關鍵的一點。"
        },
        {
          "id": "c",
          "text": "和是與人為善，同是與人同流合污",
          "why": "依本頁解釋，同重在盲從附和；同流合污是更特定的情形，不能代替整個概念。"
        },
        {
          "id": "d",
          "text": "和指和氣待人，同指立場完全相同",
          "why": "本章的和不只指表面態度和氣，還包含不同意見可以相互調整；同也不宜只說成立場一致。"
        }
      ],
      "answerId": "a",
      "explanation": "楊注藉不同味道與聲音相互配合說明和：差異仍存在，卻能相互調整而成就整體。同則著重不加辨別的附和。本題應辨明這種關係，而不把同擴成強制消滅差異，或把和縮成表面和氣。",
      "review": {
        "version": "editorial-serial27-e4e28565eeb0417d",
        "sha256": "e4e28565eeb0417da11e57c5b75864aea525e36f667c8b87496cfd45f47a398f",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-14-34",
      "type": "comprehension",
      "refs": [
        410
      ],
      "concepts": [
        "ren",
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "分清「以直報怨」既非報復也非以德報怨",
      "stem": "依本頁譯文，「以直報怨，以德報德」的『以直報怨』是什麼意思？",
      "options": [
        {
          "id": "a",
          "text": "按事情本身的是非公正回應"
        },
        {
          "id": "b",
          "text": "以牙還牙，怨恨要如數報復回去",
          "why": "楊譯以直為公平正直，不能直接等同按私人怨恨報復；是否分清恩怨並不能單獨決定行動是否公正。"
        },
        {
          "id": "c",
          "text": "坦白告訴對方自己心中的不滿",
          "why": "「直」在此指處置的公正，不是直言。"
        },
        {
          "id": "d",
          "text": "同意以德報怨，只是換個說法而已",
          "why": "孔子先反問『何以報德』，再分別提出以直報怨、以德報德，並不是把前者當作以德報怨的同義說法。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子以『何以報德』反問，再提出以直報怨、以德報德。本頁把直解作公平正直，重點在回應怨的準則，不能只換成私人報復；對有恩者則以恩德相報。",
      "review": {
        "version": "editorial-serial27-32d18a2e587b5fc1",
        "sha256": "32d18a2e587b5fc18292c613a901e2ec580fbc5b0b6b5c31cc01758dc8d48fed",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-15-24",
      "type": "comprehension",
      "refs": [
        444
      ],
      "concepts": [
        "shu",
        "ren"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨識勿施於人的施與所施對象",
      "stem": "依15.24本頁譯文，「己所不欲，勿施於人」的施在此怎樣理解？",
      "options": [
        {
          "id": "a",
          "text": "把前述自己不想要的事物加給別人",
          "why": "本頁譯為不要把自己不想要的事物加給別人，所施承接己所不欲。"
        },
        {
          "id": "b",
          "text": "只指向別人施捨金錢或物品作為恩惠",
          "why": "本句承接己所不欲，不限於施捨金錢物品，更不是禁止一切給予恩惠。"
        },
        {
          "id": "c",
          "text": "只指向別人講述自己內心的想法",
          "why": "本頁是將不願承受的事物加人，不能縮成單純說出想法。"
        },
        {
          "id": "d",
          "text": "把別人的所有喜好強加到自己身上",
          "why": "這把施者與承受對象倒置：原句由己所不欲出發，限制把它加給人。"
        }
      ],
      "answerId": "a",
      "explanation": "己所不欲是這裡所施的內容，於人指出加給別人的方向。依本頁譯文讀清動作與對象，便不會把它誤限成施捨恩惠、表達想法，或倒轉成別人施加給自己。與己欲立而立人的比較是另一項閱讀任務。",
      "review": {
        "version": "editorial-serial27-039ac0537e8356cb",
        "sha256": "039ac0537e8356cbfce5dac9980b2af36bab235fba0e3281087fbfc2fa274bb7",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-15-29",
      "type": "comprehension",
      "refs": [
        449
      ],
      "concepts": [
        "ren",
        "xue"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "分辨字面翻譯、原意存疑與後人的思想發揮",
      "stem": "依本頁楊注，解釋『人能弘道，非道弘人』應持何種分寸？",
      "options": [
        {
          "id": "a",
          "text": "可作字面理解，確切原意仍須存疑",
          "why": "楊注保留字面翻譯，卻明言真意難體會，且對其他解說也保留疑問。"
        },
        {
          "id": "b",
          "text": "已確定唯一原意是人的能力比道更根本",
          "why": "楊注沒有確認這種哲學命題為唯一原意。"
        },
        {
          "id": "c",
          "text": "已確定只要學道，人生就一定成功",
          "why": "本章與楊注都沒有這種人生結果保證。"
        },
        {
          "id": "d",
          "text": "已確定道無所不在，所以人完全不必求道",
          "why": "此結論不是本頁的字面翻譯，也不是楊注接受的確定解說。"
        }
      ],
      "answerId": "a",
      "explanation": "楊伯峻在這章只提供字面翻譯，明說確切意思不易體會，尤其非道弘人更難解釋；所列前人說法也未被確認為定論。閱讀時可以提出自己的理解並論證，但應清楚標示與來源的確定程度，不能把存疑處包裝成唯一答案。",
      "review": {
        "version": "editorial-serial27-ea8afb451e9e5f03",
        "sha256": "ea8afb451e9e5f03d10782d1d5e415e4f623fccaa44d5e0d4d6ca1ced8d1e64a",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-15-31",
      "type": "comprehension",
      "refs": [
        451,
        31
      ],
      "concepts": [
        "xue"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "將個人學思經驗與2.15的主張對讀，不當作實驗驗證",
      "stem": "「終日不食，終夜不寢，以思，無益，不如學也」與 2.15 的關係是？",
      "options": [
        {
          "id": "a",
          "text": "以自身經驗說明，學習不能被空想取代"
        },
        {
          "id": "b",
          "text": "推翻了 2.15，改主張只要學不必思",
          "why": "「無益」針對的是脫離學的空思，並未取消思。"
        },
        {
          "id": "c",
          "text": "說明身體要緊，不可以廢寢忘食",
          "why": "廢寢忘食只是敘述背景，結論落在思與學。"
        },
        {
          "id": "d",
          "text": "自述年輕時走過彎路，後來才知學",
          "why": "原文只說吾嘗，沒有交代此事發生的年齡，不能自行補成青年階段。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子以自己長時間只思而無益的經驗說不如學。與2.15學而不思、思而不學對照，可看出不能偏廢學與思；不能把這段個人敘述擴成所有思考都無用，也不能代補未交代的人生階段。",
      "review": {
        "version": "editorial-serial27-a586f31fe72f83b1",
        "sha256": "a586f31fe72f83b18fd4b9263e94cf944a9685a3def43afdc2e6e02d35d323ad",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-16-9",
      "type": "comprehension",
      "refs": [
        471
      ],
      "concepts": [
        "xue",
        "jiaoxue"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨明同樣遇困後有無學習的差別",
      "stem": "就『困而學之』與『困而不學』兩類相比，原文明說的差別是什麼？",
      "options": [
        {
          "id": "a",
          "text": "是否在遇到困難後去學習",
          "why": "兩類都先有困，原文直接以學與不學區分。"
        },
        {
          "id": "b",
          "text": "是否天生比別人更聰明",
          "why": "題目只比較困而學與困而不學，原文沒有以這兩類的天生聰明程度作直接區別。"
        },
        {
          "id": "c",
          "text": "是否曾經學過其他知識",
          "why": "本章沒有交代後兩類此前是否學過其他知識，直接差別是此次遇困後學或不學。"
        },
        {
          "id": "d",
          "text": "是否已靠自己解決所有困難",
          "why": "原文說的是遇困後有無學習，沒有以已經解決所有困難作區分。"
        }
      ],
      "answerId": "a",
      "explanation": "本題只比較後兩類：同樣遇困，是否學習是明說的差別。全章仍將生知、學知、困學、困不學列成四等，不能因強調後兩類，就把其他高下改寫為原文沒有的純粹起點差異。",
      "review": {
        "version": "editorial-serial27-35c4ce291c3909fb",
        "sha256": "35c4ce291c3909fb24f36128ff760699c772a933ebc9089728d3806c15de8548",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-17-2",
      "type": "comprehension",
      "refs": [
        478,
        459
      ],
      "concepts": [
        "xue",
        "jiaoxue"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "由習染作用討論重視教育的思想聯繫",
      "stem": "把17.2與15.39『有教無類』對讀，下列哪項聯繫有文本依據而不過度推論？",
      "options": [
        {
          "id": "a",
          "text": "後天習染影響差異，可支持重視教育"
        },
        {
          "id": "b",
          "text": "只要施教，就必定消除所有人的差距",
          "why": "兩章沒有保證教育能消除所有差異；習染有作用不等於任何教育都有同一效果。"
        },
        {
          "id": "c",
          "text": "天性差異已能解釋後來的一切差距",
          "why": "『習相遠』明說習染會使差異擴大，不能把後來所有差距都只歸給天性。"
        },
        {
          "id": "d",
          "text": "古人的天性都勝過今人，所以只讀古書即可",
          "why": "兩章都沒有判定古今人的天性高下，也没有推出只讀古書即可的主張。"
        }
      ],
      "answerId": "a",
      "explanation": "此章指出性情相近而後天習染使差異擴大，可與有教無類等重視教育的主張對讀。相近不等於完全相同，習也不只限於學校教育；這是一種思想上的聯繫，不能寫成形式上必然推出的結論。",
      "review": {
        "version": "editorial-serial27-45fb5461440ab58f",
        "sha256": "45fb5461440ab58f84e8b31bea8ce1bfabbdaa1bd22c4b1a0d7437c456477399",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-17-9",
      "type": "comprehension",
      "refs": [
        485
      ],
      "concepts": [
        "shijiao"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "理解怨在指定譯文中的學詩作用",
      "stem": "依本頁楊譯，『詩可以興，可以觀，可以群，可以怨』中的怨主要說明什麼作用？",
      "options": [
        {
          "id": "a",
          "text": "學得諷刺的方法，能表達不平"
        },
        {
          "id": "b",
          "text": "學詩只為發洩不滿，不必理會興觀群",
          "why": "怨只是本句並列的四種作用之一，不能把它擴成學詩的唯一目的。"
        },
        {
          "id": "c",
          "text": "怨恨命運不公，感嘆生不逢時",
          "why": "某種怨命題材不能代替本句學得諷刺方法的功能解釋；不能由此推成對所有詩歌題材的准許或禁止。"
        },
        {
          "id": "d",
          "text": "指《詩》中充滿哀怨的那類作品",
          "why": "四項說的是讀詩的功能，不是題材分類。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁楊譯以學得諷刺的方法解釋可以怨。它與興、觀、群共同說明學詩的作用，不是規定詩只能表達公事或只能發洩私情，也不是對所有詩歌題材作一律禁止。",
      "review": {
        "version": "editorial-serial27-200e99abeaa1f4d7",
        "sha256": "200e99abeaa1f4d72cb2ad81d41d5235fb5a7eb03b8cadca4fe0c087e8abad7a",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-19-6",
      "type": "comprehension",
      "refs": [
        519
      ],
      "concepts": [
        "xue",
        "ren"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "辨明近思所指向的當前問題",
      "stem": "依本頁楊譯，「切問而近思」的『近思』指怎樣思考？",
      "options": [
        {
          "id": "a",
          "text": "從當前切近的問題著手思考"
        },
        {
          "id": "b",
          "text": "思考得淺近簡單，不必深入細究",
          "why": "本頁說多考慮當前的問題，指思考所關注的問題，並非要求內容淺易或停止深入。"
        },
        {
          "id": "c",
          "text": "順著老師的思路去想，不另立說",
          "why": "本頁以考慮當前問題說明近思，沒有要求沿用老師思路，也沒有說不許另立見解。"
        },
        {
          "id": "d",
          "text": "最近才開始思考的那些新問題",
          "why": "楊譯說多考慮當前的問題，並不是交代從某個較近的日期才開始思考。"
        }
      ],
      "answerId": "a",
      "explanation": "楊譯近思為多考慮當前問題，與博學、篤志、切問相連。這是在說思考的著力處，不等於問題只能淺顯，也不等於禁止高遠志向；仁在其中亦不能被擴張成其他一切實踐都無須考慮。",
      "review": {
        "version": "editorial-serial27-ca01db37c524659e",
        "sha256": "ca01db37c524659ec43af83b380f5184f4ba38933c2757154adf2953636986ff",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cm-20-3",
      "type": "comprehension",
      "refs": [
        541
      ],
      "concepts": [
        "tianming",
        "li",
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "辨明三項知與三個目標的對應",
      "stem": "依本頁楊譯，知命、知禮、知言分別與哪三個目標相連？",
      "options": [
        {
          "id": "a",
          "text": "成為君子、立足處世、辨識人物"
        },
        {
          "id": "b",
          "text": "通曉歷史、建立制度、說服聽眾",
          "why": "這三項不是原文三個無以後所列的目標：為君子、立、知人。"
        },
        {
          "id": "c",
          "text": "預知吉凶、熟記儀節、辯論取勝",
          "why": "本頁三項目標是成為君子、立足社會、認識人；知言重在分辨言語，也不等於辯論取勝。"
        },
        {
          "id": "d",
          "text": "改變命運、依附權勢、揣測人心",
          "why": "原文沒有將改變命運或依附權勢列為目標；本頁的知人以分辨言語為條件，也不能縮成揣測人心。"
        }
      ],
      "answerId": "a",
      "explanation": "三句分別把知命連到為君子，把知禮連到立，把知言連到知人。本頁知言重在理解分析他人的話，以辨是非善惡；這是三項条件的對應，不是算命、制度創設或辯論課程的次序。",
      "review": {
        "version": "editorial-serial27-0eba1c5ed3fafab3",
        "sha256": "0eba1c5ed3fafab35ca2b73801d33ab3be807f55e028cc263c530bb4a42fb3a6",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-3-1",
      "type": "interpretation",
      "refs": [
        41,
        42
      ],
      "concepts": [
        "li",
        "zhengming"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較開篇兩個僭禮實例及其排列的可見效果",
      "stem": "《八佾》開篇連列季氏用八佾、三家以雍徹兩例。依兩章內容看，這樣的排列有何可見效果？",
      "options": [
        {
          "id": "a",
          "text": "先集中呈現僭禮實例，引出對禮的思考"
        },
        {
          "id": "b",
          "text": "稱讚魯國的樂舞演出水準很高",
          "why": "兩章都對使用者與應有禮制的差距提出批評，並未稱讚演出水準。"
        },
        {
          "id": "c",
          "text": "只介紹樂舞規格，沒有對使用者作判斷",
          "why": "『是可忍也』『奚取於三家之堂』都在評判具體用禮行為，不能縮成不作判斷的規格介紹。"
        },
        {
          "id": "d",
          "text": "表明孔子與季氏的私人恩怨",
          "why": "兩章可見的批評依據是使用者與禮制名分不合，沒有把它們歸因於孔子的私人恩怨。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章都把具體行為與應有名分對照：季氏使用天子的八佾，三家使用天子主祭的樂歌。因此可將這組排列讀成集中呈現僭禮問題；這是有章文依據的閱讀分析，並不等於已證實編者的確切心理與編纂經過。",
      "review": {
        "version": "editorial-serial27-5359ebba097f78d1",
        "sha256": "5359ebba097f78d1e03dc56e4bba72a56be6a6fd6258cc323f7d4cb9a4146af8",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-5-9",
      "type": "interpretation",
      "refs": [
        101
      ],
      "concepts": [
        "zhiren",
        "xue"
      ],
      "figures": [
        "zigong",
        "yanhui"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "依指定與字讀法，理解教師如何承接學生自評",
      "stem": "依本頁楊注，孔子說『弗如也；吾與女弗如也』，如何承接子貢對自己與顏回的比較？",
      "options": [
        {
          "id": "a",
          "text": "贊同子貢所說自己不及顏回的評估"
        },
        {
          "id": "b",
          "text": "把自己與子貢一起列為不及顏回的人",
          "why": "楊注明說此處與是同意、贊同的動詞，不作把吾與女並列的連詞；本題依這一讀法。"
        },
        {
          "id": "c",
          "text": "測試子貢是否會謙虛地說假話",
          "why": "本章沒有說子貢故意說假話；不能把孔子的贊同改成測試假謙虛。"
        },
        {
          "id": "d",
          "text": "說明顏回的天資無人可及，不必再學",
          "why": "本章比較聞一知十與聞一知二，沒有斷言顏回的天資永遠無人可及，也沒有說別人因此不必再學。"
        }
      ],
      "answerId": "a",
      "explanation": "楊注把與解作同意，孔子是在贊同子貢不及顏回的自評，並非把自己也列入不如者。是否另有考察自知或鼓勵誠實的用意，可以討論，但原文並未明說這種心理動機，更不能以不合本頁讀法的翻譯作證。",
      "review": {
        "version": "editorial-serial27-8dd514a722778d63",
        "sha256": "8dd514a722778d63822f0bdac4de8418328b727361664bebbee9049535d3a730",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-6-28",
      "type": "interpretation",
      "refs": [
        148
      ],
      "concepts": [
        "tianming",
        "chushi"
      ],
      "figures": [
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "誓辭出現的場合",
      "stem": "子見南子、子路不說後，孔子用『予所否者，天厭之』作誓。這段誓辭如何回應當時情境？",
      "options": [
        {
          "id": "a",
          "text": "回應子路不悅，以自身行止是否正當為誓"
        },
        {
          "id": "b",
          "text": "他要證明南子是個好人",
          "why": "誓辭針對的是自己的行止，不是替南子辯護。"
        },
        {
          "id": "c",
          "text": "他習慣以發誓加強語氣",
          "why": "本章給出特定相見與不悅的情境，並不能證明孔子平日習慣藉發誓加重語氣。"
        },
        {
          "id": "d",
          "text": "他在向天祈求原諒",
          "why": "所在本頁解作假若；誓辭是假定自己不對便願受天厭，不能改成已承認犯錯而請求原諒。"
        }
      ],
      "answerId": "a",
      "explanation": "章文把發誓接在子路不高興之後，誓辭又以予所否者指向孔子自身行止。這支持將其理解為對疑慮的回應；但原文没有說他無話可辯或只剩賭咒一法，也沒有給出可將此事稱為全書唯一的獨立統計證據。",
      "review": {
        "version": "editorial-serial27-ee3b351962b61b6d",
        "sha256": "ee3b351962b61b6dcc1187c4068cf050530368ec178d6ff88d59e32149429227",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-7-11",
      "type": "interpretation",
      "refs": [
        161
      ],
      "concepts": [
        "chushi",
        "junzi"
      ],
      "figures": [
        "yanhui",
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "理解帶兵問話與前段稱許的關聯",
      "stem": "依本頁楊注，子路在孔子稱許顏淵後轉問『子行三軍，則誰與』，如何理解這個插話？",
      "options": [
        {
          "id": "a",
          "text": "由自己好勇轉問帶兵共事，尋求肯定"
        },
        {
          "id": "b",
          "text": "只因軍事專業興趣順口發問，與前段稱許無關",
          "why": "楊注特別指出子路好勇，因見孔子夸獎顏淵而發問，將此問與前一段對話聯繫；不能只說毫無前後關係的順口詢問。"
        },
        {
          "id": "c",
          "text": "子路認為顏淵不適合帶兵，出言提醒",
          "why": "原文沒有說子路認為顏淵不宜帶兵；楊注把此問連到子路好勇與先前稱許，不能另補提醒顏淵不適任的動機。"
        },
        {
          "id": "d",
          "text": "孔子刻意冷落子路，引他發問",
          "why": "本章沒有交代孔子事先安排冷落；後答重視謹慎與謀略，不能反推這是預設的引問手段。"
        }
      ],
      "answerId": "a",
      "explanation": "楊注把子路的好勇、孔子對顏淵的稱許與帶兵之問相連，可據此理解子路尋求肯定。孔子的回答則把可共事的判準轉向謹慎與謀略。好勇不等於軍事能力必然出眾，這段也沒有證明孔子事先安排冷落子路。",
      "review": {
        "version": "editorial-serial27-67c4705b08880dde",
        "sha256": "67c4705b08880dde169a54660375f1095fa57496ee55012b138babb3af889670",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-9-5",
      "type": "interpretation",
      "refs": [
        214
      ],
      "concepts": [
        "tianming",
        "chushi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "危難中的自我定位",
      "stem": "讀完整章『文不在茲乎』至『天之未喪斯文也，匡人其如予何』，孔子把自己的安危與何事聯繫？",
      "options": [
        {
          "id": "a",
          "text": "自任文化傳承，並以天未喪斯文為依據"
        },
        {
          "id": "b",
          "text": "認為自己武力過人，必能制服匡人",
          "why": "章文的理由是斯文與天意，並未訴諸武力。"
        },
        {
          "id": "c",
          "text": "認為只要證明自己官位高，便不會被拘",
          "why": "本章没有以官位高低作脫困依據，也未記這段話是向誰交涉。"
        },
        {
          "id": "d",
          "text": "認為自己應完全退出文王的文化傳承",
          "why": "文不在茲乎及不得與於斯文正顯示自任其傳，並非退出。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子先將自己與文王以後的文化傳承相連，再以天是否喪斯文形成條件推論，最後反問匡人能如何對待自己。文化使命與安危信心在此相連，不應為突出前者而刪掉後者；至於說話對象與實際脫困交涉，本章並未交代。",
      "review": {
        "version": "editorial-serial27-90b1c714e5238cdb",
        "sha256": "90b1c714e5238cdbf25db15838de525c2b57ce3258dc0fa3250773fe28334027",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-11-9",
      "type": "interpretation",
      "refs": [
        280,
        279
      ],
      "concepts": [
        "tianming",
        "ren"
      ],
      "figures": [
        "yanhui"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "理解反問如何表達對顏淵的哀傷",
      "stem": "顏淵死，孔子哭之慟。從者說「子慟矣」，孔子答「有慟乎？非夫人之為慟而誰為！」這句話的意思是？",
      "options": [
        {
          "id": "a",
          "text": "顏淵正是值得自己如此悲傷的人"
        },
        {
          "id": "b",
          "text": "他說自己沒有為顏淵感到悲傷",
          "why": "後一句說不為這樣的人悲傷又為誰悲傷，明示他為顏淵而慟，並非否認有悲傷。"
        },
        {
          "id": "c",
          "text": "他責備從者多管閒事",
          "why": "回答的重心是為什麼為顏淵而慟，不能把它縮成責怪從者多管閒事。"
        },
        {
          "id": "d",
          "text": "他認為哭泣不合禮，需要收斂",
          "why": "孔子隨即說明為何為顏淵而慟，本章沒有接著要求自己收斂，也未明言正在破例違禮。"
        }
      ],
      "answerId": "a",
      "explanation": "題引內容在11.10。從者提醒孔子太傷心，他以『不為這樣的人慟，又為誰慟』回應，突出顏淵在他心中的分量。楊注採哀過說解慟，卻不能因此代補孔子自知失態、決定破禮的完整心理過程。",
      "review": {
        "version": "editorial-serial27-9fb503d4c9c08baa",
        "sha256": "9fb503d4c9c08baaa962162f06be1ef2a6f61b912e346039099a268b05a316c4",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-13-3",
      "type": "interpretation",
      "refs": [
        349
      ],
      "concepts": [
        "zhengming"
      ],
      "figures": [
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "子路的質疑使論證展開",
      "stem": "子路說「有是哉，子之迂也！奚其正？」孔子隨即斥「野哉由也」並展開整條推論。這段對話的作用是？",
      "options": [
        {
          "id": "a",
          "text": "由質疑轉入正名與政事秩序的連鎖論證"
        },
        {
          "id": "b",
          "text": "顯示子路不尊重老師，應受批評",
          "why": "野哉確是責語，但其後還有完整的理由展開；只說學生應受批評，不能概括這段對話的作用。"
        },
        {
          "id": "c",
          "text": "顯示孔子脾氣不好",
          "why": "這段有責語也有論證，不能憑一次對話判定孔子的整體性格。"
        },
        {
          "id": "d",
          "text": "說明正名之說確實迂闊",
          "why": "孔子以名分與政事後果回應子路，並未直接接受迂闊的評語；讀者仍可另外分析這條論證是否充分。"
        }
      ],
      "answerId": "a",
      "explanation": "子路提出正名何用的質疑後，孔子先批評其鹵莽，再把名不正逐步連到言、事、禮樂、刑罰與百姓處境。楊注提醒這裡的名涉及禮制與名分，不是一般措辭錯誤。辨認論證如何展開，與評判論證是否成立，是不同任務。",
      "review": {
        "version": "editorial-serial27-82692b20232c6619",
        "sha256": "82692b20232c661936e4938a5e922544df5014469ba94d86bcdc5b4f96641ab6",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-15-2",
      "type": "interpretation",
      "refs": [
        422
      ],
      "concepts": [
        "junzi",
        "chushi"
      ],
      "figures": [
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "「君子固窮」的處境",
      "stem": "在陳絕糧，從者病，子路慍見曰「君子亦有窮乎？」孔子答「君子固窮，小人窮斯濫矣」。這句答話的重點是？",
      "options": [
        {
          "id": "a",
          "text": "君子也會受困，差別在困中能否守住操行"
        },
        {
          "id": "b",
          "text": "君子本來就應該貧窮，安於清苦",
          "why": "本頁楊譯為君子雖窮仍堅持，並未把貧困本身設為應追求的目標。"
        },
        {
          "id": "c",
          "text": "他責備子路不該抱怨",
          "why": "答語以君子與小人受困後的行為作對照，核心超出單純要求子路停止抱怨；不能因此否認其中可能有告誡。"
        },
        {
          "id": "d",
          "text": "他保證困境很快會過去",
          "why": "全章沒有這樣的安慰。"
        }
      ],
      "answerId": "a",
      "explanation": "在斷糧困境中，子路問君子是否也會窮。孔子答話不承諾道德保證免於困境，而區分困時仍堅持與無所不為。這是文本明說的對照；原文沒有直接把子路的問題改寫成講道德毫無用處的完整信念。",
      "review": {
        "version": "editorial-serial27-cca7d8e646b3dbea",
        "sha256": "cca7d8e646b3dbea2eeccffdaa09b8f9eaa5b8d9939a558ac86299276c9b6f83",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-17-1",
      "type": "interpretation",
      "refs": [
        477
      ],
      "concepts": [
        "li",
        "chushi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "連繫避見與回拜，理解禮俗中的周旋",
      "stem": "陽貨送豚給孔子，孔子「時其亡也，而往拜之」，卻在路上遇見了他。孔子這一連串舉動說明？",
      "options": [
        {
          "id": "a",
          "text": "避開直接相見，同時履行受贈後的回拜禮"
        },
        {
          "id": "b",
          "text": "他其實很想見陽貨，只是不好意思",
          "why": "特意挑對方不在家時回拜，正是為了不見。"
        },
        {
          "id": "c",
          "text": "他忘記了陽貨在家的時間",
          "why": "「時其亡也」是刻意挑選，不是疏忽。"
        },
        {
          "id": "d",
          "text": "他完全不理會陽貨，拒絕往來",
          "why": "他確實去回拜了，禮數並未廢。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子先避免直接相見，又按當時饋贈禮俗選對方不在家時回拜。這顯示他試圖同時處理往來禮數與相見意願；但事情並未照計畫結束，原文明說兩人路上相遇，後面也確有對話。楊注又指出孔子並未出仕陽虎，不能將吾將仕矣直接當作依附承諾。",
      "review": {
        "version": "editorial-serial27-0c5c558017f1e644",
        "sha256": "0c5c558017f1e6449396516364ae210fd22a0dfb9977f7dd6aa19f0cc2224e70",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-18-6",
      "type": "interpretation",
      "refs": [
        508
      ],
      "concepts": [
        "chushi",
        "ren"
      ],
      "figures": [
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "孔子對隱者的正面回應",
      "stem": "長沮桀溺勸子路「與其從辟人之士，豈若從辟世之士哉」。孔子聽後憮然曰「鳥獸不可與同群……天下有道，丘不與易也」。他的立場是？",
      "options": [
        {
          "id": "a",
          "text": "正因天下無道，才需要有人去改變"
        },
        {
          "id": "b",
          "text": "他鄙視隱者，認為他們懦弱",
          "why": "楊注以悵惘失意解憮然；這個詞本身不能證明孔子鄙視隱者或稱其懦弱。"
        },
        {
          "id": "c",
          "text": "他承認隱者說得對，只是自己放不下",
          "why": "孔子以不能離開人群及天下未有道說明自己的行動方向，並非只承認隱者全對而表示放不下。"
        },
        {
          "id": "d",
          "text": "他認為隱居才是更高的境界",
          "why": "與「鳥獸不可與同群」相反。"
        }
      ],
      "answerId": "a",
      "explanation": "隱者以天下皆亂質疑改變的可能，孔子則說不能離開人群，並以天下有道就不必從事改變作回應。兩者的分歧可作有據比較；原文沒有判定隱者的推理無懈可擊，也不能把孔子的回答寫成完全沒有回應對方。本題依完整原文與孔子答語判斷；本頁桀溺譯文有缺段，不能把缺漏補成任何一方的觀點。",
      "review": {
        "version": "editorial-serial27-8756f18159259aaf",
        "sha256": "8756f18159259aaf8ce40e515ab514b494fe415cc8a02d864fbd4899e2553791",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-11-26",
      "type": "interpretation",
      "refs": [
        296
      ],
      "concepts": [
        "chushi",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "依指定譯文分析未被用與若被知的對話銜接",
      "stem": "依本頁楊譯的開場，孔子先說自己因年長而未被任用，再問『如或知爾，則何以哉』。前後如何銜接？",
      "options": [
        {
          "id": "a",
          "text": "由自己未被任用，引出學生若受賞識將如何行事"
        },
        {
          "id": "b",
          "text": "以年長身分要求學生不得表達不同志向",
          "why": "本頁譯文沒有這項禁止，後文何傷乎、亦各言其志也更明說可以各談志向。"
        },
        {
          "id": "c",
          "text": "說明自己時間不多，要學生長話短說",
          "why": "本頁譯文談年齡與是否被任用，未說談話時間緊迫。"
        },
        {
          "id": "d",
          "text": "為接下來的批評先作鋪墊",
          "why": "後文確有對子路不讓的評論，但不能據此把開場確定為預先安排批評。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁楊譯把開場解為孔子因年長而不被任用，接著轉向學生平日自嘆不被了解，再問若有人了解並任用他們將如何行事。這與常見的解除年長壓力讀法不同，不能混作同一譯解。後文允許曾點各言其志是可見的鼓勵，但不足以證明他敢說話全由開場一句造成。",
      "review": {
        "version": "editorial-serial27-6dd2c2b9fd72b918",
        "sha256": "6dd2c2b9fd72b918ca492bcee1095d9e1ae04598bd90f32f965ebd35410b19ef",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-2-21",
      "type": "interpretation",
      "refs": [
        37
      ],
      "concepts": [
        "zheng",
        "xiao"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "回應「子奚不為政」的方式",
      "stem": "有人問孔子「子奚不為政？」他引《書》「孝乎惟孝，友于兄弟，施於有政」作答。這個回答的策略是？",
      "options": [
        {
          "id": "a",
          "text": "孝友風氣延及政治，也是參與為政的一途"
        },
        {
          "id": "b",
          "text": "承認自己沒有從政的能力",
          "why": "他的回答是重新界定為政，不是自認不能。"
        },
        {
          "id": "c",
          "text": "批評當時的政治太黑暗",
          "why": "章中未涉時政批評。"
        },
        {
          "id": "d",
          "text": "表示自己志在治學，無意仕途",
          "why": "這個回答否定只有做官才算參政，並未表示自己決意拒絕所有仕途。"
        }
      ],
      "answerId": "a",
      "explanation": "問者把為政與做官相連，孔子引孝友風氣延及政治，說這也是為政，因而擴大問題中所設的途徑。本章没有交代被問到痛處的心理，也不能將延及政治的環節省去，變成任何家庭行為都等於全部政治。",
      "review": {
        "version": "editorial-serial27-8f69859ebfd61e1b",
        "sha256": "8f69859ebfd61e1b5335053d0b0fabcc18c452fbd28a51200e4d41b292b51ce3",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-14-21",
      "type": "interpretation",
      "refs": [
        397
      ],
      "concepts": [
        "li",
        "zheng",
        "chushi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "結合行動與自述，理解不敢不告的責任",
      "stem": "孔子告老後，為陳恒弒君而沐浴入朝請討，並說『以吾從大夫之後，不敢不告也』。這組行動如何表達其責任？",
      "options": [
        {
          "id": "a",
          "text": "鄭重處理臣弒君之事，履行曾任大夫的報告責任"
        },
        {
          "id": "b",
          "text": "因沐浴這一儀節，便取得直接調兵的權力",
          "why": "章中孔子向哀公與三子請討，並非因沐浴就取得自行調兵權；也不能以儀節被記載與否推定一切朝見常規。"
        },
        {
          "id": "c",
          "text": "已退休便不必理會此事，只是偶然路過朝廷",
          "why": "楊注說特為此事來朝，兩次不敢不告又明示其自認責任，與偶然路過不合。"
        },
        {
          "id": "d",
          "text": "他要參加祭祀活動",
          "why": "他是為請討而朝，非為祭祀。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子雖已告老，仍為臣弒君之事鄭重入朝請討。哀公讓他向三子報告，其後三子不允；孔子兩次說不敢不告，說明自己仍認為有報告之責。這是結合章文的責任解讀，不等於證明所有朝見是否都須沐浴的普遍禮制。",
      "review": {
        "version": "editorial-serial27-3ddf4c9cdc5c8af4",
        "sha256": "3ddf4c9cdc5c8af4f8e2b3d0984762653331ee4b3a9aca0838485a21e8bc5c0b",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-6-4",
      "type": "interpretation",
      "refs": [
        124,
        125
      ],
      "concepts": [
        "yili",
        "ren"
      ],
      "figures": [
        "ranyou"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "對讀贈粟與任職所得，辨明不同的用財情境",
      "stem": "對讀6.4子華母親受粟與6.5原思辭粟，哪項能兼顧兩章的不同處境？",
      "options": [
        {
          "id": "a",
          "text": "救助要周急；任職所得可收，也可分助鄰里"
        },
        {
          "id": "b",
          "text": "說明孔子對弟子偏心，賞罰不均",
          "why": "兩章一談救助贈粟，一談任職所得及分助鄰里，有不同的處理依據，不能只歸因於對弟子的親疏偏心。"
        },
        {
          "id": "c",
          "text": "只因吝惜財物，所以一律不願給出",
          "why": "6.5孔子要原思收下所得，並可分給鄰里，與一律不願給出財物不合。"
        },
        {
          "id": "d",
          "text": "只記錄俸粟數量，並不談財物如何使用",
          "why": "周急不繼富與分給鄰里都直接談財物的使用，不能說只是記錄數量。"
        }
      ],
      "answerId": "a",
      "explanation": "6.4以子華的肥馬輕裘為背景，明言周急不繼富，因而限制為其母追加的贈粟；6.5則是原思任宰所得，不必推辭，多餘可助鄰里。兩章都可討論財物如何正當使用，但不能把俸祿是否應得全縮成受助者急不急，也不能據相鄰排列就確證編者心理。",
      "review": {
        "version": "editorial-serial27-d6f3da598b151131",
        "sha256": "d6f3da598b1511316ee64069dcc900b743403c877aba46eb3c1c0be971f8a669",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-19-25",
      "type": "interpretation",
      "refs": [
        538,
        535,
        536,
        537
      ],
      "concepts": [
        "zhiren",
        "li"
      ],
      "figures": [
        "zigong"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "《子張》篇末四章的共同主題",
      "stem": "《子張》末四章由子貢回應孔子學問從何而來，以及孔子與他人賢能的比較。對讀這四章，可見怎樣的共同內容？",
      "options": [
        {
          "id": "a",
          "text": "由弟子的回答申說孔子所學與師道地位"
        },
        {
          "id": "b",
          "text": "子貢與同門爭奪學派領導權",
          "why": "這四章記錄子貢如何答問與比喻，沒有呈現爭奪學派領導權的行動。"
        },
        {
          "id": "c",
          "text": "當時人普遍認為子貢勝過孔子",
          "why": "章中只有若干具名人物的問話與評語，不能據此概括當時人普遍看法。"
        },
        {
          "id": "d",
          "text": "這幾章是後人偽託",
          "why": "要判斷篇章真偽，需要文本傳承等證據；這組對話本身不能單獨證偽，風格相合也不能单獨證真。"
        }
      ],
      "answerId": "a",
      "explanation": "19.22談孔子無常師而廣學文武之道，後三章則用宮牆、日月與天不可階等譬喻回應賢能比較。四章共同呈現子貢對師學與師道的申說。這是篇末組章可見的共同內容，不能擴為全書最後一句，也不能把所有問話都先定性為貶抑。",
      "review": {
        "version": "editorial-serial27-61249499015d946e",
        "sha256": "61249499015d946ecef1bfbe110884c2fed5e0e357e4e6bd9ef6d972363a73fd",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-9-12",
      "type": "interpretation",
      "refs": [
        221
      ],
      "concepts": [
        "li",
        "xin"
      ],
      "figures": [
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "「無臣而為有臣」的責備",
      "stem": "孔子病重，子路『使門人為臣』。孔子病稍好後責備『無臣而為有臣，吾誰欺？欺天乎』。依本頁譯注，責備的重點是？",
      "options": [
        {
          "id": "a",
          "text": "把本不應有的臣屬安排成有臣，造成名實不符"
        },
        {
          "id": "b",
          "text": "子路擅自作主，沒有請示他",
          "why": "責備的落點是「行詐」與名實不副，不是程序。"
        },
        {
          "id": "c",
          "text": "子路為此花費了太多錢財",
          "why": "章中並未提到費用多寡，責備的也不是開銷。"
        },
        {
          "id": "d",
          "text": "子路預備喪事等於咒他死",
          "why": "孔子的責語指向無臣而為有臣之詐，沒有把準備喪事說成詛咒他死亡；也不能代造子路全部心理。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子責備把本來沒有、也不當有的臣安排成有臣，形成不合身分的名實假象。楊注以治喪組織幫助現代讀者理解，但同時指出古今制度有別。可以討論子路的關切，卻不能說其動機已被完全證實，更不能無比較證據就稱這是全書最重的責備。",
      "review": {
        "version": "editorial-serial27-5b96fd2229504cb6",
        "sha256": "5b96fd2229504cb61f77fcfe0c6cbba68f33fa83bf14d2bb17156e7f0b0ceff6",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "in-5-26",
      "type": "interpretation",
      "refs": [
        118
      ],
      "concepts": [
        "ren",
        "junzi"
      ],
      "figures": [
        "zilu",
        "yanhui"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較三種志向的不同著力處",
      "stem": "依本頁楊譯，比較子路、顏淵與孔子的志向，哪項概括較準確？",
      "options": [
        {
          "id": "a",
          "text": "共享財物、不自誇功善、使老者安而友信少懷"
        },
        {
          "id": "b",
          "text": "三人志向相同，只是說法不同",
          "why": "三人分別著重共享、避免自誇與對不同人物關係的期許，並非只是同一志向換幾種說法。"
        },
        {
          "id": "c",
          "text": "子路只願保護私物，不與朋友共用",
          "why": "子路明說願與朋友共用，敝之而無憾，與保護私物不共享相反。"
        },
        {
          "id": "d",
          "text": "孔子只談自己的衣食，未談人際關係",
          "why": "老者、朋友、少者明確涉及不同人際關係，並非只談個人衣食。"
        }
      ],
      "answerId": "a",
      "explanation": "子路願共享財物而無憾，顏淵願不誇耀好處與功勞，孔子則談與老者、朋友和少者的關係。本頁楊譯把信與懷作使動，包含使朋友信任我、使年輕人懷念我，因此不能說全句完全不涉及自身關係。可以比較不同著力處，卻不能把三人道德高低或實踐難易當已由原文確定。",
      "review": {
        "version": "editorial-serial27-1eb75408196cc2e8",
        "sha256": "1eb75408196cc2e8c1afda06c46591dae441366d32bf475ef3eb027617276c8c",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-ren-1",
      "type": "concept",
      "refs": [
        323,
        324,
        325,
        344,
        365
      ],
      "concepts": [
        "ren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較不同問仁答語的實踐著力點與共同呈現方式",
      "stem": "對讀顏淵、仲弓、司馬牛與樊遲問仁的答語，就呈現方式看，哪項概括較準確？",
      "options": [
        {
          "id": "a",
          "text": "從行為要求談仁，實踐的著力點並不全相同"
        },
        {
          "id": "b",
          "text": "答案互相矛盾，說明孔子對仁沒有定見",
          "why": "自律、慎言與待人要求未必彼此排斥；要主張矛盾，仍須指出在何種相同條件下不能同時成立。"
        },
        {
          "id": "c",
          "text": "四答只是愛人二字的同義改寫，沒有新增要求",
          "why": "克己復禮、慎言、勿施所不欲等各提出不同要求；即使討論共同思想，也不能說只是詞語替換。"
        },
        {
          "id": "d",
          "text": "四答都只強調儀式之禮，不涉及其他行為要求",
          "why": "顏淵和仲弓的答語確有禮的因素，但慎言、愛人、勿施所不欲等不能都縮成儀式要求。"
        }
      ],
      "answerId": "a",
      "explanation": "這組章句把仁連到自律、待人與言行的不同要求，可以比較其互相補充之處。楊注明確據史記說司馬牛多言而躁，卻不能把這個個案擴成每位問者都有已知缺點，或直接斷言仁完全不是一個可討論的概念。",
      "review": {
        "version": "editorial-serial27-0279a158c736df3f",
        "sha256": "0279a158c736df3fd64484c91ae344a97115c9f888889c830e5a0639a6a90ec5",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-ren-2",
      "type": "concept",
      "refs": [
        68,
        127,
        180
      ],
      "concepts": [
        "ren",
        "xue"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "安仁與利仁的分別",
      "stem": "依本頁楊譯，『仁者安仁，知者利仁』的兩個著力點是什麼？",
      "options": [
        {
          "id": "a",
          "text": "行仁使自己心安；認識其長遠利益而行仁"
        },
        {
          "id": "b",
          "text": "仁者只憑情感而不行動，知者只計利益也不行仁",
          "why": "本頁對兩者都以行仁說明，不是把情感或計算與實際行為分開。"
        },
        {
          "id": "c",
          "text": "仁者是天生的，知者是學來的",
          "why": "4.2說的是兩者如何實行仁德，沒有把兩者的來由分別定為天生或後天學得。"
        },
        {
          "id": "d",
          "text": "兩句完全同義，沒有任何著力點差別",
          "why": "安仁與利仁的理由不同，但這種表述差異不等於同一個人絕不可能兼具仁與知。"
        }
      ],
      "answerId": "a",
      "explanation": "楊譯把安仁說成實行仁德而心安，把利仁說成認識仁德的長遠利益而實行。上句說不仁者不能久處約樂，卻沒有直接把所有知者都歸為不仁者；不能據此斷言只有安仁者才可能處理任何困樂。",
      "review": {
        "version": "editorial-serial27-c3fa17a2423cd6c8",
        "sha256": "c3fa17a2423cd6c801702be9915ab3717d81ce360bdbbd6feba8005a6c4bc91d",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-li-1",
      "type": "concept",
      "refs": [
        43,
        44,
        487,
        12
      ],
      "concepts": [
        "li",
        "ren"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "辨明仁與禮樂實踐的聯繫",
      "stem": "『人而不仁，如禮何？人而不仁，如樂何？』把仁與禮樂作了怎樣的聯繫？",
      "options": [
        {
          "id": "a",
          "text": "仁關乎如何對待禮樂，儀式形式本身不足"
        },
        {
          "id": "b",
          "text": "禮比仁更根本，先有禮才能有仁",
          "why": "這個反問指出不仁者對待禮樂的困難，沒有說只要先有儀式就必定產生仁。"
        },
        {
          "id": "c",
          "text": "禮與仁互不相干，各管一事",
          "why": "這個反問把不仁與如何對待禮樂相連，不能說仁與禮樂在此互不相干。"
        },
        {
          "id": "d",
          "text": "不仁的人不配行禮，應當禁止",
          "why": "原句反問不仁者如何對待禮樂，並未訂出禁止其參加儀式的資格規則。"
        }
      ],
      "answerId": "a",
      "explanation": "3.3以不仁者如何對待禮樂發問，可讀出內在德行與禮樂實踐的關係。這不是只問儀式動作是否齊全，更不是一條參加儀式的資格禁令。若再與3.4、17.11、1.12對读，可分析德行、形式與規範的互動，但需要另有明確比較任務。",
      "review": {
        "version": "editorial-serial27-4737582624e473be",
        "sha256": "4737582624e473beef8c5862da7fd2e0fe2b12d2818f0e39959b890523206c4f",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-li-2",
      "type": "concept",
      "refs": [
        12
      ],
      "concepts": [
        "li",
        "zhongyong"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "和為貴仍須以禮節之",
      "stem": "依本頁楊譯的和字與句讀，『知和而和，不以禮節之，亦不可行也』補充什麼限制？",
      "options": [
        {
          "id": "a",
          "text": "只求處事恰當，卻不用禮節制，仍行不通"
        },
        {
          "id": "b",
          "text": "只要稱為恰當，任何禮的約束都可取消",
          "why": "後句仍要求以禮節制，不能把和當成取消一切規範的理由；至於具體禮制能否調整，是另外的問題。"
        },
        {
          "id": "c",
          "text": "禮與和是兩套並行的制度",
          "why": "和是禮運用時的可貴之處，不是另一套制度。"
        },
        {
          "id": "d",
          "text": "先王之道以和為唯一標準",
          "why": "後句明說仍須以禮節制，不能把『和』解成唯一足夠的準則。"
        }
      ],
      "answerId": "a",
      "explanation": "楊注把和解為中節、恰當，譯文再指出不能只為恰當而求恰當，仍須有禮的節制。這不同於把和單純說成人際和好。其他句讀可按注中保留另作比較，不宜借現代主義標籤代替本句的限定。",
      "review": {
        "version": "editorial-serial27-1296cdb5cb0c2232",
        "sha256": "1296cdb5cb0c22323ff979cbbcf7399ba4ff642d4592a2391384a188709202ee",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-xue-1",
      "type": "concept",
      "refs": [
        1,
        31,
        27,
        451,
        518
      ],
      "concepts": [
        "xue"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "綜合多章學習活動及其相互配合",
      "stem": "把1.1實習、2.15學思、2.11溫故知新與子夏19.5補未知、保已能對讀，如何概括《論語》中的學習活動？",
      "options": [
        {
          "id": "a",
          "text": "實習、思考、溫故、獲新與補缺互相配合"
        },
        {
          "id": "b",
          "text": "只需記住文字，不必思考或實習",
          "why": "記憶與保持所能自有位置，但2.15要求思考，1.1楊注也強調實習，不能只留記誦。"
        },
        {
          "id": "c",
          "text": "只需獲取新知，舊知與已能都不必再顧",
          "why": "溫故與月無忘其所能都要求保持、重看已有知能，不能只取新知便丟開它們。"
        },
        {
          "id": "d",
          "text": "拜師後只守已有師說，不再形成新理解",
          "why": "傳承與溫故本身並非錯誤，但知新要求獲得新體會，不能把守師說擴成不再形成新理解。"
        }
      ],
      "answerId": "a",
      "explanation": "這些章句可以互補：學與思、實習與理解、溫故與知新、補未知與保已能相互支持。這是一種跨章整理，不是原文宣布的固定五步流程；19.5來自子夏，也不能將全組話都直接署名為孔子。",
      "review": {
        "version": "editorial-serial27-6e58b03976f7d4de",
        "sha256": "6e58b03976f7d4de866012b410dc54079815c4df86f0efa31d072d04bbfd2437",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-xue-2",
      "type": "concept",
      "refs": [
        400
      ],
      "concepts": [
        "xue",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "為己之學與為人之學",
      "stem": "依本頁楊譯，『古之學者為己，今之學者為人』中的兩種目的如何區分？",
      "options": [
        {
          "id": "a",
          "text": "為充實自己而學，或為給別人看而學"
        },
        {
          "id": "b",
          "text": "為己是自私，為人是利他，孔子讚後者",
          "why": "語氣是揚古抑今，孔子讚的是「為己」。"
        },
        {
          "id": "c",
          "text": "為己是自學，為人是從師",
          "why": "與學習方式無關，講的是動機。"
        },
        {
          "id": "d",
          "text": "為己是謀生，為人是服務社會",
          "why": "「為人」在此指博取他人認可，不是服務。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁把為己解作充實自身學問道德，把為人解作裝飾給別人看。因此不能望文生義，把前者當自私、後者當利他。對這種學習動機的批評可以延伸討論，但原句不足以證明凡在意他人評價的學習都必然沒有實質內容。",
      "review": {
        "version": "editorial-serial27-3e4ab288705768a1",
        "sha256": "3e4ab288705768a1d495b9a5c367d96885f781554d1474f8a8dcf5d3f83acddb",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-junzi-1",
      "type": "concept",
      "refs": [
        82,
        77,
        30,
        441,
        372
      ],
      "concepts": [
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "君子小人的對舉是一組判準",
      "stem": "《論語》中君子小人多次對舉：喻於義／喻於利、懷德／懷土、周而不比／比而不周、求諸己／求諸人、泰而不驕／驕而不泰。這些對舉的共同結構是？",
      "options": [
        {
          "id": "a",
          "text": "以對舉呈現不同取向，具體含義仍須逐章辨明"
        },
        {
          "id": "b",
          "text": "每章都明確只指同一對固定社會階級",
          "why": "楊注對4.16的身分與德行含義明言存疑，不能強定每章都是同一種階級指稱。"
        },
        {
          "id": "c",
          "text": "兩串彼此獨立的詞，句內沒有對照關係",
          "why": "喻於義與利、求諸己與人等都有明確句內對照，不能拆成互不相干的詞。"
        },
        {
          "id": "d",
          "text": "孔子對弟子與外人的不同要求",
          "why": "這組章句没有以是否孔門弟子區分君子小人；其他身分或德行含義仍要依各章判斷。"
        }
      ],
      "answerId": "a",
      "explanation": "這些句子藉對舉呈現價值、交往、求責與待人態度的差異，但不是每一組都可壓成向內好、向外壞。尤其4.16楊注保留君子小人指位、指德或兼指的疑問，跨章概括不能消除這項不確定。",
      "review": {
        "version": "editorial-serial27-43d904a818c312cf",
        "sha256": "43d904a818c312cfc6400223d62b1ddc5c519ad34739bedd7451dee354ae1dc8",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-xiao-1",
      "type": "concept",
      "refs": [
        21,
        22,
        23,
        24
      ],
      "concepts": [
        "xiao",
        "jiaoxue"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較四問孝的要求，辨明問者背景推論的限度",
      "stem": "結合《為政》四問孝的章文與本頁楊注，哪項是較有分寸的概括？",
      "options": [
        {
          "id": "a",
          "text": "四答突出不同要求，部分或與問者背景相關"
        },
        {
          "id": "b",
          "text": "四章已確證孔子依年代逐次推翻前說",
          "why": "這組章句未提供足以排列思想轉變的時間證據；編在同篇也不證明它們同時發生。"
        },
        {
          "id": "c",
          "text": "因身分有別，所以某些人只需能養而不必敬",
          "why": "楊注承認古禮有差等，卻没有以此取消敬或其他孝的要求。"
        },
        {
          "id": "d",
          "text": "答案既不相同，就證明其中至少三章不可靠",
          "why": "差異本身不證偽，編排整齊也不證真；文本真偽仍須另有傳承與考證材料。"
        }
      ],
      "answerId": "a",
      "explanation": "四答在本頁主譯中涉及依禮奉親、讓父母只為孝子的疾病憂慮、敬意與容色。2.6另保留子憂父母之疾的讀法。楊注只把2.5與僭禮的關係說成或然，並未記子游能養少敬、子夏能敬少和色；不能用想像的人物缺點填滿因材施教的故事，也不能宣稱四答已窮盡孝的全部意義。",
      "review": {
        "version": "editorial-serial27-2ec66bacdbe63868",
        "sha256": "2ec66bacdbe63868b7507a2bba899efc87abec3cc783ad15c19bb85902032f8a",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-shu-1",
      "type": "concept",
      "refs": [
        81,
        444,
        324,
        423
      ],
      "concepts": [
        "shu",
        "ren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "一貫之道的地位",
      "stem": "把4.15曾子解一貫為忠恕，與15.3孔子對子貢談一以貫之對讀，依本頁楊注可作何理解？",
      "options": [
        {
          "id": "a",
          "text": "以忠恕作統貫學行的觀念，而非只計所學之多"
        },
        {
          "id": "b",
          "text": "是孔子晚年才提出的新學說",
          "why": "章中無時間線索；且忠恕的內容散見全書各處。"
        },
        {
          "id": "c",
          "text": "孔子當場駁斥曾子的忠恕解釋",
          "why": "4.15記孔子先離開，門人才問曾子，沒有記孔子當場駁斥；同樣也不能把收錄正文當成另一次親口認可的證據。"
        },
        {
          "id": "d",
          "text": "指學問要博而後約，與待人無關",
          "why": "曾子明說是「忠恕」，落在待人接物上。"
        }
      ],
      "answerId": "a",
      "explanation": "4.15由曾子說忠恕，15.3則是孔子對子貢強調一以貫之，楊注將兩章相聯。本頁以勿施所不欲解恕，以己欲立達而立達人解忠。這支持比較統貫與博學的關係，但不表示兩章都曾否認博聞，也不表示學習與記憶本身應被取消。",
      "review": {
        "version": "editorial-serial27-a6c8f5412bfc0708",
        "sha256": "a6c8f5412bfc070871055a69d17c69e09450223188c0879e989a92f5dbe7e858",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-zheng-1",
      "type": "concept",
      "refs": [
        17,
        19,
        339,
        352
      ],
      "concepts": [
        "zheng"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "對讀德行示範與信從的治理主張",
      "stem": "把2.1北辰之喻與13.6『其身正，不令而行』對讀，兩章共同重視什麼？",
      "options": [
        {
          "id": "a",
          "text": "治理者自身德行對他人信從的影響"
        },
        {
          "id": "b",
          "text": "君主應當高高在上，與百姓保持距離",
          "why": "本章以北辰居其所、眾星環繞的比喻描寫為政者與眾人的關係，並未主張君主應疏遠百姓；13.6又落在自身行為是否端正。"
        },
        {
          "id": "c",
          "text": "德治比法治更省事，可以什麼都不做",
          "why": "兩章重視治理者自身，2.3又談德與禮的引導節制，不能解成所有事情都不用做。"
        },
        {
          "id": "d",
          "text": "百姓才是北辰，君主是環繞百姓的眾星",
          "why": "2.1把為政以德者比作北辰，這個選項顛倒了本章的比喻對應。"
        }
      ],
      "answerId": "a",
      "explanation": "北辰之喻以為政者與眾人相連，13.6又把自身是否端正與命令能否得到信從相連。對讀可見德行示範的治理觀，但這是章文的政治主張，不能直接當作任何現實制度都必然自動奏效的經驗定律。",
      "review": {
        "version": "editorial-serial27-4e1a7b8dc9c72eec",
        "sha256": "4e1a7b8dc9c72eec00c11083b5c10d710dea673217af27b592097c12e10b4439",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-zhengming-1",
      "type": "concept",
      "refs": [
        349
      ],
      "concepts": [
        "zhengming",
        "zheng",
        "li"
      ],
      "difficulty": 3,
      "cognitive": "analyze",
      "purpose": "辨別因果鏈、逆向推定、唯一原因與驗證證據的差別",
      "stem": "就下列論證鏈而言，哪一項判斷保留了文本所說的關係，又沒有擴張因果？",
      "options": [
        {
          "id": "a",
          "text": "名不正被放在這條鏈的起點，但不能據此認定所有政事失敗都只有這一個原因。"
        },
        {
          "id": "b",
          "text": "只要出現政事不成，就能沿這條鏈反推，確定其唯一原因必定是名分用詞不當。",
          "why": "從所列原因連到後果，不等於由任何相同後果都能反推唯一原因；本段没有排除其他原因。"
        },
        {
          "id": "c",
          "text": "只要名分用詞端正，就能沿這條鏈保證，其他條件如何都不影響禮樂與刑罰得當。",
          "why": "本鏈說名不正所引出的連鎖問題，不等於單憑名正就已保證全部治理條件同時充分。"
        },
        {
          "id": "d",
          "text": "只要論證的各環都被寫出，就能確定每一環的實際因果已由這段文字完成驗證。",
          "why": "重建作者提出的理由，與取得每一環實際因果的驗證證據不同；列出推論不等於完成經驗驗證。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子把名分用詞與政事、禮樂、刑罰及百姓處境連在一起，說明他為何先談正名。理解這條論證還須守住推論界線：不能由相同後果反推唯一原因，不能把改正一項當作所有條件都充分，也不能把提出因果主張直接當成已驗證。這是分析論證形式，並非宣告孔子的政治主張已證真或已證偽。",
      "context": "論證摘要（依13.3整理）：名不正 → 言不順 → 事不成 → 禮樂不興 → 刑罰不中 → 民無所措手足。",
      "review": {
        "version": "editorial-serial27-58d1b18aad8e0f90",
        "sha256": "58d1b18aad8e0f90c879d29e8bd084adcd9d873a2cb2fc9b1cf1c0474f178d19",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-zhongyong-1",
      "type": "concept",
      "refs": [
        149,
        286,
        367
      ],
      "concepts": [
        "zhongyong"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "整合中庸標準、過不及評語與不得中行時的取人條件",
      "stem": "哪項同時保留三章中的標準、評判與有條件的選擇，沒有只取其中一句？",
      "options": [
        {
          "id": "a",
          "text": "推重中庸，不以過分為勝；不得中行時再取狂狷的可取處，並未撤去中行標準"
        },
        {
          "id": "b",
          "text": "推重中庸，不以過分為勝；既然最後提到交狂狷，便證明中行已被孔子放棄",
          "why": "13.21先有不得中行的條件，不是宣布中行不值得求；提到次一層的選擇不能自動取消原標準。"
        },
        {
          "id": "c",
          "text": "推重中庸，認為過分總勝過不及；因此13.21只准選進取的狂者而排除狷者",
          "why": "11.16明說過猶不及，13.21又並列狂狷及不同特點，並未只准選狂者。"
        },
        {
          "id": "d",
          "text": "推重中庸，承認兩端偏失；因此只要把狂者與狷者平均混合，就必然得到中行",
          "why": "三章沒有把德行變成可加總的數量，也沒有提供平均兩類人便得到中行的規則。"
        }
      ],
      "answerId": "a",
      "explanation": "6.29提出所推重的德，11.16處理一項具體比較，13.21說在不得理想交往對象時怎樣另作選擇。三種語境可以相連，卻不等於由後一句撤回前者，更不是兩端的算術平均。此題須讀出理想與有條件選擇的關係；僅會解過猶不及不足以完成全部對讀。",
      "context": "6.29：中庸之為德也，其至矣乎！民鮮久矣。\n11.16：師也過，商也不及；過猶不及。\n13.21：不得中行而與之，必也狂狷乎！狂者進取，狷者有所不為也。",
      "review": {
        "version": "editorial-serial28-519913df660f1053",
        "sha256": "519913df660f10539a47c233866b158e925b6346985c45b681addf420e9e3925",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-tianming-1",
      "type": "concept",
      "refs": [
        20,
        470,
        541,
        411
      ],
      "concepts": [
        "tianming"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較知命章句與注者對原意的確定程度",
      "stem": "對讀2.4、16.8、20.3與14.35，哪種處理知命的方式較符合本頁楊注的分寸？",
      "options": [
        {
          "id": "a",
          "text": "承認知命受重視，但不把一種引申當唯一已定原義"
        },
        {
          "id": "b",
          "text": "這些章句已證明知命就是預知所有吉凶",
          "why": "本組没有給出預知全部未來的定義，2.4楊注反而暫不譯天命。"
        },
        {
          "id": "c",
          "text": "楊注明確認為努力無意義，一切只須聽命",
          "why": "2.4楊注明說孔子不是宿命論者，不能把這種結論歸給注者。"
        },
        {
          "id": "d",
          "text": "本組已把所有命字唯一限定為恢復周禮的使命",
          "why": "所列章句並未確認這一唯一限定，且楊注對相關解說仍有保留。"
        }
      ],
      "answerId": "a",
      "explanation": "知命、畏天命在這些章句中受到重視，但楊伯峻在2.4暫不譯天命，14.35也說相關解釋只能供參考。可以提出盡力而知限等解讀，卻須標示為解讀與論證，不能把它說成此底本已確定的唯一孔子原意。",
      "review": {
        "version": "editorial-serial28-ffb7cb752c4da5eb",
        "sha256": "ffb7cb752c4da5eb01ea72baf3102a226e95b34433a65cab50fc667b433fb799",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-wenzhi-1",
      "type": "concept",
      "refs": [
        138,
        330,
        48
      ],
      "concepts": [
        "wenzhi"
      ],
      "difficulty": 3,
      "cognitive": "analyze",
      "purpose": "文質關係的三個層次",
      "stem": "依本頁譯注，6.18、12.8及3.8對讀時，哪項較能兼顧三章各自的著力點？",
      "options": [
        {
          "id": "a",
          "text": "文質須相稱而不可偏廢，繪事之喻另示底子與文飾的依存"
        },
        {
          "id": "b",
          "text": "質永遠比文重要，文可有可無",
          "why": "12.8子貢以虎豹、犬羊之皮作喻：按本頁譯文，拔去有文彩的毛後，兩類皮革便很少區別；這用來反駁只要質而不要文的主張。"
        },
        {
          "id": "c",
          "text": "文比質重要，因為人先看到外表",
          "why": "3.8先有素底再畫花是該章類比，不能由此或由外表先被看到，推出文在所有情境都較重要。"
        },
        {
          "id": "d",
          "text": "文與質是同一件事的兩個名稱",
          "why": "兩者相互關聯或同等重要，不等於完全同一概念；各章也沒有提出可量化的固定比例。"
        }
      ],
      "answerId": "a",
      "explanation": "6.18論相稱，12.8反駁只要質而不要文，3.8借素底與畫花說明禮的依據。楊注指出仁義是譯者據其他儒家材料補出的賓語，原句未明說。綜合時可以談依存與互補，卻不宜把質先擴為所有文質情境的一條時間定律。",
      "review": {
        "version": "editorial-serial28-8dda1ccb5b02fdde",
        "sha256": "8dda1ccb5b02fdde7390a9e381f0b24dc2343f7ddc75ffd0080ff337884f7088",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-shijiao-1",
      "type": "concept",
      "refs": [
        196,
        485,
        18
      ],
      "concepts": [
        "shijiao",
        "li"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨讀詩、禮、樂的作用及相連關係",
      "stem": "依本頁楊譯，『興於詩，立於禮，成於樂』所說的三種作用如何相連？",
      "options": [
        {
          "id": "a",
          "text": "詩使人振奮，禮使人立足，樂使所學得以完成"
        },
        {
          "id": "b",
          "text": "學到後一項，就必須把前一項所學全部丟開",
          "why": "楊注雖說音樂是教學的最後階段，卻沒有說須丟棄先前所學；不能把後一階段當作取消前一項。"
        },
        {
          "id": "c",
          "text": "三種文獻的重要性排序",
          "why": "興、立、成分別說明作用；本句沒有排列三種文獻的重要性高下。"
        },
        {
          "id": "d",
          "text": "詩禮樂三者可以互相替代",
          "why": "本句用興、立、成分說不同作用，不能概括為三項意思完全相同而可任意換名。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁楊譯分說振奮、立足社會與完成所學，注釋又把音樂連到教學的最後階段。因此作用與教學安排並非非此即彼；原文也没有保證只按課表完成三科，就一定自動形成完備人格。",
      "review": {
        "version": "editorial-serial28-9ebde112c4501e9c",
        "sha256": "9ebde112c4501e9c024146321f4e694c8d51d5aa585892fccae7aa62d7d47590",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-chushi-1",
      "type": "concept",
      "refs": [
        201,
        427,
        113
      ],
      "concepts": [
        "chushi",
        "zhiren"
      ],
      "difficulty": 3,
      "cognitive": "analyze",
      "purpose": "比較不同應世表現，保留情境與評語的差異",
      "stem": "對讀8.13的天下有道則見、15.7所稱史魚與蘧伯玉、5.21所稱甯武子，對其應世表現可作何有分寸的比較？",
      "options": [
        {
          "id": "a",
          "text": "受稱許的表現不盡相同，須分辨語境與具體所守"
        },
        {
          "id": "b",
          "text": "孔子主張一律隱退，避免涉險",
          "why": "材料同時談避亂、剛直、藏其本領與裝儍，不能全部概括為一律隱退；如矢本身也未交代每次任職狀態。"
        },
        {
          "id": "c",
          "text": "孔子主張一律堅持直道，不可變通",
          "why": "他說甯武子的「愚」不可及，可見變通也在其中。"
        },
        {
          "id": "d",
          "text": "孔子的評價前後矛盾，無法統一",
          "why": "各章確有可討論的張力，但須逐一分析情境與評語，不能只以表現不同便判所有評價矛盾。"
        }
      ],
      "answerId": "a",
      "explanation": "8.13保留守道與避危亂的要求；15.7分別讚直與可藏本領；5.21又稱甯武子裝儍難及。不同表現不能只凭進退姿態下同一判斷，也不能把安全考量完全抹掉。保全自身與道可作解释，但5.21未明說裝儍的完整動機，仍須標示推論。",
      "review": {
        "version": "editorial-serial28-663749a9d07f8d89",
        "sha256": "663749a9d07f8d898ad4b5ce21ed7c335f9695530f7918efc0b5105417743f47",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-zhiren-1",
      "type": "concept",
      "refs": [
        443,
        448,
        405
      ],
      "concepts": [
        "zhiren"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "不以言舉人不以人廢言",
      "stem": "「君子不以言舉人，不以人廢言」防的是哪兩種錯誤？",
      "options": [
        {
          "id": "a",
          "text": "因一句好話便提拔其人；因其人不好便棄其好話"
        },
        {
          "id": "b",
          "text": "因為地位低就不聽；因為地位高就照聽",
          "why": "地位偏見可以是以人廢言的情況，但這個選項没有概括因一句話便提拔人的另一方向，不能完整回答兩端。"
        },
        {
          "id": "c",
          "text": "輕信傳聞；輕易表態",
          "why": "本句明確區分言到人與人到言的錯移；傳聞或表態可能涉及其他判斷問題，卻不是這兩端的完整解釋。"
        },
        {
          "id": "d",
          "text": "誇獎過度；批評過度",
          "why": "講的是判斷的依據錯置，不是程度。"
        }
      ],
      "answerId": "a",
      "explanation": "第一端防止從一句說得好就推到整個人值得提拔，第二端防止因對人的評價不好便抹去他說得對的話。它們要求分清判斷對象與依據，不是說身分、好惡或資訊來源從來無關，而是不能以其中一項取代應有考察。",
      "review": {
        "version": "editorial-serial28-9f108d41f6e10921",
        "sha256": "9f108d41f6e10921a87f15e3279cec80db33be29d426e15223f4dd8ed9ecf6a0",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-xin-1",
      "type": "concept",
      "refs": [
        38,
        329,
        13
      ],
      "concepts": [
        "xin"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "信的比喻與其分量",
      "stem": "「人而無信，不知其可也。大車無輗，小車無軏，其何以行之哉？」這個比喻的要點是？",
      "options": [
        {
          "id": "a",
          "text": "信是連接的關鍵，缺它則各部接不起來"
        },
        {
          "id": "b",
          "text": "信像車輪，是前進的動力",
          "why": "楊注說大車用鬲、小車用衡，輗軏是相應關鍵活銷，缺它便無法套住牲口；不是把車輪比作信。"
        },
        {
          "id": "c",
          "text": "信是車的裝飾，有了更體面",
          "why": "沒有輗軏車根本不能行，並非裝飾。"
        },
        {
          "id": "d",
          "text": "大車小車各有其信，標準不同",
          "why": "大車小車並舉是為說明無論大小皆然。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁楊注把輗軏說明為連接牲口與車具的關鍵，沒有它便不能行。比喻借不可缺的連接說明信的分量，並未談零件是否顯眼或是否受力。延伸閱讀時，1.13談約言須合義，12.7談百姓對政府的信任，須注意各章的具體語境。",
      "review": {
        "version": "editorial-serial28-c86d1e2451020009",
        "sha256": "c86d1e2451020009e864bb2ff1d23187f18fa42c2fc23db689e9503fe4217e14",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-yili-1",
      "type": "concept",
      "refs": [
        76,
        82,
        71,
        499,
        438,
        13
      ],
      "concepts": [
        "yili",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較義在行事、勇與守信中的判準作用",
      "stem": "對讀義之與比、義以為上、義以為質及信近於義，義在這組材料中有何作用？",
      "options": [
        {
          "id": "a",
          "text": "作行事與勇信等實踐的判準，並與禮信配合"
        },
        {
          "id": "b",
          "text": "只是一張固定清單，任何事情都不需再判斷",
          "why": "4.10說無適無莫而依義，不能解成在所有事情上都免除具體判斷；這並非否定一切明確規範。"
        },
        {
          "id": "c",
          "text": "與利對立的道德情感",
          "why": "17.23還以義討論勇，15.18使義與禮信配合，因此不能只概括為對利的情感；但也不必斷言義與情感毫無關係。"
        },
        {
          "id": "d",
          "text": "君子的專屬德行，小人不必講義",
          "why": "17.23 說小人有勇無義為盜，正是拿義來衡量所有人。"
        }
      ],
      "answerId": "a",
      "explanation": "這組材料以義判斷如何行事、勇能否正當，並把合義的承諾與履行相連；15.18則說以義為質、依禮行、以信成。可見義的重要判準作用，但不能從這幾例推出義完全不是德目，或把全書所有德目變成一條已證實的固定階序。",
      "review": {
        "version": "editorial-serial28-36748ed6b01dbd2c",
        "sha256": "36748ed6b01dbd2c86eeb20d262f66113e7ed2d7b145da6c6ecb2364b3538f54",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-jiaoxue-1",
      "type": "concept",
      "refs": [
        459,
        157,
        141,
        179,
        479,
        158
      ],
      "concepts": [
        "jiaoxue"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "有教無類的實踐證據",
      "stem": "為討論有教無類，哪組材料提供接納請教者的具體記載，而不只是能力分層或教法判斷？",
      "options": [
        {
          "id": "a",
          "text": "束脩以上未嘗無誨，互鄉童子亦與其進"
        },
        {
          "id": "b",
          "text": "「中人以下，不可以語上也」",
          "why": "這句區分可講授的學問深淺，沒有記下接納請教者的個案，因而不能單獨回答本題；它仍可用於討論有教無類與教法差異的關係。"
        },
        {
          "id": "c",
          "text": "「唯上知與下愚不移」",
          "why": "這句討論上知與下愚的不移，與有教無類如何相容需要另作論證；它本身沒有記錄接納請教者的個案。"
        },
        {
          "id": "d",
          "text": "「不憤不啟，不悱不發」",
          "why": "這句規定啟發的條件與時機，不能單獨作為接納某種出身學生的個案證據。"
        }
      ],
      "answerId": "a",
      "explanation": "楊注把束修解作初次拜見的薄禮，7.29又記孔子接見来自難與言之地的童子，可支持不僅憑出身成見拒人。原文仍有主動來學、潔己以進等條件，不能壓成全無界線；見面禮也不宜直接改稱已核實的學費制度。",
      "review": {
        "version": "editorial-serial28-1d8f487cee48b65d",
        "sha256": "1d8f487cee48b65d83d5bcf0eb4cd03c201c9ef38d86cdc9b770be4a23ad088a",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-ren-3",
      "type": "concept",
      "refs": [
        43,
        429,
        456,
        195
      ],
      "concepts": [
        "ren",
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "仁的分量與其代價",
      "stem": "對讀當仁不讓於師、無求生以害仁及仁以為己任，哪項較能保留這幾句各自的要求？",
      "options": [
        {
          "id": "a",
          "text": "行仁不因對老師謙讓而退，不以求生害仁，並以行仁為長久責任"
        },
        {
          "id": "b",
          "text": "只要禮的形式完備，是否行仁都無須考慮",
          "why": "3.3以不仁者如何對待禮樂發問，不能說形式完備便能取消仁的要求。"
        },
        {
          "id": "c",
          "text": "仁是可任意放棄的裝飾，遇到任何代價就可取消",
          "why": "這組話明確把行仁視為需要承擔的要求，不支持任意取消。"
        },
        {
          "id": "d",
          "text": "只在極端處境下才需要考慮",
          "why": "「仁以為己任」是終身的日常任務，不限極端。"
        }
      ],
      "answerId": "a",
      "explanation": "15.36說面臨行仁不因對老師謙讓而退，15.9提出不以求生損仁，曾子8.7則把仁作長久責任。它們表現仁的重要與代價，但仍要保留不同說話者和語境；讀者可分析古代理想，不應直接把幾句話化為任何現代處境的固定行動算法。",
      "review": {
        "version": "editorial-serial28-002f25b6c6600735",
        "sha256": "002f25b6c660073520bc9ba9ac7a269cd9ce9a704e6596dd2b93691cfb5e1340",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-zhiren-2",
      "type": "concept",
      "refs": [
        73
      ],
      "concepts": [
        "zhiren",
        "ren"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "觀過知仁的方法",
      "stem": "依本頁楊注以仁同人之解，『觀過，斯知仁矣』提供什麼觀察方向？",
      "options": [
        {
          "id": "a",
          "text": "過錯各有其類，觀其所錯即知其人"
        },
        {
          "id": "b",
          "text": "看一個人有沒有過錯，就知道他仁不仁",
          "why": "本頁把仁讀為人，並從過錯種類來理解識人；不是只問一個人有没有犯錯，再直接判仁與不仁。"
        },
        {
          "id": "c",
          "text": "應當寬容別人的過錯，這才是仁",
          "why": "「觀」是觀察方法，不是態度勸告。"
        },
        {
          "id": "d",
          "text": "同黨的人會互相包庇過錯",
          "why": "「黨」在此指類別，不指黨派。"
        }
      ],
      "answerId": "a",
      "explanation": "楊注以仁同人，因而把本句理解為考察過錯的類型來認識其人。這是一種識人觀察的主張，沒有比較所有成就與錯誤的證據效力，也不宜把一次過錯當成已證明一個人全部性格的捷徑。",
      "review": {
        "version": "editorial-serial28-179d14c688613fc5",
        "sha256": "179d14c688613fc5179d7ebaa4b6f22f4cf9fc22768fce261cba9f6a0d82c924",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-li-3",
      "type": "concept",
      "refs": [
        212
      ],
      "concepts": [
        "li",
        "zhongyong"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "辨讀9.3從眾與違眾的不同理由",
      "stem": "9.3 中孔子在麻冕一事上「從眾」，在拜下一事上「違眾」。他的取捨標準是？",
      "options": [
        {
          "id": "a",
          "text": "此處因省俭接受絲冕，因拜上倨傲而保留下拜"
        },
        {
          "id": "b",
          "text": "凡是多數人的做法都應該跟從",
          "why": "孔子在下拜一事上明言雖違眾仍從下，可見多數人的做法不是這兩項取捨的唯一判準。"
        },
        {
          "id": "c",
          "text": "凡是古制都不可更改",
          "why": "麻冕改純他就接受了，古制並非一律不可改。"
        },
        {
          "id": "d",
          "text": "他的取捨隨心情而定，沒有一定標準",
          "why": "章文分別明說儉與泰，作為兩項不同選擇的理由，並非未作說明便隨意選擇。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子對兩項變化提出不同理由：丝冕省俭，所以從眾；省去下拜被他看作倨傲，所以違眾。這可支持按行為的具體意義作判斷，而不是只按新舊或人數；但不能由兩例推出所有器物規定都可改、所有相關禮節都永遠不可改。",
      "review": {
        "version": "editorial-serial28-34546bcfb410bf1e",
        "sha256": "34546bcfb410bf1eeb6f9cf03b4e9f3fe60e34189ed5d0ae323602979f183391",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-xue-3",
      "type": "concept",
      "refs": [
        239
      ],
      "concepts": [
        "xue",
        "zhongyong"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "辨讀立與權的不同含義",
      "stem": "依本頁楊注，此章從可與共學、適道、立進一步談權，權所增加的能力是什麼？",
      "options": [
        {
          "id": "a",
          "text": "不只依禮而行，還能就具體事情權衡通變"
        },
        {
          "id": "b",
          "text": "掌握權力，能夠推行主張",
          "why": "權在本頁譯作通權達變，並非取得官位或政治權力。"
        },
        {
          "id": "c",
          "text": "有權威，能讓別人聽從",
          "why": "可與談的是能否與某人共同達到相關程度，並非與他人無關；但權在本頁譯作通權達變，不是支配他人的權威。"
        },
        {
          "id": "d",
          "text": "能夠變通，不必再守原則",
          "why": "本頁把立解為事事依禮而行，把權解為通權達變；區分二者不等於宣告禮或一切原則都可取消。"
        }
      ],
      "answerId": "a",
      "explanation": "本章反覆區分：能與之共學，未必能一同做到後面的事情；能立，也未必能權。楊注以依禮而行解立，主譯以通權達變解權。這是在區分能力，未必是每個人按同一時間表必經的四段人生歷程。此固定譯文寫作『依體』，注中則作『依禮』；本題按注釋理解立，保留兩處字形差異。",
      "review": {
        "version": "editorial-serial28-dc3e2a480edc0c4b",
        "sha256": "dc3e2a480edc0c4b4ffb457d3e9e28ed437d2d5bff326901dbb600714a8472a5",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-zheng-2",
      "type": "concept",
      "refs": [
        540,
        341
      ],
      "concepts": [
        "zheng",
        "ren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "分析五美句式與各項理由的關係",
      "stem": "把五美的共同句式與後文逐項解說合看，哪項概括較準確？",
      "options": [
        {
          "id": "a",
          "text": "提出治理要求並限制弊害，各項理由仍有差別"
        },
        {
          "id": "b",
          "text": "五種美德互不相干，需要分別修養",
          "why": "五句有共同的正面要求與負面限制，但後文仍逐項給出不同理由，不能說它們全無聯繫或不用分別理解。"
        },
        {
          "id": "c",
          "text": "五美是對百姓的要求",
          "why": "章首先問何如斯可以從政，後文又談因民之利、勞民等，依此語境可知正在談治理者的要求。"
        },
        {
          "id": "d",
          "text": "說明治理不需要威嚴",
          "why": "「威而不猛」保留了威，去掉的是猛。"
        }
      ],
      "answerId": "a",
      "explanation": "五句形式相似，具體關係卻不一：勞民而民不怨涉及不同主體，欲仁與貪財又涉及所欲對象，威而不猛則區分威儀與凶猛。不能把全部解成同一品質只要過量就產生問題，也不宜只用過猶不及一句代替逐項解讀。",
      "review": {
        "version": "editorial-serial28-07f12b01e2cd7be0",
        "sha256": "07f12b01e2cd7be017be36c46243a549e317cc280fec1c0a4625872a2ee707eb",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-shu-2",
      "type": "concept",
      "refs": [
        435,
        441
      ],
      "concepts": [
        "shu",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "對讀求諸己與厚責己薄責人",
      "stem": "把躬自厚而薄責於人與君子求諸己對讀，哪項既指出共同重點，又保留15.15的具體要求？",
      "options": [
        {
          "id": "a",
          "text": "兩章都重向自己提出要求；15.15並主張少責別人以求遠怨"
        },
        {
          "id": "b",
          "text": "自己完全不必改，只需要求別人忍讓",
          "why": "厚責自己與求諸己都包含向自身提出要求，不是只叫別人忍讓。"
        },
        {
          "id": "c",
          "text": "只比較修養名次，與如何相處完全無關",
          "why": "15.15明說薄責於人與遠怨，不能把對人的關係排除；自身修養與相處也可相連。"
        },
        {
          "id": "d",
          "text": "只適用君主管理下屬，其他關係一概不可用",
          "why": "這兩章沒有給出這種排他身分限定。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章都把注意力轉向自己應承擔的要求，15.15並以少責他人連到遠怨。這是章文提出的相處原則，沒有統計證據說大多數衝突都不是錯誤而只是尺度不一，也不能保證只要多責自己就能消除任何衝突。",
      "review": {
        "version": "editorial-serial28-aee83fa5e7ccbba8",
        "sha256": "aee83fa5e7ccbba87a8089ac5626c74478f071847b38a8ccf5b6a9b3040446b2",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cp-tianming-2",
      "type": "concept",
      "refs": [
        142,
        171,
        185
      ],
      "concepts": [
        "tianming",
        "li"
      ],
      "difficulty": 3,
      "cognitive": "analyze",
      "purpose": "比較鬼神相關章句並辨明解釋界線",
      "stem": "把敬鬼神而遠之、不語怪力亂神與丘之禱久矣連同本頁譯注對讀，哪種處理較符合來源界線？",
      "options": [
        {
          "id": "a",
          "text": "分辨各章行為與語境，不逕斷鬼神存在或抹平張力"
        },
        {
          "id": "b",
          "text": "堅定的無神論，否認鬼神存在",
          "why": "這幾章沒有直接作鬼神不存在的論證，不能僅由不語或遠之推出堅定無神論。"
        },
        {
          "id": "c",
          "text": "虔誠的信仰者，凡事訴諸神明",
          "why": "6.22要求在人事上用力並敬鬼神而遠之，7.21又記不語鬼神，不能把這組材料概括為凡事都訴諸神明。"
        },
        {
          "id": "d",
          "text": "本頁已明確把早已祈禱注解為日常行事就是禱告",
          "why": "本頁楊譯只是早就祈禱過，注釋没有這項道德化解說；若引用別家解讀，必須另明來源。"
        }
      ],
      "answerId": "a",
      "explanation": "6.22要求在人事上用力並敬而遠之，7.21記其不語，7.35則記早已祈禱的回答。它們可以引出處世、禮儀與鬼神觀的比較，但現頁没有證實日常行事就是禱告，也不足以單獨判定完整的有神或無神立場。應保留各句與注釋的張力，再有據提出解讀。",
      "review": {
        "version": "editorial-serial28-be00c1d3441cb865",
        "sha256": "be00c1d3441cb865c9690c62533dc6def9cad27370127d6177b18c167196f16d",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-1",
      "type": "linkage",
      "refs": [
        31,
        451
      ],
      "concepts": [
        "xue"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較雙向學思主張與個人敘述能支持多大的學習結論",
      "stem": "哪一段評析同時準確使用兩章，又沒有把它們的證據範圍擴大？",
      "options": [
        {
          "id": "a",
          "text": "2.15也批評學而不思；15.31記一段自身經驗，不能證明所有課程取消思考都更好"
        },
        {
          "id": "b",
          "text": "2.15也批評學而不思；15.31的篇序較後，足以證明孔子後來撤回了這項批評",
          "why": "前半對2.15的理解成立，但篇章排列不能直接證明發言年代或思想修訂；15.31也沒有宣告撤回另一章。"
        },
        {
          "id": "c",
          "text": "2.15也批評學而不思；15.31已比較同一批学生兩種學法的成績，驗證了只讀誦的優勢",
          "why": "前半成立，但15.31只記吾嘗的自身經歷，沒有同一批學生、兩種課程或成績比較；不能補造實驗紀錄。"
        },
        {
          "id": "d",
          "text": "2.15也批評學而不思；15.31既非對照實驗，其自述對理解孔子的學思主張就沒有參考價值",
          "why": "不能推出普遍教學效力，不等於敘述毫無文本理解價值；它仍呈現本章說話者對這段經歷的評價。"
        }
      ],
      "answerId": "a",
      "explanation": "檢查甲的結論要分兩步：2.15同時指出學而不思的問題，因此不能只取思而不學一面；15.31的自述可供對讀，但没有檢驗所有學生、所有課程或取消討論的效果。這既不抹去自述的理解價值，也不把它升格為已驗證的普遍教學處方。",
      "context": "甲據15.31『終日不食，終夜不寢，以思，無益，不如學也』，提議所有課程都取消思考討論，只保留讀誦，並聲稱這已經得到2.15與15.31共同驗證。\n2.15另說：『學而不思則罔，思而不學則殆。』",
      "review": {
        "version": "editorial-serial28-e3fdfcb43aeb72b4",
        "sha256": "e3fdfcb43aeb72b441146dee219c94bb70c3cb7774d9a1c56e085bb5005bef62",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-2",
      "type": "linkage",
      "refs": [
        86,
        84,
        11
      ],
      "concepts": [
        "xiao"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "用一章限制另一章",
      "stem": "有人引 4.20「三年無改於父之道」主張子女不該質疑父母。哪一章最能限制這種讀法？",
      "options": [
        {
          "id": "a",
          "text": "4.18 事父母幾諫，見志不從又敬不違"
        },
        {
          "id": "b",
          "text": "4.19「父母在，不遠遊，遊必有方」",
          "why": "4.19直接談遠遊與去處，沒有直接提出父母有不對時可以婉轉勸止，因而不如4.18能回應此推論。"
        },
        {
          "id": "c",
          "text": "4.21「父母之年，不可不知也」",
          "why": "這句談記得父母年齡並由此喜懼，沒有直接提出勸諫的做法。"
        },
        {
          "id": "d",
          "text": "2.7「今之孝者，是謂能養」",
          "why": "2.7區分供養與敬意，但沒有直接說能否向父母提出異議，不能替代4.18幾諫的明文。"
        }
      ],
      "answerId": "a",
      "explanation": "4.18明說事父母幾諫，足以反駁子女一概不得提出異議。4.20的現有譯文重複原文，應連同所指1.11閱讀；該頁楊譯把父道限定為合理部分，注又把三年說成可表長期。不能把兩章拼成先絕對服從、滿三年便可改動的時間表。",
      "review": {
        "version": "editorial-serial28-f900a6f60179d61d",
        "sha256": "f900a6f60179d61d7e2a639ff5633d4f63ab97aaab1d51c5bf964ffe673a55ef",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-3",
      "type": "linkage",
      "refs": [
        329,
        38
      ],
      "concepts": [
        "xin",
        "zheng"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "個人之信與政治之信",
      "stem": "12.7「民無信不立」與 2.22「人而無信，不知其可也」的關係是？",
      "options": [
        {
          "id": "a",
          "text": "都重視信，但分別談個人信譽與百姓對政府的信任"
        },
        {
          "id": "b",
          "text": "互相矛盾：一個講個人，一個講政治，標準不同",
          "why": "兩章主體與信的指向不同，仍可同時成立；不同層次並不自動構成矛盾。"
        },
        {
          "id": "c",
          "text": "2.22 是 12.7 的例外情況",
          "why": "2.22談個人無信難以行事，沒有說它是12.7政治信任主張的例外。"
        },
        {
          "id": "d",
          "text": "12.7 已經取代了 2.22 的說法",
          "why": "篇章排列不能直接證明言論的先後；兩章也沒有明說其中一項撤回另一項。"
        }
      ],
      "answerId": "a",
      "explanation": "2.22以車的連接部件比喻個人信譽的重要；12.7則說百姓對政府的信任不可缺。二者可在重視信這一點上對讀，同時須保留個人信用與政治信任的對象差別，不能說后一章才把信升級為重要條件。",
      "review": {
        "version": "editorial-serial28-b6ff39ff9e0daa9a",
        "sha256": "b6ff39ff9e0daa9a529a768384c4a781b42695551943a34254d03b3077ee95ac",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-4",
      "type": "linkage",
      "refs": [
        172,
        83
      ],
      "concepts": [
        "xue",
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "對應兩章的行動指向，區分內省與已完成改正",
      "stem": "哪一項既讀準兩章的動作，又能檢查這位同學多推出了什麼？",
      "options": [
        {
          "id": "a",
          "text": "善者對應從之、思齊；不善者對應改之、內自省；但內省自述尚不能證明實際行為已改"
        },
        {
          "id": "b",
          "text": "善者對應從之、思齊；不善者對應改之、內自省；因此內省自述已足以證明實際行為已改",
          "why": "前兩項對應成立，但反省有無相似問題與實際改正仍有區別；所引章句未讓一句自述自動證成行為結果。"
        },
        {
          "id": "c",
          "text": "善者對應改之、內自省；不善者對應從之、思齊；但內省自述尚不能證明實際行為已改",
          "why": "後半對證據的保留成立，前半卻把善者應取法、不善者應借鏡改正的對應交換了。"
        },
        {
          "id": "d",
          "text": "善者對應從之、思齊；不善者對應改之、內自省；但兩章用字不同，便不能比較其共同方向",
          "why": "動作不完全相同，並不取消由觀人而修己的共同方向；既須承認差別，也不能因用字不同拒絕有根據的比較。"
        }
      ],
      "answerId": "a",
      "explanation": "可將善者與從之、思齊相連，將不善者與改之、內自省相連，看到共同的借人修己方向。同時須保留動作差別：察看自己的問題不等於問題已改，正如選出合適解釋也不等於已在生活中實踐。這是辨讀表述與推論，並非否認反省的作用。",
      "context": "7.22：擇其善者而從之，其不善者而改之。\n4.17：見賢思齊焉，見不賢而內自省也。\n同學說：兩章既可對讀，只要有人說自己已內自省，就能確定他已做到改之。",
      "review": {
        "version": "editorial-serial28-e4ba44ddf91e9a8e",
        "sha256": "e4ba44ddf91e9a8e1c718aaa96a3588de0ac800f71ecbc180681ee16b2248806",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-5",
      "type": "linkage",
      "refs": [
        444,
        324
      ],
      "concepts": [
        "shu",
        "ren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "同一句話出現在兩處的意義",
      "stem": "「己所不欲，勿施於人」在 12.2（答仲弓問仁）與 15.24（答子貢問終身行之）都出現。這說明？",
      "options": [
        {
          "id": "a",
          "text": "它既用於答問仁，也用於說明可終身奉行的恕"
        },
        {
          "id": "b",
          "text": "《論語》編纂重複，屬於失誤",
          "why": "兩處問題和答語範圍不同，不能只因一句重出就認定編纂失誤；這也不足以證明編者的具體用意。"
        },
        {
          "id": "c",
          "text": "孔子只有這一句話可以回答問題",
          "why": "12.2答語同時包含出門如見大賓、使民如承大祭等內容，並非只有此句。"
        },
        {
          "id": "d",
          "text": "子貢與仲弓程度相同，所以答案相同",
          "why": "相同一句可出現在不同問題中，不能只憑這點判定問者的學習程度相同。"
        }
      ],
      "answerId": "a",
      "explanation": "在12.2，這句是回答如何行仁的一部分；15.24則以其恕乎回答終身奉行之言。可由此比較它在兩段問答中的作用，但不能據此建立編纂過程、問者程度或後世傳播原因的確證。",
      "review": {
        "version": "editorial-serial28-c6294f40c2798ff9",
        "sha256": "c6294f40c2798ff9e01f9a16daf522fe1edbb36a8dd79fddf0ad56e7a93c1aaf",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-6",
      "type": "linkage",
      "refs": [
        102,
        26
      ],
      "concepts": [
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較識人方法並區分內容與年代證據",
      "stem": "把5.10『聽其言而觀其行』與2.10的識人方法對讀，依本頁楊譯，哪項比較較準確？",
      "options": [
        {
          "id": "a",
          "text": "前者兼察言行，後者考察交往、方法與心安之處"
        },
        {
          "id": "b",
          "text": "兩者衝突：一個看言行，一個看內心",
          "why": "考察言行與考察所安可以並行，不必互相排斥；原文沒有交代一套固定的由外到內發展史。"
        },
        {
          "id": "c",
          "text": "2.10 是原則，5.10 推翻了它",
          "why": "兩章均有識人的內容，沒有明說其中一章撤回另一章；篇章順序也不能直接作年代證據。"
        },
        {
          "id": "d",
          "text": "兩章無關，分屬識人與教學兩個主題",
          "why": "5.10 的結論明確是「吾於人也」的識人方法。"
        }
      ],
      "answerId": "a",
      "explanation": "5.10不再僅憑言語相信其行為，2.10則依此頁楊譯列出交往、方法與心安等考察方向。可比較兩者的內容；但5.10第二段子曰被注者視為另一場合，兩章也未給出足以復原方法形成史的年代材料。",
      "review": {
        "version": "editorial-serial28-4e9828702e30b979",
        "sha256": "4e9828702e30b979b8f6663a863eabf2b16d4e80b0b38ea9f67f5335894abf9f",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-7",
      "type": "linkage",
      "refs": [
        292,
        141
      ],
      "concepts": [
        "jiaoxue"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "區分按理解層次與按性情調整教導",
      "stem": "6.21說中人上下與能否語上，11.22卻因子路、冉有勇為或退縮而同問異答。哪項比較符合兩章？",
      "options": [
        {
          "id": "a",
          "text": "前者依水平選擇學問深淺，後者依退縮或勇為而勉勵、抑制"
        },
        {
          "id": "b",
          "text": "11.22已證明子路必屬中人以上，冉有必屬中人以下",
          "why": "11.22給的是勇為與退縮的理由，没有据此評定兩人學問層次。"
        },
        {
          "id": "c",
          "text": "兩章都只依學生出身決定是否接納入學",
          "why": "兩章分別涉及講說深淺與具體勸告，沒有把出身或收生作為判準。"
        },
        {
          "id": "d",
          "text": "兩章都要求同一問題在任何學生面前只能有一種回答",
          "why": "6.21區分能否語上，11.22記同問異答，均不支持一律同答。"
        }
      ],
      "answerId": "a",
      "explanation": "二章都可用於討論因人調整教導，但不能混同調整依據：6.21談理解層次與講說內容的深淺，11.22談行事退縮或勇為而採不同勸告。沒有證據把兩位弟子直接放入中人上下的等級。",
      "review": {
        "version": "editorial-serial28-5cc02ebae827e7be",
        "sha256": "5cc02ebae827e7be77c354cb2d50977b217d1914ca123f453df87ac977b93c97",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-8",
      "type": "linkage",
      "refs": [
        489,
        370
      ],
      "concepts": [
        "zhongyong",
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "對讀鄉愿批評與普遍好評的證據限度",
      "stem": "要以他章對讀17.13對鄉愿的批評，哪一章最直接提醒：只憑鄉人普遍稱好，還不足以判定一個人的德行？",
      "options": [
        {
          "id": "a",
          "text": "13.24 鄉人皆好之而孔子曰未可也"
        },
        {
          "id": "b",
          "text": "17.12「色厲而內荏」",
          "why": "這句比較嚴厲外表與怯弱內心，沒有直接討論全鄉好評是否足以判德。"
        },
        {
          "id": "c",
          "text": "15.27「巧言亂德」",
          "why": "這句指出巧言可能擾亂德，與鄉愿問題可有關聯，卻未直接提出全鄉好評的判準。"
        },
        {
          "id": "d",
          "text": "2.14「小人比而不周」",
          "why": "這句區分比與周，雖可用於識人，卻沒有直接回答全鄉好評是否足以判德。"
        }
      ],
      "answerId": "a",
      "explanation": "13.24對鄉人皆好之仍答未可，轉而區分善者與不善者的好惡，可與17.13對鄉愿的批評對讀。這並不表示凡受普遍好評者都已被證成鄉愿；賊在此是敗壞德的批評，不能把某種現代機制解說冒充字面原義。",
      "review": {
        "version": "editorial-serial28-bcb86098bbc6d27c",
        "sha256": "bcb86098bbc6d27c91f58800f47cbc26258649ef4d54e273efac68af2347201c",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-9",
      "type": "linkage",
      "refs": [
        201,
        379
      ],
      "concepts": [
        "chushi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較出隱選擇與言行分寸",
      "stem": "8.13『天下有道則見，無道則隱』與14.3『邦無道，危行言孫』，依本頁楊譯，哪項比較較有依據？",
      "options": [
        {
          "id": "a",
          "text": "一談出仕或隱居，一談言行分寸，不能直接判作互相否定"
        },
        {
          "id": "b",
          "text": "衝突：一個要走，一個要留",
          "why": "14.3沒有規定必須留任，8.13之隱也不能直接等同離開國境，不能化約成一走一留。"
        },
        {
          "id": "c",
          "text": "不衝突：兩章說的都是要隱退",
          "why": "14.3要求行為正直、言語謙順，並未直接規定出仕或隱退；正直行為與隱居也不互斥。"
        },
        {
          "id": "d",
          "text": "衝突：後章推翻了前章",
          "why": "篇章次序不是言論年代的充分證據，兩章也没有明說撤回另一種主張。"
        }
      ],
      "answerId": "a",
      "explanation": "8.13在有道無道下談見與隱，14.3則談行為和言語如何表現。可以辨明其著眼點而討論相容性，不必捏造暫時走不了的補充情境；更不能把隱與危行當成互相排斥的動作。",
      "review": {
        "version": "editorial-serial28-237380fb075862f3",
        "sha256": "237380fb075862f34b40fa2d14a2b80941574e869976fcc9ce9dd2d8cd74fccb",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-10",
      "type": "linkage",
      "refs": [
        43,
        487
      ],
      "concepts": [
        "li",
        "ren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "区分两章各自的追问与不能推出的充分条件",
      "stem": "3.3与17.11各提出怎样的限制？下面哪项对读没有把限制偷换为充分条件？",
      "options": [
        {
          "id": "a",
          "text": "前章追问不仁者如何对待礼乐，后章否定仅用器物说尽礼乐；都未保证只要自称仁便可任意取消形式"
        },
        {
          "id": "b",
          "text": "前章已证明只要备齐玉帛便有仁，后章再保证器物越多越合礼",
          "why": "3.3没有从器物齐全推出仁；17.11恰在反问礼乐是否只是器物，不能据此建立数量越多越合礼的判准。"
        },
        {
          "id": "c",
          "text": "前章否定不仁者能妥善对待礼乐，就等于保证有仁者的每一种做法都必定合礼",
          "why": "指出不仁带来的问题，不等于证明仁已是所有具体做法合礼的充分条件；材料没有排除其他需要考虑的条件。"
        },
        {
          "id": "d",
          "text": "后章说礼乐不止玉帛钟鼓，就等于宣布这些器物及一切仪节都必须取消",
          "why": "不止于器物与取消器物是不同命题；17.11没有发布废除一切形式的要求。"
        }
      ],
      "answerId": "a",
      "explanation": "3.3针对不仁与如何对待礼乐的关系发问，17.11针对把礼乐缩成器物发问。对读须分别指出问题所落之处，并保留推论界线：材料既不保证自称仁便使一切做法合礼，也没有因为礼乐不止器物就要求取消器物。此题检验两项文本主张与额外推论的区别，不是证明某人的内心或完整裁定礼的全部条件。",
      "context": "3.3：人而不仁，如礼何？人而不仁，如乐何？\n17.11：礼云礼云，玉帛云乎哉？乐云乐云，钟鼓云乎哉？",
      "review": {
        "version": "editorial-serial28-2d67a846b586dc73",
        "sha256": "2d67a846b586dc73854c126631d822f6883764636480705029a537752d839c16",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-11",
      "type": "linkage",
      "refs": [
        16,
        439,
        406
      ],
      "concepts": [
        "zhiren",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "區分相似章句中的共同點與所患對象",
      "stem": "1.16、14.30與15.19都不以別人不知自己為患。比較各章轉而關注的內容，哪項最準確？",
      "options": [
        {
          "id": "a",
          "text": "1.16轉向是否知人，另兩章轉向自身是否有能力"
        },
        {
          "id": "b",
          "text": "完全相同，屬於重複記錄",
          "why": "共同點是不患別人不知自己，但1.16接患不知人也，與另兩章的自身能力有別。"
        },
        {
          "id": "c",
          "text": "語氣一次比一次強烈，內容不變",
          "why": "1.16與另兩章所關注的內容有別，不能只說語氣改變而內容完全相同。"
        },
        {
          "id": "d",
          "text": "分別針對不同弟子而說",
          "why": "這三章未記具體聽者，現有材料不足以據此確定分別針對哪些弟子。"
        }
      ],
      "answerId": "a",
      "explanation": "三章共同轉移對他人是否了解自己的關注，但1.16進一步要求知人，14.30與15.19則關注自身能力。後兩章可視為相近表述，不必虛構又一次收窄；章次也不能直接復原觀點形成的時間順序。",
      "review": {
        "version": "editorial-serial28-fe11dd814dd6df2e",
        "sha256": "fe11dd814dd6df2ed53ed515ba404925aa08a704bfd9119b7eb9c5471a9669d6",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-12",
      "type": "linkage",
      "refs": [
        150,
        444
      ],
      "concepts": [
        "ren",
        "shu"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "肯定式與否定式的推法",
      "stem": "6.30「己欲立而立人」與 15.24「己所不欲，勿施於人」在方法上的關係是？",
      "options": [
        {
          "id": "a",
          "text": "都由自身所欲作參照，分別談助人成就與不施己不欲"
        },
        {
          "id": "b",
          "text": "前者要求高，後者是它的簡化版，可以互相取代",
          "why": "協助別人立與達，和不把己不欲加人，提出的要求不同，不能彼此直接替換；勿施也不等於在任何情境都無須採取行動。"
        },
        {
          "id": "c",
          "text": "兩者對象不同，一對朋友一對外人",
          "why": "兩章沒有把對象分為朋友與外人，不能據此建立排他的適用界線。"
        },
        {
          "id": "d",
          "text": "前者是仁，後者是恕，兩者無關",
          "why": "兩章都可從自身所欲的參照來比較；本頁15.24楊注另以忠稱積極助人，不能因仁、恕名稱不同就判它們全無關係。"
        }
      ],
      "answerId": "a",
      "explanation": "6.30講自己欲立欲達時也助人立達；15.24講不把自己不願承受的事加給別人。可辨其共同參照與不同要求。本頁楊注以忠、恕作積極與限制性的區別，但沒有把前者規定為道德最高上限，也不宜把後者化為完全不作為。",
      "review": {
        "version": "editorial-serial28-8264af39cdcfe0e1",
        "sha256": "8264af39cdcfe0e1c0638d6c88e8d7be2b001bd58bbb9f13098e229ffb22d23b",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-13",
      "type": "linkage",
      "refs": [
        463,
        287
      ],
      "concepts": [
        "zheng",
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較對冉求兩項具體作為的批評",
      "stem": "16.1責冉求輔助季氏謀伐顓臾，11.17責他替季氏聚斂。兩章共同指出哪一點？",
      "options": [
        {
          "id": "a",
          "text": "作為季氏之臣，冉求仍須對自己助成的不當作為負責"
        },
        {
          "id": "b",
          "text": "孔子對冉有一向不滿，從未肯定過他",
          "why": "6.8稱冉求有藝、可以從政，11.3又列他於政事科，不能由這兩次批評說孔子從未肯定他。"
        },
        {
          "id": "c",
          "text": "兩章記的是同一件事的不同版本",
          "why": "一章談軍事進攻，一章談搜括財富，兩段記載的具體作為不同，不能直接當同一事件的兩個版本。"
        },
        {
          "id": "d",
          "text": "凡屬季氏作主，冉求作為臣屬便完全沒有責任",
          "why": "16.1以相者應扶危、匣中之物受損誰負責等比喻追責，11.17也直接批評冉求助斂，均未免除其責任。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章分別責助攻伐與助聚斂，顯示臣屬不能把自己助成不當作為的責任全推給主事者。可與冉求才幹受肯定的記載並讀，但不能僅凭章次建立責備越來越重的傳記。此題對讀的是11.17的聚斂記載與16.1的輔相責任；16.1現存正文夾有『當作貧』『當作寡』的校語，這一來源狀況仍保留可見。",
      "review": {
        "version": "editorial-serial28-378cea3c88ac885a",
        "sha256": "378cea3c88ac885a9b790d83b2bd58f411e8721e4ce5e490eeeb31a63ca789cb",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-14",
      "type": "linkage",
      "refs": [
        238,
        404
      ],
      "concepts": [
        "ren",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較三德表述的不同對話框架",
      "stem": "9.29「知者不惑，仁者不憂，勇者不懼」與 14.28「君子道者三，我無能焉：仁者不憂，知者不惑，勇者不懼」的差別是？",
      "options": [
        {
          "id": "a",
          "text": "同列三項德行表述，14.28另有孔子自言未能與子貢的回應"
        },
        {
          "id": "b",
          "text": "後者是前者的修訂，孔子改變了看法",
          "why": "仁者不憂、知者不惑、勇者不懼三項仍在，但排列次序和上下文有別；沒有顯示孔子撤回這三項看法。"
        },
        {
          "id": "c",
          "text": "前者講君子，後者講聖人",
          "why": "14.28明說君子道者三，不能說它改談聖人；9.29則直接列三項表述。"
        },
        {
          "id": "d",
          "text": "兩者無關，只是巧合相似",
          "why": "三項表述直接重出，可比較其相同內容與不同框架，不能說全無可比較的關聯。"
        }
      ],
      "answerId": "a",
      "explanation": "9.29直接列出知、仁、勇三項；14.28調整次序並加『我無能焉』，子貢則說『夫子自道也』。可以討論孔子的自謙與弟子的推許，但應分清各自所說，不能直接判定說話者內心，也不必把兩章排成先教人後自省的年代故事。",
      "review": {
        "version": "editorial-serial28-dea34ee6c605acb8",
        "sha256": "dea34ee6c605acb89fed1e2f9d8c29a90f3f6be3d067ff5a0fb3932522ec6fa6",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-15",
      "type": "linkage",
      "refs": [
        147,
        337
      ],
      "concepts": [
        "xue",
        "li"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "書中重出章的處理",
      "stem": "現有頁面中，6.27與12.15重出博學於文、約之以禮等語。12.15的注釋如何處理？",
      "options": [
        {
          "id": "a",
          "text": "以見雍也篇第六指向前篇相關注釋，保留本章"
        },
        {
          "id": "b",
          "text": "認定其中一處是衍文，予以刪去",
          "why": "他保留了兩處，只在注中互見。"
        },
        {
          "id": "c",
          "text": "另寫一段逐句解釋，專門分析兩章的每處字詞差異",
          "why": "現頁只保留互見指示，沒有這段逐句比較；6.27多出君子二字，也不能反過來說兩章逐字完全相同。"
        },
        {
          "id": "d",
          "text": "合併為一章處理",
          "why": "章次仍分列於兩篇，未作合併。"
        }
      ],
      "answerId": "a",
      "explanation": "現頁12.15注寫『見雍也篇第六』，可循往6.27相關注釋，兩個章次仍各自保留。重出與互見可以直接觀察，卻不能僅凭此例確定成書於眾手等編纂史。這份固定語料的12.15譯文欄只存互見提示，完整譯文尚缺；這一缺口仍保留明示。",
      "review": {
        "version": "editorial-serial28-b0fc89a3c415240d",
        "sha256": "b0fc89a3c415240d13f206e82d9a4147d718df10da9ab26e781ffc97dad00bd0",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-16",
      "type": "linkage",
      "refs": [
        352,
        359,
        339
      ],
      "concepts": [
        "zheng"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "辨三章表達方式的差別，不只重述正己共同主題",
      "stem": "三章都涉及正己。哪一組說明還準確指出它們各自怎樣表達？",
      "options": [
        {
          "id": "a",
          "text": "甲正反對照身正與令行；乙以反問連結正身和正人；丙在問政對答中以正釋政並勸帶頭"
        },
        {
          "id": "b",
          "text": "甲先以正釋政再答季康子；乙借天體位置作比；丙只記一次命令執行的實際結果",
          "why": "問政對答及以正釋政在丙；乙没有天體比喻，丙也没有一次命令實際執行情況的敘事。"
        },
        {
          "id": "c",
          "text": "甲乙丙依次記同一事件的三個時刻，因此可還原先下令、後正身、最後眾人服從的過程",
          "why": "這三段是不同章句，沒有共同事件及時間標記，不能憑排列拼出事件過程或因果驗證。"
        },
        {
          "id": "d",
          "text": "甲乙丙都只陳述治理者的身分和職位，沒有把其自身行為與他人反應相連",
          "why": "甲有行與不從，乙有正人，丙有孰敢不正；不能漏去这些把自身与他人相连的表述。"
        }
      ],
      "answerId": "a",
      "explanation": "共同主題相近不代表寫法相同：甲用正反兩面對照，乙以反問強調正己與正人的關係，丙針對季康子問政作答。這些表述可以比較，但不是先後發生的同一事件，也沒有獨立驗證所有制度只靠正己便有效。辨出共同主張之後，還須分別對應各章的文字形式。",
      "context": "甲／13.6：其身正，不令而行；其身不正，雖令不從。\n乙／13.13：苟正其身矣，於從政乎何有？不能正其身，如正人何？\n丙／12.17：季康子問政。孔子答政者正也，子帥以正，孰敢不正？",
      "review": {
        "version": "editorial-serial28-61f6a12fd3480c27",
        "sha256": "61f6a12fd3480c27b305568b3224ad2da7e29cfd1bdd76fe571ae0498f27f990",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-17",
      "type": "linkage",
      "refs": [
        123,
        277
      ],
      "concepts": [
        "xue",
        "jiaoxue"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "兩次問好學的答案一致",
      "stem": "哀公問「弟子孰為好學」（6.3）與季康子問同一問題（11.7），孔子的回答有何一致之處？",
      "options": [
        {
          "id": "a",
          "text": "都只舉顏回一人，且都說今也則亡"
        },
        {
          "id": "b",
          "text": "都列舉了多位弟子的長處",
          "why": "兩次都只提顏回，未作列舉。"
        },
        {
          "id": "c",
          "text": "都回答說弟子們各有所長，難以評比",
          "why": "他給了明確且唯一的答案。"
        },
        {
          "id": "d",
          "text": "都拒絕回答提問者，未提任何弟子姓名",
          "why": "兩章都明確提到顏回；問者分別是哀公和季康子，不宜統稱國君。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章都稱顏回好學，並以短命去世、今也則亡作答；6.3還說不遷怒、不貳過，11.7的注也提醒前一答語較詳。可以比較這兩次回答的共同點與詳略，卻不能僅據這兩章宣稱全書只曾對一人使用好學之稱。",
      "review": {
        "version": "editorial-serial28-523c3496c897364f",
        "sha256": "523c3496c897364f4d68c16b4b0222276070ec6c5f265bda4a1b6e9fe9fabd5b",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-18",
      "type": "linkage",
      "refs": [
        220,
        147
      ],
      "concepts": [
        "jiaoxue",
        "xue"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "把之的兩種指向實際代入，再判斷與約我的對讀範圍",
      "stem": "將甲、乙兩說分別代入6.27，再與9.11比較，哪項推理正確？",
      "options": [
        {
          "id": "a",
          "text": "採甲時以禮約束的對象同屬人；採乙時是文，便不能直接把約文當成約我"
        },
        {
          "id": "b",
          "text": "採甲時之指文，採乙時之指君子，所以兩說對應的約束對象與題中標示相反",
          "why": "題中按現注已明列甲指君子、乙指文，不能在代入時交換兩者。"
        },
        {
          "id": "c",
          "text": "兩章都有文禮二字，因此無論採甲或乙，都已證明約之和約我完全同義且指同一人",
          "why": "共同用字不取消甲乙的對象差別；即使採甲，也只說同屬人，沒有證明6.27君子就是顏淵本人。"
        },
        {
          "id": "d",
          "text": "毛奇齡說之指文，所以9.11顏淵說的我也應改成文獻，而不再指顏淵",
          "why": "毛說針對6.27的之，不是給9.11的我改所指；不能把另一章的異解越界套用。"
        }
      ],
      "answerId": "a",
      "explanation": "先分別完成代入：甲為以禮約君子，乙為以禮約文。再看9.11的我，說話者顏淵明確以自身承受教導。採甲可比較同為約人的方向，採乙則須承認對象不同；兩說都不能僅靠相似字面變成已確定的同義原則或同一歷史事件的獨立驗證。",
      "context": "6.27：君子博學於文，約之以禮。\n現注列甲讀法：之指君子；乙讀法：毛奇齡以之指文。\n9.11顏淵說：夫子博我以文，約我以禮。",
      "review": {
        "version": "editorial-serial28-4abe812e0aa30eb7",
        "sha256": "4abe812e0aa30eb71b1e557d1171ce2e42b79fdb1be4cfb1abac788cf5d928d7",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-19",
      "type": "linkage",
      "refs": [
        71,
        166
      ],
      "concepts": [
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較富貴取捨的判準與比喻表達",
      "stem": "4.5「不以其道得之，不處也」與 7.16「不義而富且貴，於我如浮雲」的關係是？",
      "options": [
        {
          "id": "a",
          "text": "都以正當與否取捨富貴，7.16另以浮雲表達自身態度"
        },
        {
          "id": "b",
          "text": "前者容許富貴，後者反對富貴，二者衝突",
          "why": "7.16 限定在「不義而」三字，並未反對富貴本身。"
        },
        {
          "id": "c",
          "text": "後者是前者的例外情況",
          "why": "兩章所引都拒絕不正當取得的富貴，7.16沒有另設條件來撤去4.5的要求。"
        },
        {
          "id": "d",
          "text": "前者對君子說，後者是孔子自述，標準不同",
          "why": "兩段所引都限定不正當取得的富貴；說話形式不同，本身不足以證明富貴取捨的標準不同。"
        }
      ],
      "answerId": "a",
      "explanation": "4.5承認富貴為人所欲，同時提出取得須合其道；7.16以不義而富且貴為限定，用浮雲表達不取的態度。可比較判準與比喻表達，不應進一步捏造孔子是否曾咬牙、內心有無掙扎等無從核見的情節。",
      "review": {
        "version": "editorial-serial28-5d11ae66f89fc245",
        "sha256": "5d11ae66f89fc245cfe2b872854ddef00cf75cc909ed1469fcc8a92a9c3864de",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-20",
      "type": "linkage",
      "refs": [
        190,
        373
      ],
      "concepts": [
        "li",
        "ren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "區分德目的条件與接近關係",
      "stem": "8.2說恭慎勇直無禮會生弊病，13.27說剛毅木訥近仁。哪項對讀最能保留兩章的不同說法？",
      "options": [
        {
          "id": "a",
          "text": "前者明說需禮節制，後者只說近仁，均不可草率等同已成仁德"
        },
        {
          "id": "b",
          "text": "剛毅木訥四者優於恭慎勇直四者",
          "why": "兩章沒有把這兩組品質排列高下，也沒有說其中一組一概優於另一組。"
        },
        {
          "id": "c",
          "text": "孔子最重視的德目是禮",
          "why": "8.2 用禮作條件，13.27 則不涉禮，不能推出禮最重要。"
        },
        {
          "id": "d",
          "text": "德目之間互相衝突，難以兼備",
          "why": "8.2談缺禮的弊病，13.27談與仁相近，並未說這些品質不可能共同具備。"
        }
      ],
      "answerId": "a",
      "explanation": "8.2以無禮為條件，逐項說可能的弊病；13.27用近仁保留與仁的距離。可以據此練習辨條件與限定詞，但不能替13.27補出沒有明說的配合清單，也不能從兩例統計性地斷言孔子很少下絕對判斷。",
      "review": {
        "version": "editorial-serial28-211c8ac2fd4f268e",
        "sha256": "211c8ac2fd4f268ee4c6c0ff7841a7e7adbbb77633bb1e961b07c1d81f859219",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-21",
      "type": "linkage",
      "refs": [
        296,
        118
      ],
      "concepts": [
        "chushi",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "兩次言志的對照",
      "stem": "5.26（顏淵季路侍，各言爾志）與 11.26（四子侍坐言志）都是言志之章。兩者的共同結構是？",
      "options": [
        {
          "id": "a",
          "text": "由提問引出各人志向，再以陳述和回應展現差別"
        },
        {
          "id": "b",
          "text": "孔子考核弟子，評定高下並排名",
          "why": "11.26有對子路、曾點等的回應和評價，但沒有給全體弟子列名次；5.26也沒有作這種排名。"
        },
        {
          "id": "c",
          "text": "弟子們互相辯論，孔子居中裁決",
          "why": "章文未呈現弟子互相辯論後由孔子裁決的共同框架；11.26末尾是曾晳向孔子追問評語的理由。"
        },
        {
          "id": "d",
          "text": "孔子先立標準，弟子照標準回答",
          "why": "兩章都讓問答展開而未先公布統一答案；本頁楊譯毋吾以也另有年長未被用之解，不能拿它來證明完全不設限。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章都以各人言志形成對照。5.26還有弟子請孔子言志，11.26則有具體贊同、微笑與理由說明；可比較人物陳述的差別，卻不能把未排名說成完全沒有評價。5.26固定原文中夾有『輕字當刪』的校語，這一來源狀況仍保留可見。",
      "review": {
        "version": "editorial-serial28-cd36c2cac4370e0e",
        "sha256": "cd36c2cac4370e0ec17e0cd1696c9048bc0c4bab6e7c62885097fde994ad89bc",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "lk-22",
      "type": "linkage",
      "refs": [
        497,
        24
      ],
      "concepts": [
        "xiao",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較孝的外在行為與情感態度並保留制度語境",
      "stem": "對讀17.21對宰我的於女安乎之問及章末批評，再看2.8色難與代勞供食之辨，哪項概括較準確？",
      "options": [
        {
          "id": "a",
          "text": "兩章都追問感情與態度，但不等於任憑個人心安便可取消禮制"
        },
        {
          "id": "b",
          "text": "兩章都只看飲食衣物的數量，內心感受完全無關",
          "why": "17.21直接問心安，2.8以色難追問態度，不能只看供給的數量。"
        },
        {
          "id": "c",
          "text": "17.21已正式同意把所有人的三年之喪一律改為一年",
          "why": "章末仍責宰我不仁，並援父母三年懷抱與天下通喪，沒有宣布這種制度更改。"
        },
        {
          "id": "d",
          "text": "2.8認為只要替長者做事、供應酒食，就已完整盡孝",
          "why": "曾是以為孝乎正是在追問僅有代勞供食是否足夠，不能讀成肯定已足夠。"
        }
      ],
      "answerId": "a",
      "explanation": "17.21把居喪之爭引向心安與否，卻沒有止於宰我的安：章末仍從不仁、父母之愛和通喪批評他。2.8也不以代勞供食說盡孝，而提出色難。兩章可共同說明態度與情感不可被外在動作替代，不能由此推成禮制全由個人喜好決定。固定來源17.21首條注釋未標出⑴，譯文仍寫作『宰我間道』；這些字形與注號狀況保留明示。",
      "review": {
        "version": "editorial-serial28-e2a6714304d5f21c",
        "sha256": "e2a6714304d5f21c62367c790e159aa6b9d8f3b14d227d7553fd02911590893d",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-1",
      "type": "conflict",
      "refs": [
        410
      ],
      "concepts": [
        "ren",
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "分析何以報德反問所指出的區分",
      "stem": "14.34有人問以德報怨，孔子反問何以報德，接著說以直報怨、以德報德。哪項最能說明這個反問的作用？",
      "options": [
        {
          "id": "a",
          "text": "追問恩與怨都用恩惠回報時，對恩惠的酬答如何區分"
        },
        {
          "id": "b",
          "text": "他主張報復，認為怨必須還以怨",
          "why": "「直」是公正處置，不是還以怨；他保留了「以德報德」。"
        },
        {
          "id": "c",
          "text": "他認為怨恨應當忘掉，不必回應",
          "why": "「以直報怨」正是要有所回應，只是回應以公。"
        },
        {
          "id": "d",
          "text": "他認為德只能施於君主",
          "why": "章中並無這樣的身分限定，說的是一般的待人之道。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子先追問如何報德，再提出以直報怨、以德報德。可據此理解為要求區別兩種回應，而直依現頁譯文指公平正直。現注說老子亦有相近語句，並推測當時可能流行；這不足以證明孔子在與老子直接辯論。",
      "review": {
        "version": "editorial-serial28-c1166aaff3ede563",
        "sha256": "c1166aaff3ede563be31ed23aa61cb95565a3dbcb09ef07f78f58817ac68c97f",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-2",
      "type": "conflict",
      "refs": [
        364,
        84
      ],
      "concepts": [
        "xiao",
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較父子相隱與事親婉諫的文本界線",
      "stem": "13.18葉公以子告父為直，孔子以父子相隱為直；4.18又說事父母幾諫。依兩章，哪項概括較有依據？",
      "options": [
        {
          "id": "a",
          "text": "孔子重視親子相護，也要求婉諫父母，不能化約成贊同一切過失"
        },
        {
          "id": "b",
          "text": "孔子與葉公對子告父的評價完全一致",
          "why": "孔子明說吾黨之直者異於是，並以相隱為不同的表現。"
        },
        {
          "id": "c",
          "text": "兩章已證明當時沒有任何法律，所以不存在倫理問題",
          "why": "兩章沒有這種制度史結論，不能以未交代制度推定制度不存在。"
        },
        {
          "id": "d",
          "text": "4.18要求婉諫，就證明13.18其實贊同子告父",
          "why": "婉諫父母與向外告發不是同一行為；不能以一章撤銷另一章的明文。"
        }
      ],
      "answerId": "a",
      "explanation": "13.18爭論何以為直，現注以孝慈說明父子相隱；4.18則保留對父母過失的婉諫。可據此討論親子責任與其他倫理要求的張力，但不能把相隱等同贊同父母一切行為，或把這兩章當作完整司法制度的描述。",
      "review": {
        "version": "editorial-serial28-a282e65e215f4233",
        "sha256": "a282e65e215f4233e9d6799b062a8aa0a0cd8c8f12ab734a302eef5ca3aea33f",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-3",
      "type": "conflict",
      "refs": [
        197,
        459
      ],
      "concepts": [
        "zheng",
        "jiaoxue"
      ],
      "difficulty": 2,
      "cognitive": "evaluate",
      "purpose": "評估處理文本張力的方法與證據界線",
      "stem": "本頁楊注反對為回護孔子而另斷8.9；15.39又說有教無類。研究兩章是否衝突時，哪種處理較能保留證據？",
      "options": [
        {
          "id": "a",
          "text": "先分辨語境與字義，保留注者立場，再說明仍待解釋的張力"
        },
        {
          "id": "e",
          "text": "以最早成篇的一章為準，其餘從之",
          "why": "題內沒有兩章成篇先後的證據；即使能判定早晚，也仍須分析各章語境與字義，不能只以較早便要求其餘從之。"
        },
        {
          "id": "b",
          "text": "以 8.9 為準，判定孔子主張愚民，「有教無類」只是口號",
          "why": "這先把另一章貶為口號，沒有分辨8.9與15.39各自的議題；現頁注者也不是對8.9完全沒有判斷。"
        },
        {
          "id": "c",
          "text": "兩句都不必當真，古書多有矛盾",
          "why": "兩章之間可能有張力，不等於兩句都無需考察；仍須分別說清它們的語境、主張與可據的證據。"
        },
        {
          "id": "d",
          "text": "把 8.9 改讀成與 15.39 一致，衝突自然消失",
          "why": "另讀須有語法、版本與語境證據；不能只因想讓兩章一致就改讀。"
        }
      ],
      "answerId": "a",
      "explanation": "先保留兩章與現頁注釋的實際說法，再比較政治引導與施教對象等語境，說清相容或衝突的理由。這種方法不預先保證沒有矛盾，也不把出現次數當作一章真偽或效力的自動判準。",
      "review": {
        "version": "editorial-serial28-81c13572b6affa4b",
        "sha256": "81c13572b6affa4b037a21940c4d495a60a4dfc1feac44782ebf0991d76b88c7",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-4",
      "type": "conflict",
      "refs": [
        392,
        62
      ],
      "concepts": [
        "ren",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "同一人不同面向的評價衝突",
      "stem": "孔子說管仲「不知禮」，又說他「如其仁」。有人據此說孔子自相矛盾。最好的回應是？",
      "options": [
        {
          "id": "a",
          "text": "分項評價：禮不合格而功業許其仁"
        },
        {
          "id": "b",
          "text": "確實矛盾，說明孔子沒有一貫標準",
          "why": "兩章評價的具体行為不同，不能僅以褒貶並存就證明同一標準前後矛盾。"
        },
        {
          "id": "c",
          "text": "「如其仁」是反話",
          "why": "14.16是在回答子路，先列九合諸侯、不以兵車的功業，現頁譯文明確作肯定，不支持反話說。"
        },
        {
          "id": "d",
          "text": "其中一章必為後人所竄改",
          "why": "並無版本依據支持這樣的判斷，是為消解矛盾而作的假設。"
        }
      ],
      "answerId": "a",
      "explanation": "3.22批評管仲使用禮制器物等行為，14.16則肯定其促成諸侯盟會、不用兵車的作用。這兩章可按評價對象分別理解，不必把某方面的肯定擴張為全人全事皆正確；也不足推出孔子在所有場合都採同一評價方法。",
      "review": {
        "version": "editorial-serial28-b33f6a0a03d58709",
        "sha256": "b33f6a0a03d58709796f10dc3c14c69bbe992fc2f4f70e259ba48752b6d3f358",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-5",
      "type": "conflict",
      "refs": [
        501
      ],
      "concepts": [
        "zhiren",
        "jiaoxue"
      ],
      "difficulty": 2,
      "cognitive": "evaluate",
      "purpose": "评估未知历史动机能否取消对文本概括的有据评价",
      "stem": "只依据本页文字及下列明确给出的评价准则，乙的推论有什么问题？",
      "options": [
        {
          "id": "a",
          "text": "乙把查明历史动机当成一切文本评价的前提；甲可按公开准则评议该概括，并保留对动机的未知"
        },
        {
          "id": "b",
          "text": "甲批评了这项概括，就必然已经断定当时所有人的观念完全相同",
          "why": "甲限定评价对象为本页概括，并明确未作全时代判断；从局部批评推出全体一致，扩大了甲的主张。"
        },
        {
          "id": "c",
          "text": "只要具体背景还未知，文本中已经呈现的概括便没有任何可讨论的内容",
          "why": "背景未知不抹除现有文字；可以区分已呈现内容、所用评价准则及尚待考证的动机，而不是取消所有讨论。"
        },
        {
          "id": "d",
          "text": "只要甲明确提出平等准则，就能据此证明作者的全部真实动机及本章传本真伪",
          "why": "公开准则说明如何评价，并不能代替历史动机、版本或传承的证据；不能由价值判断反推这些事实已获证明。"
        }
      ],
      "answerId": "a",
      "explanation": "题设把对象与准则说清：甲评议的是本页的性别概括，并未声称掌握全部背景。可以检验其准则是否一致、评价是否准确对应文字，同时保留待考的历史问题。乙把未知动机扩大成任何评价都不能作，论证过度；反过来，批评成立也不自动证明所有动机或版本事实。此题不要求读者接受古人的概括，也不把某种现代准则伪称为原章本意。",
      "context": "本页17.25译文把女子与小人概括为难以共处。\n甲以不因性别概括人的品行为准则，批评这项概括；甲没有断言已经查明作者的全部动机或当时所有人的观念。\n乙说：既然具体背景和作者动机还没有查明，现在便不能对这项文字概括作任何评价。",
      "review": {
        "version": "editorial-serial28-08220234f7dccfdb",
        "sha256": "08220234f7dccfdb60e494b1aee82064516600bff016a63ff2b453610c945faa",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-6",
      "type": "conflict",
      "refs": [
        508,
        414
      ],
      "concepts": [
        "chushi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "檢查行動分歧是否足以證明所有前提相同及證據無用",
      "stem": "依18.6與14.38，怎樣評估「雙方所有事實前提相同，所以任何新證據都無助於討論」這項結論？",
      "options": [
        {
          "id": "a",
          "text": "材料顯示行動取向不同，尚不足證全部前提相同或任何新證據必無作用"
        },
        {
          "id": "b",
          "text": "只要同處亂世，就能確定雙方所有事實判斷完全一致",
          "why": "共同面對亂世不等於對可能途徑、條件及效果的每個判斷都相同；材料沒有逐項證明這點。"
        },
        {
          "id": "c",
          "text": "只要行動取向不同，就能確定其中一方不知道天下混亂",
          "why": "不同的行動選擇不必全由不知道共同處境造成，不能只由取向差異倒推出此項事實無知。"
        },
        {
          "id": "d",
          "text": "晨門說知其不可，就證明任何改變嘗試客觀上永遠無效",
          "why": "晨門的評語不等於跨一切條件的客觀可行性證明，亦不能因此取消未來查核新材料的可能。"
        }
      ],
      "answerId": "a",
      "explanation": "先把可觀察的分歧與額外前提分開：章中可見避世與參與改變的不同取向，卻沒有逐項證明雙方對所有事實完全同意。即使存在價值分歧，也不能直接推出任何新證據都無助討論。晨門的話須保留其發言者與語境，不能當成一切改變永久無效的定理。",
      "context": "桀溺以天下滔滔質疑改變的可能；孔子表示仍須與人群打交道，並在天下未有道時參與改變；晨門另有知其不可而為之的評語。以下只評估這些材料能支持多大的推論。",
      "review": {
        "version": "editorial-serial28-433524b26cfe3895",
        "sha256": "433524b26cfe3895ed3cfc0dc89ae2c0355b36a06c739de9cff92fc7f0d79d59",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-7",
      "type": "conflict",
      "refs": [
        497
      ],
      "concepts": [
        "xiao",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "evaluate",
      "purpose": "區分論點切題、前提成立與說服對方",
      "stem": "宰我以三年不為禮樂則禮壞樂崩反對長喪。依17.21，哪項最恰當地評估這條理由的作用與限制？",
      "options": [
        {
          "id": "a",
          "text": "它切中長喪的可能代價，但禮樂必壞的前提仍需論證"
        },
        {
          "id": "b",
          "text": "完全無理，只是為自己貪圖安逸找藉口",
          "why": "孔子責不仁並提出父母之愛等理由，這不等於文本已證明宰我的每個論點都只是藉口。"
        },
        {
          "id": "c",
          "text": "有理，所以孔子接受了他的主張",
          "why": "孔子說女安則為之後仍責宰我不仁，並以父母之愛及天下通喪表明立場；不能把這句話讀成正式同意縮短喪期。"
        },
        {
          "id": "d",
          "text": "這個理由與喪期無關，屬於答非所問",
          "why": "這條理由把停止禮樂實踐與喪期長短相連，屬相關論點；是否足以成立則仍須另辨。"
        }
      ],
      "answerId": "a",
      "explanation": "宰我從長喪對禮樂的可能影響提出理由，孔子則問安否，再以父母之愛和通喪表明立場。應區分理由切題、前提已獲證實、對方接受結論三件事。本章不支持因孔子未逐條反駁就判宰我的前提已證，也不支持把女安則為之讀成正式同意縮短。",
      "review": {
        "version": "editorial-serial28-4039f845b94971f8",
        "sha256": "4039f845b94971f8228a6802693c36a14712bd622dcd79325d272b53b6d41685",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-8",
      "type": "conflict",
      "refs": [
        479,
        478
      ],
      "concepts": [
        "xue",
        "jiaoxue"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較性習與不移並保留注釋的異解",
      "stem": "對讀17.2性相近、習相遠與17.3唯上知與下愚不移，并考慮本頁對上知下愚所列異說，哪種說法較審慎？",
      "options": [
        {
          "id": "a",
          "text": "通則與兩端例外是一種讀法，但兩端所指仍須交代異說與依據"
        },
        {
          "id": "b",
          "text": "後者推翻了前者，孔子最終認為天賦決定一切",
          "why": "篇章次序不直接提供言論年代，也未明說17.3撤回17.2；不能據此稱天賦決定一切是最終立場。"
        },
        {
          "id": "c",
          "text": "兩章毫無關係，只是編排相鄰",
          "why": "二章均涉及人的差異及能否變化，可以比較；但不能因相鄰便確認編者意圖。"
        },
        {
          "id": "d",
          "text": "兩章完全一致，沒有張力",
          "why": "17.2談性相近而習染相遠，17.3限定上知與下愚不移；仍須說明兩章各自範圍及兩端所指，不能未作比較就斷為完全同一主張。"
        }
      ],
      "answerId": "a",
      "explanation": "可以嘗試把性近習遠與兩端不移理解為一般情形及例外，但這是綜合讀法。現頁對上知下愚列出不同解釋，未把品質與知識等意涵完全統一。比較時需保留此限制，不將一種調和方案當作原文明說的唯一理論。",
      "review": {
        "version": "editorial-serial28-d80957e0b06781e5",
        "sha256": "d80957e0b06781e5b49cb52486ba5639cbc32e49039981e84c888d7a2f688fc0",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-9",
      "type": "conflict",
      "refs": [
        69,
        448
      ],
      "concepts": [
        "ren",
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "區分恰當好惡與對眾評的考察",
      "stem": "依本頁楊注，4.3唯仁者能好人能惡人著重好惡得其中；15.28則說眾好眾惡都必察。哪項對讀較準確？",
      "options": [
        {
          "id": "a",
          "text": "判斷好惡要恰當，對眾人評價仍須考察，兩者可以相容"
        },
        {
          "id": "b",
          "text": "衝突：一個要表態，一個要中立",
          "why": "必察要求考察評價根據，並不規定永遠保持中立，也未命令每次立即公開表態。"
        },
        {
          "id": "c",
          "text": "並存不了，孔子在此前後不一",
          "why": "兩章分別針對好惡的正當性與其形成過程，層面不同。"
        },
        {
          "id": "d",
          "text": "4.3 只適用於仁者，15.28 適用於常人",
          "why": "15.28沒有把仁者排除在考察要求之外，不能自行設定兩章各管一類人的分工。"
        }
      ],
      "answerId": "a",
      "explanation": "4.3現注強調所好惡得當，15.28則提醒不能直接接受眾人的好惡。兩者可共同討論如何形成較有根據的判斷，但不能因此判凡暫不表態者皆為鄉愿，或聲稱兩章已提供一套沒有餘留問題的完整程序。",
      "review": {
        "version": "editorial-serial28-9dbec837b2f71dfc",
        "sha256": "9dbec837b2f71dfc19e51fef87c585f9ee6e87b56b7423aba4a70dcf72fe36db",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-10",
      "type": "conflict",
      "refs": [
        201,
        397
      ],
      "concepts": [
        "chushi",
        "zheng"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "辨別退居言事的個案與對隱的普遍推論",
      "stem": "8.13說天下有道則見、無道則隱；14.21記孔子告老後仍以曾為大夫而不敢不告弒君之事。哪項對讀較審慎？",
      "options": [
        {
          "id": "a",
          "text": "退居後仍告事，不能僅憑這個個案把隱等同絕不言事"
        },
        {
          "id": "b",
          "text": "無法統一，孔子言行不一致",
          "why": "8.13未明文把隱界定成絕不言事，不能僅因14.21有告事行動就判定言行矛盾。"
        },
        {
          "id": "c",
          "text": "8.13 只是理論，孔子自己並不實行",
          "why": "14.21只記這次告事及其理由，不足判斷8.13只是從未實行的空言。"
        },
        {
          "id": "d",
          "text": "14.21 時魯國有道，故不適用 8.13",
          "why": "兩章沒有直接完成這個政治情勢對照；不能為求一致而自行補上魯國有道的前提。"
        }
      ],
      "answerId": "a",
      "explanation": "14.21現注明孔子已告老，他又以曾為大夫解釋告事。這支持區分退居狀態與具體責任，卻不證明此次告老就是8.13所說的隱，也不能由一例推出所有隱者的共同義務。",
      "review": {
        "version": "editorial-serial28-1e0f8b7b1c95a6ea",
        "sha256": "1e0f8b7b1c95a6ea2aed4fbc7da1d6e9d0cd863e559be0909c0c42d8a15ef88e",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-11",
      "type": "conflict",
      "refs": [
        481,
        483
      ],
      "concepts": [
        "chushi",
        "yili"
      ],
      "figures": [
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較兩次欲往敘述與文本的史實限制",
      "stem": "17.5公山弗擾召孔子與17.7佛肸召孔子，兩章都記子欲往和子路異議。哪項比較符合原文與本頁注釋？",
      "options": [
        {
          "id": "a",
          "text": "17.5答有用則為東周；17.7承認先言，再以堅白、匏瓜作答"
        },
        {
          "id": "b",
          "text": "兩章子路都逐字引用同一句老師先言，孔子都否認說過",
          "why": "17.5沒有這種引用；17.7引用後，孔子反而答然有是言也。"
        },
        {
          "id": "c",
          "text": "两章都只記孔子斥責子路，未給任何答語",
          "why": "17.5有為東周之答，17.7有堅白與匏瓜的比喻，均不能略去。"
        },
        {
          "id": "d",
          "text": "兩章均明記孔子已實際前往，因此史事不存在任何疑問",
          "why": "兩章記欲往，不等於記已往；17.5現注還明列史料間問題而存疑。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章均保存子路的異議，但問題與回答並不相同。17.5談如有用我則為東周，17.7才承認先言并作堅白與匏瓜之喻。只能先就敘述比較，不能臆定編者故意展示難堪、孔子著急等心理，亦不能跳過17.5注者對史事的保留。",
      "review": {
        "version": "editorial-serial28-633d21960f876473",
        "sha256": "633d21960f8764739c1c6194442c6a6d0fdbb9a3a59f3e8a8a5e580e32d992e0",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-12",
      "type": "conflict",
      "refs": [
        162,
        166
      ],
      "concepts": [
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較求富與拒絕不義富貴的限定條件",
      "stem": "7.12「富而可求也，雖執鞭之士，吾亦為之」與 7.16「不義而富且貴，於我如浮雲」是否矛盾？",
      "options": [
        {
          "id": "a",
          "text": "前者討論可求與不可求，後者拒絕不義所得，不能簡化成要富與不要富"
        },
        {
          "id": "b",
          "text": "矛盾：一個要富，一個不要富",
          "why": "7.12有可求與不可求的假設，7.16限定不義所得，均不是無條件表態。"
        },
        {
          "id": "c",
          "text": "不矛盾：兩句都在說孔子想發財",
          "why": "7.12保留不可求則從吾所好的選擇，7.16拒絕不義所得並說清貧中有樂；不能把兩章都縮成想發財。"
        },
        {
          "id": "d",
          "text": "矛盾：反映孔子早晚年思想的變化",
          "why": "題內沒有兩段言論的年代證據，而已有不同限定條件可供比較，不能逕稱早晚年思想轉變。"
        }
      ],
      "answerId": "a",
      "explanation": "7.12以可求、不可求分說，7.16則把不義所得富貴看作浮雲，並說清貧中亦有樂。兩章可相容，但不能省去7.12的假設，或把可求逕自換成另一套未明說的詞義。",
      "review": {
        "version": "editorial-serial28-06fedc0ed81461f2",
        "sha256": "06fedc0ed81461f2beac1858479f020524162ab069cae70bad923d4a274e4361",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-13",
      "type": "conflict",
      "refs": [
        370,
        445
      ],
      "concepts": [
        "zhiren",
        "zhongyong"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較稱譽的考驗與評價者的區分",
      "stem": "15.25「如有所譽者，其有所試矣」與13.24對鄉人好惡的回答，對評價人的根據各有何要求？",
      "options": [
        {
          "id": "a",
          "text": "稱譽有考驗根據，對鄉人好惡還須分辨評價者，不能只看一致與否"
        },
        {
          "id": "b",
          "text": "不應該評價任何人",
          "why": "「如有所譽者」表明他確實會稱譽，只是有條件。"
        },
        {
          "id": "c",
          "text": "應當以多數人的評價為準",
          "why": "13.24不以一鄉皆好或皆惡作充分判準，還區分善者與不善者；這並不等於所有多數評價必錯。"
        },
        {
          "id": "d",
          "text": "只能評價自己認識的人",
          "why": "現譯強調曾經考驗，沒有將是否熟識列為唯一資格，也未窮盡考驗的具体方式。"
        }
      ],
      "answerId": "a",
      "explanation": "15.25把稱譽與曾經考驗相連，13.24則不滿足於鄉人一致好惡，而區分善者與不善者的評價。可綜合為重視根據且不僅隨眾，但不能直接把試泛化成隨便說得出一個理由，或宣稱本章已制定涵蓋所有評價情形的完整規則。",
      "review": {
        "version": "editorial-serial28-839a1d406b7a4d04",
        "sha256": "839a1d406b7a4d0415850be774712213436dcaf94b257c614dcccc0b267f3730",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-14",
      "type": "conflict",
      "refs": [
        499,
        190
      ],
      "concepts": [
        "yili",
        "li"
      ],
      "figures": [
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較義與禮對勇的制約，避免把條件當成存在前提",
      "stem": "17.23說君子義以為上，有勇無義為亂；8.2說勇而無禮則亂。哪項對讀較準確？",
      "options": [
        {
          "id": "a",
          "text": "兩章都指出勇需受規範，分別著重義與禮，不能因此說二者全同"
        },
        {
          "id": "b",
          "text": "兩章都直接否定一切勇，認為人完全不應勇敢",
          "why": "兩章指出的是勇缺少義或禮的危害，未一概否定勇。"
        },
        {
          "id": "c",
          "text": "認為只有君子可以有勇",
          "why": "17.23明说小人也可能有勇，因此勇並非君子身分的專有能力。"
        },
        {
          "id": "d",
          "text": "兩章都沒有討論勇的運用，義與禮只是無關的話題",
          "why": "17.23就尚勇提出義的優先，8.2也明說勇無禮的後果，都與勇的運用相關。"
        }
      ],
      "answerId": "a",
      "explanation": "17.23不是說有義才可能有勇，而是指出有勇無義的危害並把義置上；8.2則談無禮之勇。可比較兩章的制約關係，同時保留義、禮用語的差異，不把一次分析推成孔子處理全部德目問題的唯一模式。",
      "review": {
        "version": "editorial-serial28-0a1a64f1587d10eb",
        "sha256": "0a1a64f1587d10eb2acce18c9b953eff09d42c98dc92421d9607e08929446de8",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-15",
      "type": "conflict",
      "refs": [
        146
      ],
      "concepts": [
        "ren",
        "zhiren"
      ],
      "figures": [
        "zaiwo"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "根據欺罔之辨檢查假設推論，保留逝字異解",
      "stem": "6.26以井有仁設問，本頁注又用欺以其方、難罔以非其道說明可欺不可罔。依此，哪項概括較有根據？",
      "options": [
        {
          "id": "a",
          "text": "不能因君子可能被欺騙，就推出能用不合道理的說法使他自陷"
        },
        {
          "id": "b",
          "text": "仁者遇到危險應當立刻迴避",
          "why": "本章區分可與不可的情況，沒有制定遇到一切危險都立即逃避的規則；可逝在現注也非單純前往之義。"
        },
        {
          "id": "c",
          "text": "仁者應當不顧一切地跳下去救人",
          "why": "原文明說不可陷，注以非理陷害說明其限制；不能將行仁推成無條件接受這項設問而跳下井。"
        },
        {
          "id": "d",
          "text": "宰我的問題很無聊，孔子拒絕回答",
          "why": "孔子明列可逝與不可陷、可欺與不可罔的區別，是對設問作出回應。"
        }
      ],
      "answerId": "a",
      "explanation": "現頁以孟子所說欺以其方、難罔以非其道來辨欺與罔，重點不是把行仁等同無條件自陷。逝字另有往而不返與折的解讀，不能把本頁說法偷換成一定可以前往救人。這種倫理分別也不宜擴張為現實中仁者永不受操控的保證。",
      "review": {
        "version": "editorial-serial28-b76913bc267648bc",
        "sha256": "b76913bc267648bce7e6e7c7634648657cac15650a8e67b6b9519f33a0cf1d1f",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "cf-16",
      "type": "conflict",
      "refs": [
        88,
        461
      ],
      "concepts": [
        "xin",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較言行相副與達意的要求",
      "stem": "孔子既說「古者言之不出，恥躬之不逮也」（慎言），又說「辭達而已矣」。兩者的關係是？",
      "options": [
        {
          "id": "a",
          "text": "前者顧慮行動趕不上言語，後者重視達意，兩種要求可以並行"
        },
        {
          "id": "b",
          "text": "衝突：一個要少說，一個要說清楚",
          "why": "慎言關注言行是否相副，達意關注表達是否清楚，二者並不因少說與清楚而必然對立。"
        },
        {
          "id": "c",
          "text": "兩者都主張不必說話",
          "why": "「辭達」正要求把意思說到位。"
        },
        {
          "id": "d",
          "text": "「辭達而已矣」是說話越少越好",
          "why": "「達」是達意的標準，不是數量標準。"
        }
      ],
      "answerId": "a",
      "explanation": "4.22說言語不輕易出口，是怕行動趕不上；15.41則以達意為表達要求。可以同時做到言行相副與清楚表達，不必分成嚴格的出口前後程序。現注批評過於浮華的詞藻，也不能改成孔子一概不欣賞文采。",
      "review": {
        "version": "editorial-serial28-dfc3d3c589875be0",
        "sha256": "dfc3d3c589875be091995254030a5dae9f1f2d83626ce3189af59c0aa0382136",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zilu-1",
      "type": "figure",
      "refs": [
        292
      ],
      "concepts": [
        "jiaoxue"
      ],
      "figures": [
        "zilu",
        "ranyou"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "由性情差異解釋同問異答",
      "stem": "「聞斯行諸？」子路問，孔子說有父兄在，不能聽到就做；冉有問，孔子讓他聽到就做。孔子明說的理由是？",
      "context": "公西华曰：“由也问闻斯行诸，子曰‘有父兄在’；求也问闻斯行诸，子曰‘闻斯行之’。赤也惑，敢问。”",
      "options": [
        {
          "id": "a",
          "text": "求也退故進之，由也兼人故退之"
        },
        {
          "id": "b",
          "text": "子路年長，責任較重，所以要慎重",
          "why": "孔子以冉求退縮、仲由勇於作為說明差別；本頁注不採兼人即好勝的解讀。"
        },
        {
          "id": "c",
          "text": "冉有的家境不同，父兄不在",
          "why": "本章未說冉有父兄不在；孔子明以退與兼人說明不同勸告，不能另補家庭狀況。"
        },
        {
          "id": "d",
          "text": "孔子隨口而答，並無深意",
          "why": "本章明記孔子以求也退、由也兼人回答公西華，不能說答語沒有理由。"
        }
      ],
      "answerId": "a",
      "explanation": "公西華追問同問異答，孔子分別以退縮與勇為說明勸進、勸退。這是文本對教學理由的交代，可以討論補偏；但本章沒有記錄後續學習成效，不能把理由清楚當成效果已獲驗證。",
      "review": {
        "version": "editorial-serial28-a875c4ba34ec6345",
        "sha256": "a875c4ba34ec6345ad841b380412f73ae53ba2296a980fec648f4667301fd523",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zilu-2",
      "type": "figure",
      "refs": [
        99,
        236
      ],
      "concepts": [
        "junzi",
        "yili"
      ],
      "figures": [
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較子路受肯定與受提醒的不同範圍",
      "stem": "5.7孔子說從我者其由與，又說好勇過我；9.27稱子路不恥敝袍，又說僅此何足以臧。哪項對讀較有依據？",
      "options": [
        {
          "id": "a",
          "text": "肯定某一表現並不等於已臻完善，兩章仍分別提出限制"
        },
        {
          "id": "b",
          "text": "兩章都先承認選錯了學生，隨即完全否定子路",
          "why": "兩章均保存具體肯定，後續限制不等於撤銷对子路一切能力的評價。"
        },
        {
          "id": "c",
          "text": "兩章已證明子路完成了實際出海計畫",
          "why": "本題兩章沒有記錄這種行動結果，不能由浮海之語補出已完成的行程。"
        },
        {
          "id": "d",
          "text": "兩章都完全沒有批評，只有無條件的讚賞",
          "why": "好勇過我與何足以臧都使評語有所限制，不能刪去其提醒作用。"
        }
      ],
      "answerId": "a",
      "explanation": "5.7先推測可能跟隨自己的會是子路，隨後批評其過於好勇；9.27則區分不恥敝袍與是否已足稱善。可比較肯定與限制的範圍，而不據此建立孔子每次都先讚後抑的固定模式。5.7材字在本頁讀哉，注者另列而不採裁度說，應保留這個訓釋界線。",
      "review": {
        "version": "editorial-serial28-789758c929825546",
        "sha256": "789758c929825546ecb20c9e9c9efe974266184f8906ffc0da5de39c6f1c9094",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-yanhui-1",
      "type": "figure",
      "refs": [
        25
      ],
      "concepts": [
        "xue",
        "jiaoxue"
      ],
      "figures": [
        "yanhui"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "辨別如愚的表象及退而省其私的不同讀法",
      "stem": "2.9由不違如愚說到亦足以發、回也不愚。依本頁楊譯及所收朱熹異解，哪項概括較準確？",
      "options": [
        {
          "id": "a",
          "text": "表面不提異議不等於愚；退後自研與老師察私行是頁內不同讀法"
        },
        {
          "id": "b",
          "text": "孔子一開始就知道顏回聰明，只是說反話",
          "why": "本文沒有證明這全是反話；本頁也並非只採孔子退後觀察顏回的解讀。"
        },
        {
          "id": "c",
          "text": "顏回確實愚鈍，只是肯用功",
          "why": "結語「回也不愚」是明確的否定。"
        },
        {
          "id": "d",
          "text": "顏回善於在老師面前掩飾",
          "why": "「亦足以發」是稱許其能發揮，不是掩飾。"
        }
      ],
      "answerId": "a",
      "explanation": "本文由看似愚轉到能發揮、不愚。現頁主譯作顏回退後自己研究，注釋另承認孔子察其私行的說法可通。不能抹去主語解讀的差別，也不能把如愚當作孔子曾斷定他愚的確證。",
      "review": {
        "version": "editorial-serial28-5d5b6369a3dc70d0",
        "sha256": "5d5b6369a3dc70d00d1f4c179fb01a875b8d270f56919feb4a7d29114ed1dec2",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-yanhui-2",
      "type": "figure",
      "refs": [
        278,
        279,
        280,
        281
      ],
      "concepts": [
        "li",
        "tianming"
      ],
      "figures": [
        "yanhui"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較哀痛與喪儀安排的具體依據",
      "stem": "孔子為顏淵死而哭慟，又反對厚葬、拒絕售車置槨。對讀11.8—11.11，哪項概括較有依據？",
      "options": [
        {
          "id": "a",
          "text": "深切哀痛可以與對家力、身分及喪儀分寸的顧慮並存"
        },
        {
          "id": "b",
          "text": "孔子並不像表面那樣看重顏回",
          "why": "11.9的天喪予與11.10的哭慟明示哀痛，不能僅因反對厚葬便說他不重視顏回。"
        },
        {
          "id": "c",
          "text": "孔子捨不得財物",
          "why": "11.8舉自己兒子無槨，又說曾為大夫不可徒行，提供了比單純吝財更具體的理由。"
        },
        {
          "id": "d",
          "text": "厚葬在當時是不合法的",
          "why": "門人實施厚葬不等於已證明合法或違法；11.11現注著重家力與禮，沒有提供該斷言的法律依據。"
        }
      ],
      "answerId": "a",
      "explanation": "11.9、11.10記哀痛；11.8說明拒售車置槨的理由，11.11反對厚葬且現注談家力與禮。可以比較情感與具體喪儀選擇，不能把哭慟簡化成失去一切分寸，也不能把奢厚直接等同有愛或把反對厚葬直接等同無情。",
      "review": {
        "version": "editorial-serial28-593be069a4436de4",
        "sha256": "593be069a4436de4712f266d301df4adcff306f9b1e32df3b8975c434ff67ebe",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zigong-1",
      "type": "figure",
      "refs": [
        405,
        286
      ],
      "concepts": [
        "zhiren",
        "junzi"
      ],
      "figures": [
        "zigong"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較反問譏評者與辨別過不及的答法",
      "stem": "14.29子貢方人，孔子反問賜也賢乎哉；11.16子貢問師與商孰賢，孔子答過猶不及。哪項比較較準確？",
      "options": [
        {
          "id": "a",
          "text": "前者反問評人者自身，後者分辨過與不及，不把過分當成更好"
        },
        {
          "id": "b",
          "text": "兩章都按照單一高低順序列出所有弟子的排名",
          "why": "14.29沒有排名，11.16也以過猶不及否定過分就一定較好的推論。"
        },
        {
          "id": "c",
          "text": "嚴厲斥責他不該議論同門",
          "why": "兩章没有提出一律不准談同門的規則，且11.16確有對師與商的分別評語。"
        },
        {
          "id": "d",
          "text": "稱讚他有識人之明",
          "why": "14.29的反問與11.16對推論的修正，都不能直接化成對子貢識人能力的讚許。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章各有重點：14.29反問譏評者自身是否足夠好，11.16則在給出過、不及的評語後糾正過者必勝的推論。不能把它們說成孔子從不評人，也不能由此斷定子貢所有評人活動都同樣受批。",
      "review": {
        "version": "editorial-serial28-545f34930dc147f0",
        "sha256": "545f34930dc147f0336ff875524b8f233e02349d6f4a28564acbd5701c3defe6",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zigong-2",
      "type": "figure",
      "refs": [
        537,
        536
      ],
      "concepts": [
        "zhiren"
      ],
      "figures": [
        "zigong"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較子貢兩次護師比喻的不同作用",
      "stem": "19.23子貢用宮牆、19.24用丘陵與日月護師。哪項最能分辨兩種比喻的作用？",
      "options": [
        {
          "id": "a",
          "text": "宮牆說明難窺全貌，日月強調難以超越，都是子貢對老師的推重"
        },
        {
          "id": "b",
          "text": "自己的學問已經超過老師，但不便明說",
          "why": "宮牆之喻強調不易窺見孔子學問的全貌，日月之喻強調難以超越；兩章都在推重孔子，未暗示子貢已勝過老師。"
        },
        {
          "id": "c",
          "text": "老師的學問淺顯易懂，人人可入",
          "why": "宮牆之喻說不得其門則不能見內部豐富，並不是人人已能輕易窺見全部。"
        },
        {
          "id": "d",
          "text": "評價老師是不敬的行為，不該討論",
          "why": "他並未迴避，而是正面作了說明。"
        }
      ],
      "answerId": "a",
      "explanation": "19.23以牆高與能否入門解釋觀察者所見有限；19.24以丘陵和日月的不同高度表達對孔子的推重。兩者是子貢的評價與說服方式，不宜把比喻當作已測量的高下，也不能据此為弟子言語能力排第一。",
      "review": {
        "version": "editorial-serial28-15464eb7bbfc7a63",
        "sha256": "15464eb7bbfc7a6394c6204a5762d7fdafbc30b0d65fe659f2150b5a9342ada5",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zengzi-1",
      "type": "figure",
      "refs": [
        4
      ],
      "concepts": [
        "shu",
        "ren"
      ],
      "figures": [
        "zengzi"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨識三省所列內容並區分三字之義",
      "stem": "曾子「吾日三省吾身」，所省的三件事是？",
      "options": [
        {
          "id": "a",
          "text": "替人謀事是否盡心、交友是否誠信、所受傳授是否溫習實踐"
        },
        {
          "id": "b",
          "text": "事父母孝乎、事君忠乎、與友信乎",
          "why": "三省的內容明確為謀、交、傳三事，未列事父母與事君。"
        },
        {
          "id": "c",
          "text": "言不過行乎、行不違禮乎、心不怨乎",
          "why": "這三項並非本章文字，是仿其句式擬造的。"
        },
        {
          "id": "d",
          "text": "學而不思乎、思而不學乎、學而不習乎",
          "why": "這組學與思的說法不是1.4原列的謀事、交友與傳習三問。"
        }
      ],
      "answerId": "a",
      "explanation": "1.4以忠、信、習檢查替人謀事、交友及所受傳授。現注明說三省指多次反省，不是數字三恰好對應下列三件事；也不能只憑另章曾參魯的評語推斷這種反省方法是因遲鈍而產生。",
      "review": {
        "version": "editorial-serial28-4aa47926fc14a0f0",
        "sha256": "4aa47926fc14a0f02f0f5b2ded61027fa32547ece173e05bab3e39e8d971ae0a",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zengzi-2",
      "type": "figure",
      "refs": [
        191
      ],
      "concepts": [
        "li",
        "junzi"
      ],
      "figures": [
        "zengzi"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "解釋視手足、戒慎與知免的關係",
      "stem": "8.3曾子有疾，召弟子視手足並引戰戰兢兢等詩句，最後說吾知免夫。依本頁楊譯，重點是？",
      "options": [
        {
          "id": "a",
          "text": "藉手足保全與戒慎詩句，說自己如今才知免於禍害刑戮"
        },
        {
          "id": "b",
          "text": "他擔心弟子照顧不周，要檢查身體",
          "why": "本章確涉身體，但引詩及知免把話意連到戒慎與免禍，不能只當作即時醫護要求。"
        },
        {
          "id": "c",
          "text": "要弟子藉此學習侍疾之禮",
          "why": "章中没有逐項教授侍疾儀節，而是曾子自述戒慎及知免。"
        },
        {
          "id": "d",
          "text": "他後悔一生過於謹慎",
          "why": "他說如今才知道可以免於禍害刑戮，並未表示後悔此前的戒慎。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁把免解為免於禍害刑戮，引詩與視手足共同呈現戒慎守身的意思。這不等於對全部德行的一次最終驗收，也不宜僅憑相鄰章句就斷定這正是死亡當刻。",
      "review": {
        "version": "editorial-serial28-feb7dacf026b58a6",
        "sha256": "feb7dacf026b58a665e17d10fdc80deab8340b76c73e68dfc2bfbbd66a2a3c1d",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zaiwo-1",
      "type": "figure",
      "refs": [
        102,
        497
      ],
      "concepts": [
        "xiao",
        "li"
      ],
      "figures": [
        "zaiwo"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較宰我相關記載引出的識人與喪禮問題",
      "stem": "對讀5.10宰予晝寢及17.21宰我論喪期，對其文本作用哪項分析較有依據？",
      "options": [
        {
          "id": "a",
          "text": "前者連到聽言觀行，後者展開喪期與親愛之辯，不能據此定人物優劣之最"
        },
        {
          "id": "b",
          "text": "他是孔門最差的學生，記載他只為警示後人",
          "why": "另章11.3將宰我列於言語所長，不能只由責語斷其全人最差，或確定記錄只為警示。"
        },
        {
          "id": "c",
          "text": "他其實是孔子最欣賞的學生",
          "why": "這些責語不支持最欣賞的結論；人物各方面評語也不能只靠一句話排總名次。"
        },
        {
          "id": "d",
          "text": "他的記載都是後人偽造",
          "why": "判斷真偽須有相應史料或版本證據，不能僅因記載有責語就稱全部偽造。"
        }
      ],
      "answerId": "a",
      "explanation": "5.10把宰予事件連到聽言與觀行，現注提醒後段是另一場合之言；17.21則通過喪期問答展開禮樂、安否與父母之愛的討論。這是可觀察的文本作用，並不能證明沒有這位弟子孔子就不可能說出相應道理，或把答案排作全書最深。",
      "review": {
        "version": "editorial-serial28-44de12d44d3d9c56",
        "sha256": "44de12d44d3d9c56562d759a00a749ef993c58565abc005bf84a88081d9e17ed",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-ranyou-1",
      "type": "figure",
      "refs": [
        128,
        287,
        463
      ],
      "concepts": [
        "zheng",
        "yili"
      ],
      "figures": [
        "ranyou"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "區分從政才能與具體行事的責任",
      "stem": "冉有政事之才受孔子肯定，卻兩次因附從季氏遭嚴責。這條線索說明孔子看重什麼？",
      "options": [
        {
          "id": "a",
          "text": "從政有才並不免除聚斂、助伐及未盡輔佐之責"
        },
        {
          "id": "b",
          "text": "孔子反對弟子出仕做官",
          "why": "6.8肯定冉求的從政能力，兩次責備另有具體行為對象，不能泛化成反對所有弟子出仕。"
        },
        {
          "id": "c",
          "text": "孔子認為冉有能力不足",
          "why": "6.8 明說「求也藝，於從政乎何有」。"
        },
        {
          "id": "d",
          "text": "孔子與季氏有私怨",
          "why": "所引批評以聚斂、用兵與輔佐責任為理由，不能無據改寫成單由私怨而發。"
        }
      ],
      "answerId": "a",
      "explanation": "6.8肯定冉求多藝，11.17批評替季氏聚斂，16.1又論助伐與輔佐之責。才能與道義責任是不同問題。非吾徒也可見責備之重，但此處沒有足以確認正式除名程序、後續身分或此次任職推薦經過的記載。",
      "review": {
        "version": "editorial-serial28-ec48fd4f4d123450",
        "sha256": "ec48fd4f4d123450459554c6b370e385c04b975c32e70a2cdb2eadd643a691eb",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zixia-1",
      "type": "figure",
      "refs": [
        133,
        286
      ],
      "concepts": [
        "junzi",
        "xue"
      ],
      "figures": [
        "zixia"
      ],
      "difficulty": 2,
      "cognitive": "evaluate",
      "purpose": "辨別人物訓誡能否支持具體動機推論",
      "stem": "6.13勸子夏為君子儒、勿為小人儒；11.16說商也不及。僅憑這兩章，哪種推論最審慎？",
      "options": [
        {
          "id": "a",
          "text": "可辨有訓誡與不及評語，但尚不能確定其缺點就是以學問謀生"
        },
        {
          "id": "e",
          "text": "不及已證明子夏一生從未有過驕傲言行",
          "why": "不及是特定評語，不能用來排除其一生所有可能行為。"
        },
        {
          "id": "b",
          "text": "只要受過君子儒之誡，就證明整體品行必然不端",
          "why": "勸其向何種目標學習，不等於已給出全部品行的定罪結論。"
        },
        {
          "id": "c",
          "text": "既列文學之科，就必然各方面已臻最高而無須再學",
          "why": "所長的記錄不等於所有方面完善；11.16仍有不及的評語。"
        },
        {
          "id": "d",
          "text": "只要另一章曾受稱讚，就能排除這兩章包含任何勸誡",
          "why": "不同場合可有肯定與勸誡，不能以稱讚撤去6.13的明確勸語。"
        }
      ],
      "answerId": "a",
      "explanation": "這兩章保存對子夏的勸語與不及評語，但沒有交代足以唯一確定拘細節或謀生動機的細節。若提出某種人物解釋，應另列材料、推論與限制，不能以熟悉的人格標籤替代章句。",
      "review": {
        "version": "editorial-serial28-969102c336203ecc",
        "sha256": "969102c336203ecc07d0572d6d07ae12286a1b774d449bd060547f601b057193",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zizhang-1",
      "type": "figure",
      "refs": [
        342
      ],
      "concepts": [
        "zhiren",
        "junzi"
      ],
      "figures": [
        "zizhang"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "分析爾所謂達者的追問功能",
      "stem": "子張問士如何為達，孔子先問何哉爾所謂達者；聽到在邦必聞、在家必聞後，答是聞也非達也。這一追問有何作用？",
      "options": [
        {
          "id": "a",
          "text": "先查明子張用達所指為何，再指出他把達與有名望混在一起"
        },
        {
          "id": "b",
          "text": "只詢問子張是否聽清聲音，沒有涉及他所用的概念",
          "why": "孔子針對子張對達的說明回以聞非達，重點在含義而非聽覺。"
        },
        {
          "id": "c",
          "text": "聞指小名氣，達指大名氣",
          "why": "孔子並未把達改成更大名氣，而是先指出有名望不等於達。"
        },
        {
          "id": "d",
          "text": "聞在鄉里，達在邦國，範圍不同",
          "why": "子張的答語本就同時包括邦與家，不是只談一個較小地域。"
        }
      ],
      "answerId": "a",
      "explanation": "先問爾所謂達者，使子張交代自己的理解，孔子再指出在邦家有名望是聞，不能就此等同達。這是澄清概念後糾正等同關係的問答，不宜據此斷定子張內心只想求名。這份語料的12.20正文在察言後中斷，後半仍見於主譯；本題只據前段完整問答判斷追問作用，保留原文缺口。",
      "review": {
        "version": "editorial-serial28-0b7f385618405c19",
        "sha256": "0b7f385618405c199320fda0389e7dae82427eb3d8e80b163c8a3f3393dcd9d4",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-guanzhong-1",
      "type": "figure",
      "refs": [
        393
      ],
      "concepts": [
        "ren",
        "li",
        "zheng"
      ],
      "figures": [
        "guanzhong"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "分析孔子如何回應子貢以死殉主質疑管仲",
      "stem": "14.17子貢因管仲未為公子糾殉死而質疑其仁，孔子列管仲相桓公、一匡天下、民受其賜等功業。這些事例如何回應質疑？",
      "options": [
        {
          "id": "a",
          "text": "以對民眾與天下的作用，反對只憑是否殉死判定管仲"
        },
        {
          "id": "b",
          "text": "承認管仲必須殉死，接著證明他其實已經自殺",
          "why": "孔子列其後來輔相與功業，並未宣稱管仲已自殺。"
        },
        {
          "id": "c",
          "text": "日後有功，所以孔子主張管仲先前每一件事都無可批評",
          "why": "答語針對不死是否足以否仁，沒有宣告管仲所有行為皆正確。"
        },
        {
          "id": "d",
          "text": "只重視殉死者是否被人知道，對公共作用完全不談",
          "why": "民到於今受其賜等內容直接提出公共作用，不能略去。"
        }
      ],
      "answerId": "a",
      "explanation": "子貢以未死且又相桓公提出疑問，孔子則列治理與人民受益，並與匹夫匹婦之諒對照。這是在變更判斷所據的行為與影響，不等於以功業免除一切批評；本章也不是14.16如其仁之語的直接出處。",
      "review": {
        "version": "editorial-serial28-da6502d992f57927",
        "sha256": "da6502d992f57927d2b19f38f50b43babf84a5ed23678f03f5536381844ea2b5",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-minzi-1",
      "type": "figure",
      "refs": [
        275
      ],
      "concepts": [
        "xiao",
        "chushi"
      ],
      "figures": [
        "minziqian"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨別不間的主語與評論對象",
      "stem": "「孝哉閔子騫！人不間於其父母昆弟之言。」這句稱許的特別之處是？",
      "options": [
        {
          "id": "a",
          "text": "別人對其父母兄弟稱讚他的話沒有異議"
        },
        {
          "id": "b",
          "text": "他的父母兄弟從不批評他",
          "why": "人指別人；沒有異議的對象是父母兄弟稱讚他的話，不是斷言家人從不批評他。"
        },
        {
          "id": "c",
          "text": "他經常向人講述自己如何盡孝",
          "why": "本句講家人之言及別人的反應，沒有提供他經常自述孝行的資訊。"
        },
        {
          "id": "d",
          "text": "他的孝行被記載在史書中",
          "why": "這一句提出的是家人稱讚與他人無異議，不是援引一部史書為證。"
        }
      ],
      "answerId": "a",
      "explanation": "依現頁譯文，家人稱讚閔子騫，而別人對那些話没有異議。不能把它改成家人從不批評，也不能把家人評價說成全無分量；這一句本身不構成普遍要求外人一致稱好的評人規則。",
      "review": {
        "version": "editorial-serial28-f95563b87d3cf836",
        "sha256": "f95563b87d3cf836585975a5ef0b5f79e7da1bd195cf2d20ce8b6b47a6990acb",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-boyi-1",
      "type": "figure",
      "refs": [
        165
      ],
      "concepts": [
        "chushi",
        "ren"
      ],
      "figures": [
        "boyi",
        "zigong"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "還原側問推理並分清直接發言與推斷",
      "stem": "冉有想知道孔子是否支持衛君，子貢入內問「伯夷、叔齊何人也？」得答「古之賢人也……求仁而得仁，又何怨」，出來便說「夫子不為也」。他的推理是？",
      "options": [
        {
          "id": "a",
          "text": "依讓位與爭位的對照，從孔子許夷齊為賢推知對衛君的立場"
        },
        {
          "id": "b",
          "text": "孔子稱讚古人，就表示他厭惡當世的一切君主",
          "why": "推論過寬；子貢的推理針對的是爭位這一具體情形。"
        },
        {
          "id": "c",
          "text": "孔子說「何怨」，表示他不願捲入紛爭",
          "why": "「何怨」是說伯夷叔齊不悔其選擇，不是孔子表態迴避。"
        },
        {
          "id": "d",
          "text": "子貢的結論與所問古人全無關聯，也沒有任何文本根據",
          "why": "現注提供讓位與爭位的對照，可見並非全無根據；但夫子不為也是子貢的推斷，不是孔子的直接答句。"
        }
      ],
      "answerId": "a",
      "explanation": "子貢問古人而推知當時衛君的問題。依本頁注釋，夷齊讓位與衛國父子爭位形成對照，使這一推斷有脈絡。仍應分清孔子所說、子貢所推及注者的解釋，而非把比喻式對照當無須前提的普遍邏輯，或據此評出言語能力第一。",
      "review": {
        "version": "editorial-serial28-75203579c6bb3d2d",
        "sha256": "75203579c6bb3d2dd565669448a5f7a07e6000ee449121a94cc82e5340082d13",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zilu-3",
      "type": "figure",
      "refs": [
        285
      ],
      "concepts": [
        "jiaoxue",
        "zhiren"
      ],
      "figures": [
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "辨明升堂未入室對人物評價的雙重限制",
      "stem": "孔子說「由之瑟奚為於丘之門？」門人因此不敬子路，孔子後又說「由也升堂矣，未入於室也」。這一補充的作用是？",
      "options": [
        {
          "id": "a",
          "text": "既肯定已有相當學問，也說尚未精深，避免將先前批評讀成全無可取"
        },
        {
          "id": "b",
          "text": "進一步批評子路，強調他不夠格",
          "why": "「升堂矣」是肯定其已達相當程度。"
        },
        {
          "id": "c",
          "text": "說明子路的琴藝確實很差",
          "why": "現頁以學問階段解升堂入室，不能只當瑟藝很差的數值評分；對音調的批評也不等於全人皆不足取。"
        },
        {
          "id": "d",
          "text": "轉移話題，避免尷尬",
          "why": "後句直接說明子路的學問程度，與門人不敬的敘述相接；不能僅憑此補出轉移話題以免尷尬的動機。"
        }
      ],
      "answerId": "a",
      "explanation": "升堂與入室在現注中表示學問程度不同；答語既肯定已到一定階段，又保留未精深的限制。這有助修正門人因批評而生的輕視，不必臆測最初只是隨口，或把後續說明定為偏袒護短。",
      "review": {
        "version": "editorial-serial28-01ba9721b322c7b5",
        "sha256": "01ba9721b322c7b565989be01a86ae3cb025d8fb57a6b88e057e8d5d896e42d2",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-ziyou-1",
      "type": "figure",
      "refs": [
        480,
        525
      ],
      "concepts": [
        "li",
        "jiaoxue"
      ],
      "figures": [
        "ziyou",
        "zixia"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "區分兩章教育討論的議題與說話者",
      "stem": "17.4孔子承認子游所說學道有益；19.12子游批子夏門人只得末節，子夏反駁。依現頁譯文，哪項比較較準確？",
      "options": [
        {
          "id": "a",
          "text": "一章肯定學道的作用，另一章爭論教學內容與次序，不能混作同一場定論"
        },
        {
          "id": "b",
          "text": "兩章都由子夏承認全部教法錯誤，接受子游要求停教",
          "why": "17.4沒有子夏的這種發言；19.12子夏反而說言游過矣。"
        },
        {
          "id": "c",
          "text": "兩章都明說只教灑掃即可，學道本末不必再分",
          "why": "17.4談學道的作用，19.12則有先後、有始有卒等問題，均不能化約成只教灑掃。"
        },
        {
          "id": "d",
          "text": "19.12是孔子親口裁定子夏錯、子游對",
          "why": "此段記子游與子夏的發言，沒有孔子親口作這項裁決。"
        }
      ],
      "answerId": "a",
      "explanation": "17.4記孔子對子游說法的肯定；19.12記兩位弟子的爭論，現譯把子夏之意解為有分類和次序的傳授。可以比較問題焦點，但不能把一章的肯定移成另一章的裁決，或從文本保存爭論就證明兩邊已同樣被確認正確。",
      "review": {
        "version": "editorial-serial28-86e901b1b58df54e",
        "sha256": "86e901b1b58df54eef6e62fc06405475ea6ad355cc582bc6f9ef2d68bf19028c",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zhonggong-1",
      "type": "figure",
      "refs": [
        126,
        121
      ],
      "concepts": [
        "zhiren",
        "ren"
      ],
      "figures": [
        "zhonggong"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "用可使南面對讀牛犢比喻的人物評價",
      "stem": "6.6用犂牛之子騂且角說仲弓，6.1又說雍也可使南面。依本頁注釋，兩章對讀較支持哪項判斷？",
      "options": [
        {
          "id": "a",
          "text": "仲弓本人有可用之才，不應只因父親身分便棄用"
        },
        {
          "id": "b",
          "text": "仲弓資質平常，需要更加努力",
          "why": "6.1直接肯定可為長官，6.6又以合格牛犢為喻，並非認定資質平常。"
        },
        {
          "id": "c",
          "text": "祭祀用牲有嚴格規定，不可隨意",
          "why": "祭牲條件在此用來譬喻人物任用，若只談祭祀而不論仲弓，就漏掉兩章的共同對象。"
        },
        {
          "id": "d",
          "text": "仲弓應當先改善家世再談出仕",
          "why": "與比喻的結論完全相反。"
        }
      ],
      "answerId": "a",
      "explanation": "6.1肯定仲弓可任長官，6.6現注則把合格牛犢不應因耕牛父輩而被棄的比喻，用來解釋仲弓不應因父親身分被舍棄。這支持對本人能力的重視，不必另立未經材料證明的思想發展或因果次序。",
      "review": {
        "version": "editorial-serial28-b5e5bf84422db54d",
        "sha256": "b5e5bf84422db54dfc0814c9387e1cc463cd8d5fd536326d44fca0afeec5e742",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-fanchi-1",
      "type": "figure",
      "refs": [
        350
      ],
      "concepts": [
        "zheng",
        "jiaoxue"
      ],
      "figures": [
        "fanchi"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨識答語從耕作技術轉向上位者責任的理由",
      "stem": "13.4樊遲請學稼圃後，孔子說上好禮、義、信則四方之民襁負其子而至。這段答語明確採取的理由是？",
      "options": [
        {
          "id": "a",
          "text": "著眼上位者以禮義信使民歸附，因而問何必自己從事耕作"
        },
        {
          "id": "b",
          "text": "老農老圃完全沒有任何耕作技術，孔子在各方面都比他們熟練",
          "why": "孔子先說吾不如老農、吾不如老圃，不能讀成否認他們的技術。"
        },
        {
          "id": "c",
          "text": "孔子不懂農事，因此惱羞成怒",
          "why": "答語明列上位者與民眾的關係，卻沒有提供足以確定惱羞成怒的心理資料。"
        },
        {
          "id": "d",
          "text": "樊遲問得不合禮，冒犯了老師",
          "why": "本章雖說上好禮，卻未記樊遲的請問方式失禮或冒犯老師；不能把論禮直接變成責其問法不當。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子把理由放在上位者的禮義信及民眾歸附上。這呈現文本中的角色與身分區分，可以進一步評析其價值限制；但不能把樊遲原已立志為政或只是動機錯置當作本章明文。承認農圃專長，也不自動解決其中的等級問題。",
      "review": {
        "version": "editorial-serial28-0da7320abc9f7d7d",
        "sha256": "0da7320abc9f7d7d9c77871a81fc0ff8339022b80f1a714798ba05f1ea188949",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-kongzi-1",
      "type": "figure",
      "refs": [
        184,
        152,
        170
      ],
      "concepts": [
        "xue",
        "jiaoxue"
      ],
      "figures": [
        "kongzi"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "比較持續學教的自述與不同章句語氣",
      "stem": "對讀7.34、7.20與7.2，本頁對7.2何有於我哉採自問之譯並列另一讀法。哪項概括較準確？",
      "options": [
        {
          "id": "a",
          "text": "7.34與7.20重視持續學教和勤求，7.2則須交代語氣讀法的差別"
        },
        {
          "id": "b",
          "text": "三章都毫無保留地宣稱自己已是聖人且生來全知",
          "why": "7.34說聖與仁則吾豈敢，7.20說我非生而知之，均不支持這種自稱。"
        },
        {
          "id": "c",
          "text": "7.20否認後天求學的價值，主張知識只由天生決定",
          "why": "7.20正以好古、敏以求之說明自己的求知方式。"
        },
        {
          "id": "d",
          "text": "他從不自許任何事",
          "why": "7.34仍以可謂云爾說為之不厭、誨人不倦，不能說从不承認任何事情。"
        }
      ],
      "answerId": "a",
      "explanation": "7.34與7.20以不厭不倦、好古敏求說明持續實踐，並不自稱聖仁或生知。7.2現譯另有自問語氣，注釋又列不同解法。比較可見共同關切，也要保留各章語氣，不能由少數章句推出孔子全書唯一的一種自我評價。",
      "review": {
        "version": "editorial-serial28-a18ec5de8ff7aaeb",
        "sha256": "a18ec5de8ff7aaeb5453311864b404dba8dc7c95205eb9bfac4d920ef86753ec",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "fg-zilu-4",
      "type": "figure",
      "refs": [
        509
      ],
      "concepts": [
        "chushi",
        "li"
      ],
      "figures": [
        "zilu"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "核對子路與丈人的敘事順序及後段言義",
      "stem": "依18.7的敘事，哪項最準確地描述子路與丈人的相遇及其後論述？",
      "options": [
        {
          "id": "a",
          "text": "先拱立、留宿與回報，返見時丈人已去，後段才記子路論不仕無義"
        },
        {
          "id": "b",
          "text": "與丈人辯論農事，證明自己懂稼穡",
          "why": "文本沒有記子路與丈人辯論農事，後段列的是長幼、君臣及行義的理由。"
        },
        {
          "id": "c",
          "text": "子路回報孔子後，記載就結束，沒有再返見或發言",
          "why": "章中接著記孔子使子路反見，及子路關於出仕之義的話，不能把前段當全文。"
        },
        {
          "id": "d",
          "text": "承認隱者說得對，勸孔子退隱",
          "why": "後段明說不仕無義、君子之仕在行其義，並沒有勸孔子退隱。"
        }
      ],
      "answerId": "a",
      "explanation": "要分清相遇、留宿、回報與返見的次序，不把後段論義變成初見時當面即答。四體不勤在本頁主譯是责子路，注中還列丈人自說的讀法；不能未交代異解便說一定在譏孔子。後段論義可再與其他出處章句比較，但先須保存本章敘事關係。",
      "review": {
        "version": "editorial-serial28-9b16df1a4304f06e",
        "sha256": "9b16df1a4304f06ee3f57e6a06a0e65b22a35dd61d367febb571afb3f6bcee9e",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-xue-1",
      "type": "application",
      "refs": [
        1,
        31
      ],
      "concepts": [
        "xue"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "學而時習之落到複習方法上",
      "stem": "你能跟著老師講解看懂例題，但尚未獨立完成同類題。依本頁對學而時習之的解釋，哪一步最直接補足目前缺少的環節？",
      "context": "以下是將古文用於現代學習的假設情境，並非對某次考試失利的原因診斷。",
      "options": [
        {
          "id": "a",
          "text": "安排獨立演練，核對哪些步驟真能自己完成"
        },
        {
          "id": "b",
          "text": "只把聽課筆記讀得更密集，仍不自己試做",
          "why": "閱讀頻率不等於獨立演練；時在本頁亦不是越密集越好的意思。"
        },
        {
          "id": "c",
          "text": "只思考公式來歷，暫不檢查自己能否運用",
          "why": "思考公式有價值，但此項仍未補上題中明說欠缺的獨立運用檢查。"
        },
        {
          "id": "d",
          "text": "已能跟著講解看懂，便足以證明可獨立完成，不需再檢查",
          "why": "跟著講解理解不等於已獨立完成；題中明說尚未做過，不能把待核能力直接判成已證。"
        }
      ],
      "answerId": "a",
      "explanation": "現頁以實習、演習說明習，可以啟發把所學付諸實作。情境已知尚未獨立做過，因此先補這個環節較直接；並不意味所有失分只有一個原因，或讀書思考可以省略。",
      "review": {
        "version": "editorial-serial28-1431b4341a1e08cf",
        "sha256": "1431b4341a1e08cf7ef8992be998a314dd4bb7dd89de4ac9ce2a6c402140ffb9",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-xue-2",
      "type": "application",
      "refs": [
        451,
        31
      ],
      "concepts": [
        "xue"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "空想與求證的分工",
      "stem": "寫短視頻與專注力的文章前，你尚未閱讀相關材料，只憑印象反覆猜想。依15.31並參2.15，哪一步較能補足目前的方法？",
      "options": [
        {
          "id": "a",
          "text": "查讀可靠材料與不同觀點，再整理問題、證據和思路"
        },
        {
          "id": "b",
          "text": "再想一晚，把思路理清楚再動筆",
          "why": "題中已明說尚未查讀材料；若仍只用同一批印象思考，便未補足檢驗猜想的資料。這不表示所有獨立思考都無益。"
        },
        {
          "id": "c",
          "text": "只把同一批猜想寫得更長，仍不查任何材料",
          "why": "寫作可以整理思路，但此項明說不補材料，不能檢驗原有猜想。"
        },
        {
          "id": "d",
          "text": "換一個題目，仍只憑原有印象而不查資料",
          "why": "換題本身未改變此情境中缺少材料和檢驗的方式，不能保證問題已解。"
        }
      ],
      "answerId": "a",
      "explanation": "15.31可提醒不要把長時間苦思當作充分學習；2.15又不主張取消思考。此處已明示未查材料，因此查讀、整理與檢驗是合適的現代應用，並非古文對所有寫作困難的唯一處方。",
      "review": {
        "version": "editorial-serial28-f722f9876e0d3088",
        "sha256": "f722f9876e0d30884980cd0fc3ef655fc7c932a2703a5957b30971cd0a0f8b01",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-xue-3",
      "type": "application",
      "refs": [
        450,
        123
      ],
      "concepts": [
        "xue",
        "junzi"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "「過而不改」與「不貳過」",
      "stem": "你三次訂正都只抄標準答案，還沒檢查哪一步理解有誤。把不貳過與過而不改用於自我改進，哪一步較直接？",
      "options": [
        {
          "id": "a",
          "text": "說清錯在何步及理由，再用同類題檢查是否改善"
        },
        {
          "id": "b",
          "text": "再抄一遍題目與答案，使版面更工整，仍不核對出錯步驟",
          "why": "重抄得工整不等於已理解錯因，未回應題中指出的缺口。"
        },
        {
          "id": "c",
          "text": "只增加題數，不看錯因也不核對解題過程",
          "why": "練習可協助改進，但此項排除了檢查與回饋，未針對已知缺口；不是所有增加練習都無用。"
        },
        {
          "id": "d",
          "text": "這很正常，錯三次還算少",
          "why": "犯錯本可成為學習材料，但不能因此放棄檢查與改進；也不宜把再錯本身等同道德過失。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章可啟發重視實際改進，而非只完成訂正形式。這裡的現代步驟是查明、解釋及再檢驗；它不是古文明列的做題程序，更不能由一次或多次再錯便否定學習者的努力。",
      "review": {
        "version": "editorial-serial28-944ed32c39f68f83",
        "sha256": "944ed32c39f68f8330174c6bc1abad7c9fe1ac34869022b348e8991c9e62474f",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-shu-1",
      "type": "application",
      "refs": [
        444,
        324
      ],
      "concepts": [
        "shu"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "恕的底線用法",
      "stem": "同學已表示不願自己的糗照被轉傳，班群仍拿它取笑。以己所不欲勿施於人思考，你的選擇是？",
      "options": [
        {
          "id": "a",
          "text": "不轉傳取笑，尊重同學意願並協助制止繼續羞辱"
        },
        {
          "id": "b",
          "text": "只要不是自己發的，跟著笑一下沒關係",
          "why": "在這個情境中，跟著嘲笑也參與了對同學的羞辱；不是照片的首發者，不能消除這項參與的影響。"
        },
        {
          "id": "c",
          "text": "再貼照片並羞辱轉發者，讓他也被全群嘲笑",
          "why": "制止傷害可以必要，但再散布照片與以羞辱報羞辱會另加傷害，不是不能指出問題。"
        },
        {
          "id": "d",
          "text": "偷偷存下照片，以後拿來私下取樂，但不公開轉發",
          "why": "此項明說為取樂而保留，不尊重當事人已表達的意願；不同於必要且受限的求助留證。"
        }
      ],
      "answerId": "a",
      "explanation": "這是把勿施於人用於現代群組行為：考慮同學意願，停止轉傳與嘲笑。換位並不要求對傷害沉默，合理制止、支持當事人與需要時求助也可以並行。",
      "review": {
        "version": "editorial-serial28-af9645e86ebefb43",
        "sha256": "af9645e86ebefb43aefa48723dda8c5694bbc4881a7a61afa0298052b777ecc5",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-shu-2",
      "type": "application",
      "refs": [
        150
      ],
      "concepts": [
        "shu",
        "ren"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "「己欲立而立人」的積極面",
      "stem": "小組作業要求每位成員都能說明自己的部分；你已弄懂，組員仍卡住。以己欲立而立人、己欲達而達人作為啟發，哪種做法較合適？",
      "options": [
        {
          "id": "a",
          "text": "先問困難在哪，分享方法，讓組員自己練習並說明"
        },
        {
          "id": "b",
          "text": "直接代做全部，要求組員不必理解也不要參與",
          "why": "題目明定每人要能說明，完全代做而排除其參與沒有幫助達成這項學習目標。"
        },
        {
          "id": "c",
          "text": "先確保自己的部分完美，其餘不管",
          "why": "這只做到「己欲立」，缺了推及他人的那一半。"
        },
        {
          "id": "d",
          "text": "只是隱瞞進度裝作不懂，不了解也不回應組員的困難",
          "why": "這種隱瞞未提供協助；若是為共同學習調整節奏，則是另一種可考慮的做法。"
        }
      ],
      "answerId": "a",
      "explanation": "由希望自己學會推及協助別人，可以落實為詢問、解說、練習與回饋。這是現代情境的具體設計，不能把立人固定成只准一種方法，或一概否定合宜分工和配合節奏。",
      "review": {
        "version": "editorial-serial28-67abad71dda76438",
        "sha256": "67abad71dda764387a6405974db09b13497dc0b6d81b37b8dababb96d520cb10",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-xin-1",
      "type": "application",
      "refs": [
        13,
        38
      ],
      "concepts": [
        "xin"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "先問該不該諾",
      "stem": "朋友要你答應：考試時把答案傳給他，並說「你答應了就不能反悔」。依「信近於義，言可復也」，該怎麼判斷？",
      "options": [
        {
          "id": "a",
          "text": "不答應作弊；若已答應，坦白說明更正而不以守信為由照做"
        },
        {
          "id": "b",
          "text": "既然答應了就要做到，守信最重要",
          "why": "1.13把可踐的約言與義相聯，不能只取守信而取消正當性的檢查。"
        },
        {
          "id": "c",
          "text": "答應但故意傳錯答案，兩邊都不得罪",
          "why": "故意傳錯答案仍是在參與作弊，又另加欺騙，並不是坦白更正不當承諾的負責做法。"
        },
        {
          "id": "d",
          "text": "先答應下來，到時候再看情況",
          "why": "明知不該做而先許諾，本身已違背「言可復」的前提。"
        }
      ],
      "answerId": "a",
      "explanation": "以信近於義思考承諾，可先檢查所答應的事是否正當；2.22對信誉的重視也不自動使作弊承諾正當。拒絕或更正時仍需說明與負責，不能把義當作任意反悔的藉口。這是古文原則的現代應用。",
      "review": {
        "version": "editorial-serial28-5cd61e00bdfd0bd6",
        "sha256": "5cd61e00bdfd0bd6757a877c97fb7ddfa1d63b40308dd508be037b158364adb3",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-xin-2",
      "type": "application",
      "refs": [
        329
      ],
      "concepts": [
        "xin",
        "zheng"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "民信不立的現代對照",
      "stem": "學生會多次未兌現承諾，也未說明原因，只以新活動轉移注意。把12.7對信任的重視用於此情境，哪一步較直接？",
      "options": [
        {
          "id": "a",
          "text": "核查失約原因，公開說明可行承諾並追蹤落实"
        },
        {
          "id": "b",
          "text": "先把活動辦得更精彩，用成績贏回人心",
          "why": "更多活動可能有價值，但不能代替對已失約事項的說明與處理。"
        },
        {
          "id": "c",
          "text": "只增加總預算，不查各項失約原因，也不回應同學",
          "why": "若有資源缺口可調整，但只加總額而不查原因未必修補承諾與落实的問題。"
        },
        {
          "id": "d",
          "text": "減少對外承諾，避免被追究",
          "why": "縮小不切實際承諾可以是改進；此選項卻以免被追究為目的，沒有處理過去失約。"
        }
      ],
      "answerId": "a",
      "explanation": "本題把重視信任轉成可核實的說明與履行。12.7原先處於必不得已的取捨追問，不能照搬為任何團體永遠先後固定的管理規則，更不能由此取消基本需要。",
      "review": {
        "version": "editorial-serial28-d04d2b46e94ce666",
        "sha256": "d04d2b46e94ce6661e84787458b112ef715650412f301edde87c6bf74c5a1eb1",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-yili-1",
      "type": "application",
      "refs": [
        71,
        82
      ],
      "concepts": [
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "先問該不該得",
      "stem": "競賽按公開標準選人，家人卻提議讓你繞過程序，擠掉已符合資格者。以4.5不以其道得之、不處也作為啟發，該怎樣判斷？",
      "options": [
        {
          "id": "a",
          "text": "拒絕繞過公平程序的取得方式，循公開標準爭取"
        },
        {
          "id": "b",
          "text": "機會難得，先拿到再用實力證明自己",
          "why": "「不以其道得之」判的正是取得的方式；事後的表現不能追認取得的正當性。"
        },
        {
          "id": "c",
          "text": "君子應當淡泊，這種名額本來就不該想要",
          "why": "孔子承認「富與貴，是人之所欲也」，想要不是問題，取法才是。"
        },
        {
          "id": "d",
          "text": "只要沒有明文規定禁止，就可以接受",
          "why": "此情境已有公開選拔標準，也明說安排會擠掉符合資格者；不能只找有無某一句禁令，就忽略不公平的取得方式。"
        }
      ],
      "answerId": "a",
      "explanation": "4.5把想要與取得方式分開，適合用來檢查此處已明示的不公平安排。這是對現代程序的類比，不表示凡有他人協助都不義。4.16可另作義利討論，但其君子、小人身分讀法在現注仍有保留。",
      "review": {
        "version": "editorial-serial28-56e069453695f03b",
        "sha256": "56e069453695f03b874f55ac7d0fa0ede5d73d98afced3663dc41104e1cebfd8",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-yili-2",
      "type": "application",
      "refs": [
        166,
        162
      ],
      "concepts": [
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "分辨可求與不可求",
      "stem": "一份高薪兼職要求你把已查明虛假的資訊當真實宣傳。以7.12和7.16作為判斷啟發，哪項選擇較合適？",
      "options": [
        {
          "id": "a",
          "text": "可以爭取收入，但拒絕靠明知虛假的宣傳取得"
        },
        {
          "id": "b",
          "text": "君子不該打工賺錢，應專心讀書",
          "why": "他說富若可求，「雖執鞭之士，吾亦為之」——並不排斥謀生。"
        },
        {
          "id": "c",
          "text": "薪水高就值得，說幾句宣傳話不算什麼",
          "why": "題中手段已明示為明知虛假仍宣傳，薪資數額本身不能證成它正當。"
        },
        {
          "id": "d",
          "text": "先做著，攢夠錢再去做真正想做的事",
          "why": "以後想做的事不能自動消除眼前所得涉及不正當手段的問題。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章並不一概拒財，卻不能把可求理解成有收入便無條件接受。此處的類比著眼7.16對不義所得的拒絕；7.12從吾所好仍是另有所好的表述，不能直接偷換為本題已證的道德定義。",
      "review": {
        "version": "editorial-serial28-d7cbb382af177957",
        "sha256": "d7cbb382af1779576a06900f0cbc4d05c682bc13a682b25f73d0d974c39fbd34",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-junzi-1",
      "type": "application",
      "refs": [
        441,
        439
      ],
      "concepts": [
        "junzi"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "求諸己的實際操作",
      "stem": "小組報告失利後，你尚未檢查自己的分工與核對工作。以君子求諸己提醒自己，哪項做法較直接？",
      "options": [
        {
          "id": "a",
          "text": "檢查自己的分工與核對工作，確認有哪些可改之處"
        },
        {
          "id": "b",
          "text": "先認定全是組員的錯，拒絕檢查自己的任何行為",
          "why": "合理釐清責任可以並行，但此項預先免除自己一切檢查，與題中自我要求相反。"
        },
        {
          "id": "c",
          "text": "只換一組人，不檢查過程，也不確認自己能改什麼",
          "why": "換組可能有理由，但此項明說放棄過程檢查，沒有落實本題的自我反思。"
        },
        {
          "id": "d",
          "text": "接受結果，不必檢討",
          "why": "求諸己是主動檢討，不是消極承受。"
        }
      ],
      "answerId": "a",
      "explanation": "求諸己可啟發檢查自己能負責、能改進的部分；15.19亦把注意力放在自身能力。這不要求把別人的錯一概攬下，也不禁止同時查清責任、求助或調整合作關係。",
      "review": {
        "version": "editorial-serial28-353f78be193246fc",
        "sha256": "353f78be193246fc93c5111f9da6385775a0d138100d1e347aa3de0ed48d2e67",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-junzi-2",
      "type": "application",
      "refs": [
        369,
        442
      ],
      "concepts": [
        "junzi",
        "zhongyong"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "和而不同的協作用法",
      "stem": "討論方案時，你不贊成多數人的意見。依「君子和而不同」「矜而不爭，群而不黨」，最合的做法是？",
      "options": [
        {
          "id": "a",
          "text": "提出異議與理由，聽取回應，不因陣營排斥合理意見"
        },
        {
          "id": "b",
          "text": "明知方案有問題也只附和多數，假裝完全同意",
          "why": "此項以盲從掩去已知問題，與和而不同的差異相成不合；並非所有暫緩發言都錯。"
        },
        {
          "id": "c",
          "text": "只按私下拉來的陣營投票，拒絕聽任何反對理由",
          "why": "問題在以排他陣營代替理由，而不在所有共同討論或合作本身。"
        },
        {
          "id": "d",
          "text": "即使新證據顯示自己有錯，也一律拒絕調整",
          "why": "保留異見不等於拒絕證據；有理由堅守原則與無條件固執不同。"
        }
      ],
      "answerId": "a",
      "explanation": "此處可用不同意見相參與不結排他宗派作合作原則。它不保證所有分歧都能調和，也不要求放棄界線以維持表面和諧；是否採納、折衷或停止合作，仍需具體理由。",
      "review": {
        "version": "editorial-serial28-64dec899642e6977",
        "sha256": "64dec899642e6977176023e57a6c280fb7eed0b96f0b778acec678ce025abcbb",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-zhiren-1",
      "type": "application",
      "refs": [
        26,
        448
      ],
      "concepts": [
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "眾好眾惡都要察",
      "stem": "網上都在責罵某人，你不了解經過，正考慮是否轉發並下判斷。以眾惡眾好必察作啟發，哪項較合適？",
      "options": [
        {
          "id": "a",
          "text": "先核對可得的可靠證據；不足時不轉傳定論，也可暫不參與"
        },
        {
          "id": "b",
          "text": "多數人的判斷通常不會錯，可以跟從",
          "why": "多人一致責罵，並不等於這件事已獲可靠證據支持；15.28仍要求考察，其注所引13.24也不把全鄉一致好惡作充分判準。"
        },
        {
          "id": "c",
          "text": "一面倒的事多半有內情，應該站到少數那一邊",
          "why": "反過來盲從少數，同樣是省掉了「察」這一步。"
        },
        {
          "id": "d",
          "text": "雖不查證，仍轉發並斷言此人一定有錯",
          "why": "此項在不查證下仍傳播定論；若選擇不判斷、不傳播而退出，是不同情況。"
        }
      ],
      "answerId": "a",
      "explanation": "重點是不要以多數或少數身分代替判斷根據。考察限於合法、適當、可得的資訊，不是窺探私人資料；證據不足可暫停判斷，也無須把所有網上爭議都承擔為自己的調查任務。",
      "review": {
        "version": "editorial-serial28-7a1bb232998bd22e",
        "sha256": "7a1bb232998bd22e84f7f64caec30407fef0d8ca6a88de6338ce6a76883b1703",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-zhiren-2",
      "type": "application",
      "refs": [
        26,
        443
      ],
      "concepts": [
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "分開言論證據與人物總評，辨別可下結論的範圍",
      "stem": "依2.10與15.23作為啟發，怎樣處理這兩項判斷較審慎？",
      "options": [
        {
          "id": "a",
          "text": "分開核查反例與言行；兩個總判都不足，先查可核對的材料"
        },
        {
          "id": "b",
          "text": "甲曾履約又說得好，可直接認定他此後所有主張都成立",
          "why": "過往兩次履約可作了解的一部分，但不能保證往後每項言論都正確；一句好話也不構成全人能力已證。"
        },
        {
          "id": "c",
          "text": "乙曾失約，故無須看資料便可認定這次反例一定錯誤",
          "why": "對人的過往評價不能代替對具體言論與資料的核查，正好涉及不以人廢言。"
        },
        {
          "id": "d",
          "text": "反例可供查核，就等於已被證實，可立即判甲的主張必錯",
          "why": "可查核表示存在核對途徑，不等於已核實；反例是否成立及能推翻多大範圍，仍須實際檢查。"
        }
      ],
      "answerId": "a",
      "explanation": "先分清在判斷一項主張，還是在判斷一個人。甲的履約紀錄不能證明每一句話都對，乙的失約也不能單獨推翻可查的反例。先核資料，再把適當、可得的言行材料放回較完整脈絡；這是古文原則的現代類比，不是由少數紀錄自動評定品德。",
      "context": "甲曾兩次履約，今天提出一句漂亮主張；乙曾一次失約，今天提供一項可核查的反例。有人因此認定甲此後所有話都可信、乙的反例必不成立。",
      "review": {
        "version": "editorial-serial28-1aaa9a3a17ecdd83",
        "sha256": "1aaa9a3a17ecdd83e22d037aa35a0410d842e832fe9af2252d5782bce1a01467",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-xiao-1",
      "type": "application",
      "refs": [
        84,
        23
      ],
      "concepts": [
        "xiao"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "孝與異議並存",
      "stem": "父母替你決定了選科，你並不認同。依「事父母幾諫，見志不從，又敬不違」，該怎麼處理？",
      "options": [
        {
          "id": "a",
          "text": "說明興趣與依據，聽取顧慮並保持尊重，必要時請師長協助討論"
        },
        {
          "id": "b",
          "text": "父母的決定就是對的，照辦不必多說",
          "why": "幾諫容許在父母有不對時提出婉轉勸告，不能把父母一切決定必然正確當成本章立場；如何開口仍需視具體情境。"
        },
        {
          "id": "c",
          "text": "不解釋選擇依據，只以辱罵貶低父母来回應",
          "why": "有理由堅持自己的選擇與以辱罵回應不同；此項未作有內容且尊重的溝通。"
        },
        {
          "id": "d",
          "text": "表面答應，私下按自己的來",
          "why": "表面答應而隱瞞安排可能使共同討論失去真實資訊；可改為說明仍不同意及可行選擇，不必假裝同意。"
        }
      ],
      "answerId": "a",
      "explanation": "可從婉諫與敬學習尊重地提出異議，但古代事親章句不是現代選科決定權的完整規則。保持尊重不等於放棄自己的興趣、判断或尋求協助，也不能把不違直接翻成一切决定都照辦。",
      "review": {
        "version": "editorial-serial28-8458f9020f9093bf",
        "sha256": "8458f9020f9093bf21db3b90b30d936bcdcf4d9db86ada4b55cfa5e59026bf5e",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-xiao-2",
      "type": "application",
      "refs": [
        24,
        23
      ],
      "concepts": [
        "xiao"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "從色難反思溝通，避免以單一表現總評孝行",
      "stem": "你持續負擔家用，但最近通話時常匆忙而不耐煩。以本頁色難與不敬何以別的讀法反思，哪個改進方向較合適？",
      "options": [
        {
          "id": "a",
          "text": "肯定已有的供養付出，也檢查疲累與溝通安排，改善相處時的尊重"
        },
        {
          "id": "b",
          "text": "既然出錢，就完全不必考慮任何溝通態度",
          "why": "本頁2.7、2.8正提醒供養之外還有敬與容色，不能以出錢取消相處責任。"
        },
        {
          "id": "c",
          "text": "立即辭去工作，認為只有一直在家陪伴才算合適",
          "why": "本章沒有規定必須辭去工作；可以先具體檢查時間、負荷與溝通方式。"
        },
        {
          "id": "d",
          "text": "只要自認心意到了，就不必改善任何相處態度",
          "why": "相處態度會影響對方感受，不能說全無關係；同時它也不是判斷全部心意的唯一證據。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁把色難解為子女侍親時的容色，可啟發兼顧供養與相處方式。這不是要求每次強作愉悅，更不能忽略疲累與現實負荷；適當表達狀態、另約時間及保持尊重，都可成為具體反思。",
      "review": {
        "version": "editorial-serial28-22bed9874e56d679",
        "sha256": "22bed9874e56d67902cb308a3cd9e6d88a3fac506b62c2d50a3a86167ed9adfe",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-ren-1",
      "type": "application",
      "refs": [
        69,
        70
      ],
      "concepts": [
        "ren"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "仁者能好人能惡人",
      "stem": "已確認有同學持續排擠他人，你想友善待人。以唯仁者能好人能惡人作為啟發，哪種選擇較能兼顧是非與適當行動？",
      "options": [
        {
          "id": "a",
          "text": "不認同排擠，依安全與當事人需要選擇支持、制止或求助"
        },
        {
          "id": "b",
          "text": "友善就代表任何排擠行為都不能被指出或阻止",
          "why": "尊重人不等於取消對傷害行為的是非判斷。"
        },
        {
          "id": "c",
          "text": "只要自己沒參與，就可以斷言排擠本身完全沒問題",
          "why": "未參與不能證成排擠正當；是否親自介入與如何評價行為是不同問題。"
        },
        {
          "id": "d",
          "text": "號召全班反過來羞辱、排擠原先的排擠者",
          "why": "以另一輪排擠回應會增加傷害，不等於有根據而適度的是非判斷。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁以好惡得中解此句，可啟發不把友善理解成放任傷害。具體支持方式需看安全和當事人需要，不以是否公開發言作唯一道德測試，也不把反向羞辱當作正義。",
      "review": {
        "version": "editorial-serial28-9a4b9611a9da2d6a",
        "sha256": "9a4b9611a9da2d6ac441c10761933228f29c130e723ce8f5a6116bef9c15546a",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-ren-2",
      "type": "application",
      "refs": [
        180,
        257
      ],
      "concepts": [
        "ren"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "仁在當下可及",
      "stem": "你把行仁想得很遙遠，因而連力所能及的關心也不開始。把7.30與10.17對讀，哪項可作較合適的行動啟發？",
      "options": [
        {
          "id": "a",
          "text": "從能做的具體關懷開始，也承認仍需學習與累積能力"
        },
        {
          "id": "b",
          "text": "要先修養多年，德行到位了才談得上行仁",
          "why": "本章正是反對把仁推遠：「仁遠乎哉？」"
        },
        {
          "id": "c",
          "text": "行仁要有能力和地位，等以後再說",
          "why": "有些事情需要資源能力，但這不表示眼下所有可做的關心都必須擱置。"
        },
        {
          "id": "d",
          "text": "只保留心裡的善意，所有可做的具體關心都不必開始",
          "why": "題目問可行的行動啟發；10.17記具體關切是否傷人，不能把只存善念當成所有可做的關懷都已完成。"
        }
      ],
      "answerId": "a",
      "explanation": "7.30可鼓勵不把仁一味推遠；10.17則提供關切人是否受傷的具体記載。這不等於所有仁行都毋須準備，也不把一次念頭、點擊或行動認定為已完全具備仁德。",
      "review": {
        "version": "editorial-serial28-c5320aadbd519a6a",
        "sha256": "c5320aadbd519a6a623f7c1bce9b67663564cbb467f1ce27381b8e2d523819cf",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-li-1",
      "type": "application",
      "refs": [
        44,
        487
      ],
      "concepts": [
        "li"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "檢查豪華排場是否取代典禮的實際需要",
      "stem": "畢業典禮已滿足基本安全與使用需要，剩餘預算有人只想用來比拚豪華排場。以3.4與17.11作為啟發，哪項較合適？",
      "options": [
        {
          "id": "a",
          "text": "節制純粹攀比的花費，兼顧有用形式與對參與者的敬意"
        },
        {
          "id": "b",
          "text": "隆重才顯得鄭重，應當把場面辦足",
          "why": "鄭重可以透過多種形式呈現，不能以花費越高就越有禮作唯一判準。"
        },
        {
          "id": "c",
          "text": "禮是形式，兩邊都不重要",
          "why": "17.11否定把禮只限於器物，並非宣告禮或形式全無價值；3.4也在比較怎樣行禮。"
        },
        {
          "id": "d",
          "text": "按慣例辦即可，不必討論",
          "why": "題中已出現只為攀比的支出，仍須按實際需要檢查；沿用慣例不能直接回答這項花費是否合適。"
        }
      ],
      "answerId": "a",
      "explanation": "3.4寧儉、17.11不止玉帛，可用來檢查是否把排場當全部。這不取消場地、器物、程序與美感的適當作用；判斷仍須看實際需要，而非凡布置皆奢、凡省錢皆合禮。",
      "review": {
        "version": "editorial-serial28-7864b0bbe5909472",
        "sha256": "7864b0bbe5909472bf6852f1e30d1c4e4ed7ae38c6a2846d0ac59a1583f058b6",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-li-2",
      "type": "application",
      "refs": [
        190
      ],
      "concepts": [
        "li",
        "junzi"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "四種德行都需要禮來調節",
      "stem": "「恭而無禮則勞，慎而無禮則葸，勇而無禮則亂，直而無禮則絞」——你是個直率的人，常因說話太衝得罪人。這章給你的提示是？",
      "options": [
        {
          "id": "a",
          "text": "保留誠實，同時核對事實、場合與說法，避免把尖刻當直率"
        },
        {
          "id": "b",
          "text": "為避免任何分歧，一律隱瞞已核實的重要事實、迎合對方",
          "why": "本章提醒直需合禮，並非要求一概放棄據實表達；隱瞞迎合與調整說話方式不同。"
        },
        {
          "id": "c",
          "text": "說話衝是性格問題，改不了",
          "why": "不能以性格固定為由放棄反思；可以具體調整做法，而不必宣稱一改就立刻見效。"
        },
        {
          "id": "d",
          "text": "只要出發點是好的，說話方式不重要",
          "why": "絞在現注指尖刻刺人，指出需要檢查的結果，並沒有保證說話者的動機一定良善。"
        }
      ],
      "answerId": "a",
      "explanation": "8.2提醒看似可取的特點仍需合宜實踐。應檢查內容是否真實、方式是否適當，不能把直率當傷人免責理由。現注明禮之本質，也不表示禮完全不涉及規範或具體形式。",
      "review": {
        "version": "editorial-serial28-bafb80e906b12bb5",
        "sha256": "bafb80e906b12bb545c99a26a0f66502b6ac8951111dd21eaad3c23ee498b5ed",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-zheng-1",
      "type": "application",
      "refs": [
        352,
        339
      ],
      "concepts": [
        "zheng"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "其身正不令而行",
      "stem": "你當班長，要求大家守時，但自己常遲到。依「其身正，不令而行；其身不正，雖令不從」，關鍵在？",
      "options": [
        {
          "id": "a",
          "text": "自己先遵守守時要求，說明並改正遲到的問題"
        },
        {
          "id": "b",
          "text": "只對同學加罰，自己仍照常遲到且不說明",
          "why": "此項以處罰別人代替處理自己違規，未回應兩章對帶頭者行為的要求。"
        },
        {
          "id": "c",
          "text": "只把規則寫得更長，自己仍不遵守",
          "why": "清晰規則可以有幫助，但此項沒有改正題中帶頭者自己違規的問題。"
        },
        {
          "id": "d",
          "text": "要求幾個同學守時帶頭，卻宣布自己永久例外",
          "why": "同伴示範可以有益，但不能用它替自己取消同樣的責任。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章可啟發要求他人前也檢查自身示範。本題可行的改進是處理自己遲到，而非只加碼要求別人。這不保證所有人必然立刻配合，也不表示清楚制度或共同協作就無價值。",
      "review": {
        "version": "editorial-serial28-21f75b2efab39383",
        "sha256": "21f75b2efab39383f339a566a5b3597e8b25af6645f1bffb2b59fd4c0e239f6d",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-zheng-2",
      "type": "application",
      "refs": [
        19
      ],
      "concepts": [
        "zheng",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "evaluate",
      "purpose": "罰則與羞恥心的差別",
      "stem": "宿舍開始扣分後變乾淨了，但尚不知道大家的理解、感受或後續習慣。以2.3的區分作反思，哪項結論較審慎？",
      "options": [
        {
          "id": "a",
          "text": "可見環境改善，卻還不能據此確認內在認同或撤去約束後的表現"
        },
        {
          "id": "b",
          "text": "變乾淨已足以證明方法全面合宜，效果也必然長久",
          "why": "乾淨是可見結果之一，還不能單獨證明過程合宜、效果持續及內在認同。"
        },
        {
          "id": "c",
          "text": "本章已證明任何情況都必須取消一切懲罰措施",
          "why": "本章比較政刑與德禮的引導，未明說任何情況都禁止刑罰；不能由這段直接推出普遍禁令。"
        },
        {
          "id": "d",
          "text": "只要採用了扣分約束，就已證明大家出於內在認同而行事",
          "why": "用了扣分約束本身，不證明已達本章所說有恥且格；外在表現與內在認同仍須分辨。"
        }
      ],
      "answerId": "a",
      "explanation": "古文可提示把外在表現與內在認同分開思考，但題中證據只到清潔改善。撤去約束後如何仍需觀察，不能先斷一定回復原狀；也不應任意以學生是否表現羞恥作人格裁決。",
      "review": {
        "version": "editorial-serial28-15f1ebc8cdc22328",
        "sha256": "15f1ebc8cdc223289793efb9cbcc65024a13e7c8471120477cd697a2a9a492f7",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-zhongyong-1",
      "type": "application",
      "refs": [
        286,
        149
      ],
      "concepts": [
        "zhongyong"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "過與不及的自我診斷",
      "stem": "準備演講，你反覆修改到最後一刻，稿子越改越亂；同伴則完全不準備。依「過猶不及」，怎麼看這兩種狀態？",
      "options": [
        {
          "id": "a",
          "text": "兩種準備方式都可能失當，要依任務與實際效果調整"
        },
        {
          "id": "b",
          "text": "你比同伴好，因為努力總是對的",
          "why": "子貢由師也過推問師是否更好，孔子以過猶不及回應；在此情境中，也不能只憑投入更多就判定準備方式更合適。"
        },
        {
          "id": "c",
          "text": "取兩人的平均就對了",
          "why": "恰好由事情本身決定，不是兩個人的中點。"
        },
        {
          "id": "d",
          "text": "只憑一次講得好，就證明所有準備安排都永遠最佳",
          "why": "結果是重要回饋之一，但一次結果不能證明全部做法在任何情況都最佳。"
        }
      ],
      "answerId": "a",
      "explanation": "過與不及可用來反思準備是否符合需要，不是算出兩人的算術中點。可結合試講、時間與效果調整；不能把努力本身判錯，也不忽略結果提供的回饋。",
      "review": {
        "version": "editorial-serial28-c122a50e82c32099",
        "sha256": "c122a50e82c320990ad794aadc238ac2df8b1196010009e7f888710595416a1a",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-chushi-1",
      "type": "application",
      "refs": [
        201,
        202
      ],
      "concepts": [
        "chushi"
      ],
      "difficulty": 2,
      "cognitive": "evaluate",
      "purpose": "按責任、可行改善與安全界線判斷去留",
      "stem": "社團出現不正當要求，你是幹部。把8.13天下有道則見、無道則隱及8.14不在其位不謀其政作為反思材料，哪種判斷較審慎？",
      "options": [
        {
          "id": "a",
          "text": "辨明要求、責任與改善空間，按安全與界線選擇拒絕、求助或退出"
        },
        {
          "id": "b",
          "text": "不問具體情況，斷言任何問題都只能立即退出而不作其他判斷",
          "why": "退出可能適當，但不能未看情況就宣稱它永遠是唯一答案；同樣不能要求一概留下。"
        },
        {
          "id": "c",
          "text": "只為保住頭銜留下，完全不處理已承擔的責任",
          "why": "此項把保位代替對責任與情勢的判斷，不是有條件且負責的去留選擇。"
        },
        {
          "id": "d",
          "text": "留下來並用同樣的方式往上爬，先站穩再說",
          "why": "為取得位置而照做已知不當之事，沒有解決手段是否正當的問題。"
        }
      ],
      "answerId": "a",
      "explanation": "兩章提供出處與職位的思考材料，並未替現代社團預先決定所有答案。應查明事實、責任與可行途徑，不能把隱解成必須忍到完全無路才可離開，也不以宏大的責任語言取消安全與求助。",
      "review": {
        "version": "editorial-serial28-fc2d8f380a942e3e",
        "sha256": "fc2d8f380a942e3e179de953f90bd991db9d3975616b28eed01f85c75e072895",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-jiaoxue-1",
      "type": "application",
      "refs": [
        158,
        292
      ],
      "concepts": [
        "jiaoxue"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "依實際困難給提示，不由表情猜定學習狀態",
      "stem": "輔導學弟時，他皺眉但未說清困難。以7.8的憤悱啟發及11.22因情況調整作為參考，哪項較妥當？",
      "options": [
        {
          "id": "a",
          "text": "問他試到哪裡、卡在哪裡，依需要給提示或示範，再請他嘗試"
        },
        {
          "id": "b",
          "text": "不聽他的問題，直接代做全部並禁止他提問",
          "why": "此項取消了解困難及學生嘗試，不是說所有完整示範都不應使用。"
        },
        {
          "id": "c",
          "text": "讓他自己想，完全不要介入",
          "why": "原文仍有開導與啟發的互動；題中尚未弄清困難，不能把等待或完全不介入當成唯一適當的做法。"
        },
        {
          "id": "d",
          "text": "只憑皺眉就判他基礎全不會，從頭灌輸而不詢問",
          "why": "表情不足以確定知識缺口；詢問基礎本可合理，但不能先下全面診斷。"
        }
      ],
      "answerId": "a",
      "explanation": "原文重視求通、欲言的狀態，現代應用可先了解實際困難，再選提示、示範或練習。不能只看皺眉就斷定已到最佳火候，也不保證等得越久或提示越少就越好。",
      "review": {
        "version": "editorial-serial28-1f4b54095aa64ce7",
        "sha256": "1f4b54095aa64ce73388c9f15cffe64fcb859759c1cb94f9bf0fe98ca6f778fb",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-jiaoxue-2",
      "type": "application",
      "refs": [
        292
      ],
      "concepts": [
        "jiaoxue",
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "依兩份具體作答紀錄選擇不同支援，而非由固定性格套答案",
      "stem": "借11.22根據具体情況調整勸告的做法，哪組回應最直接對應記錄中的兩項缺口？",
      "options": [
        {
          "id": "a",
          "text": "請甲先核對錯用的條件並解釋；讓乙先獨立試做已準備好的題，再按結果回饋"
        },
        {
          "id": "b",
          "text": "兩人既問同一句，便都立即往下做；甲說得流利已足以代替條件核對",
          "why": "甲的記錄已顯示公式錯用，流利背出不能補上適用條件；同問也不使已知缺口相同。"
        },
        {
          "id": "c",
          "text": "兩人都重抄公式直到熟練；乙已說清的步驟與甲尚未核對的條件不必區分",
          "why": "甲缺的是檢查適用條件，乙已有正確步驟而缺獨立嘗試；一律重抄未針對這兩項不同資料。"
        },
        {
          "id": "d",
          "text": "把甲定為永遠衝動、乙定為永遠退縮；以後不看新記錄也固定給相反勸告",
          "why": "本次材料只支持本次調整，不能固定兩人的所有未來狀態；新錯誤或準備變化都可能需要另一種回應。"
        }
      ],
      "answerId": "a",
      "explanation": "不同回應須由已有記錄支持：甲先補條件核對，乙可在已準備的任務中練習獨立嘗試，之後再看結果。11.22可啟發不要機械同答，但這些公式練習與回饋安排是現代類比，不是原文明列的教案，也沒有承諾一次調整必然成功。",
      "context": "以下是現代練習記錄：\n甲能流利說出某公式，卻把它用在不符合條件的例子；請他解釋適用条件時，他尚未核對。\n乙已正確核對同類題的條件並說清步驟，但總在下一道已準備好的練習前反覆請人確認，不敢自己試。\n兩人都問：我現在可以往下做嗎？",
      "review": {
        "version": "editorial-serial28-15a8987bc1c39914",
        "sha256": "15a8987bc1c39914144738febf718336e441a9118476265d29e99ff51bbad24c",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-wenzhi-1",
      "type": "application",
      "refs": [
        138,
        330
      ],
      "concepts": [
        "wenzhi"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "內容與表達都要",
      "stem": "你的報告內容紮實但排版凌亂、講述含糊；同學的報告漂亮但空洞。依「文質彬彬」，怎麼評價？",
      "options": [
        {
          "id": "a",
          "text": "可以類比看出各有偏重，分別補內容或清楚呈現，再依任務評估"
        },
        {
          "id": "b",
          "text": "只看內容便可判你的整份報告已最佳，不必改進呈現",
          "why": "內容確重要，但凌亂或含糊可能妨礙理解；不能只憑一項優點取消其他檢查。"
        },
        {
          "id": "c",
          "text": "只憑第一印象漂亮，就可判同學的報告已最佳，內容空洞也不必管",
          "why": "呈現可幫助理解，卻不能只憑漂亮外觀替空洞內容評為較好。"
        },
        {
          "id": "d",
          "text": "既各有所長，就完全不必檢查或改進任何不足",
          "why": "承認長處與指出不足可以並行，不等於各自都無須改善。"
        }
      ],
      "answerId": "a",
      "explanation": "可借文質相配反思內容與表達，但這是現代類比。兩章不是報告的固定配分標準，不能直接把君子評語換成成績，也不能斷定兩種不足嚴重程度一樣。",
      "review": {
        "version": "editorial-serial28-3476c1658275eaf2",
        "sha256": "3476c1658275eaf281835acd5be92e2496a321b79acd58813733aa452bab825a",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-shijiao-1",
      "type": "application",
      "refs": [
        485,
        351
      ],
      "concepts": [
        "shijiao"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "由誦讀延伸理解、欣賞及情境運用",
      "stem": "你已熟記一些詩篇，卻很少練習解釋、欣賞或合宜運用。把13.5與17.9作為啟發，哪項改進較直接？",
      "options": [
        {
          "id": "a",
          "text": "保留背誦基礎，增加解釋、感受與依語境運用的練習"
        },
        {
          "id": "b",
          "text": "只增加背誦數量，仍不練習理解或使用",
          "why": "數量可有價值，但此項沒有補上題中已知較少練習的環節。"
        },
        {
          "id": "c",
          "text": "詩詞本來就沒有實用價值",
          "why": "17.9列出多種學詩作用，13.5也在相關任務中討論如何運用；兩章不足以支持詩詞一概無用的結論。"
        },
        {
          "id": "d",
          "text": "應該改讀應用文，不必讀詩",
          "why": "讀其他文體可以有幫助，卻不能由此認定詩無須再讀；題目要補的是所學與理解運用的聯繫。"
        }
      ],
      "answerId": "a",
      "explanation": "13.5在當時辦政與外交語境下批評只多誦而不能用，17.9另列多種學詩作用。現代可設理解、欣賞與表達練習，不必強迫每次作文引詩，也不能把未立即用出來等同從未學到。",
      "review": {
        "version": "editorial-serial28-79b86dcf400cf494",
        "sha256": "79b86dcf400cf4942291e8b0784a0414dd36c813056a264e2c8a6891192c65b6",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-tianming-1",
      "type": "application",
      "refs": [
        411,
        414
      ],
      "concepts": [
        "tianming"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "區分自我改進、外在條件與無據歸咎",
      "stem": "你為一件事準備了很久，結果仍不如意。依「不怨天，不尤人」與「知其不可而為之」，該怎麼安放這件事？",
      "options": [
        {
          "id": "a",
          "text": "復盤可改之處，也辨認不由自己決定的條件，不作無據歸咎"
        },
        {
          "id": "b",
          "text": "既然結果不由自己，以後不必那麼認真",
          "why": "一次结果不如意，不能证明认真准备从此无用。仍须检查可改之处与外在条件；14.38是晨门的评语，也不能据它认定每件事都已客观证明不可能成功。"
        },
        {
          "id": "c",
          "text": "一定是自己還不夠努力，要更拚",
          "why": "結果可能受多種條件影響，不能未查便說一定不夠努力；也不能把自責直接當尤人的詞義。"
        },
        {
          "id": "d",
          "text": "不查任何原因，就把全部責任推给環境和運氣",
          "why": "分析外在條件可以必要，但未查即全數歸咎不是有根據的復盤。"
        }
      ],
      "answerId": "a",
      "explanation": "可以由不怨不尤反思面對挫折的態度，同時檢查行動與條件。這是現代應用，不等於14.35已完整提出可控不可控理論；現注保留上達原意，14.38的評語也應保留其說話者。",
      "review": {
        "version": "editorial-serial28-ce0e87a3fa523de6",
        "sha256": "ce0e87a3fa523de63f1cb3522a895787bfbca387d08aa03715f1c67432cc7465",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-zhengming-1",
      "type": "application",
      "refs": [
        349,
        333
      ],
      "concepts": [
        "zhengming"
      ],
      "difficulty": 2,
      "cognitive": "apply",
      "purpose": "名實相符的組織用法",
      "stem": "社團頭銜與實際分工不一致，已造成責任互推。借13.3及12.11反思現代組織，哪項做法較直接？",
      "options": [
        {
          "id": "a",
          "text": "共同釐清權責，依實際安排調整職務或讓任職者真正履責"
        },
        {
          "id": "b",
          "text": "只管眼前交差，明知責任互推也永不說清分工",
          "why": "辦事可以同步進行，但永久忽略已造成問題的責任不清，未處理題中缺口。"
        },
        {
          "id": "c",
          "text": "取消所有頭銜，也取消分工與負責人，任問題無人處理",
          "why": "取消頭銜未必錯，但此項同時放棄必要分工；無頭銜仍可有清楚責任。"
        },
        {
          "id": "d",
          "text": "安排掛名者象徵性露面，責任仍全部推給別人",
          "why": "若真正承擔責任可以改善，此項卻只改表象，保留原有責任落差。"
        }
      ],
      "answerId": "a",
      "explanation": "此处借名與實的關係檢查現代分工，不是將古代禮制等級原樣搬入社團。責任可以透過調整稱謂或實際履責釐清；沒有某種頭銜，也不代表不能組織工作。",
      "review": {
        "version": "editorial-serial28-699ad85c80f417cf",
        "sha256": "699ad85c80f417cf17da83c7158e62b75e40207fa245ac8ff2e4a3df7ff5332d",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-zhiren-3",
      "type": "application",
      "refs": [
        466
      ],
      "concepts": [
        "zhiren",
        "xin"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨識益友所重的行為，區分坦誠與逢迎",
      "stem": "依「友直，友諒，友多聞，益矣；友便辟，友善柔，友便佞，損矣」，下面哪種朋友屬於「益者」？",
      "options": [
        {
          "id": "a",
          "text": "依事實坦誠指出問題，也尊重你並願意聽取更正"
        },
        {
          "id": "b",
          "text": "當面一味恭維，背後卻故意毀謗你",
          "why": "這更貼近現頁善柔的譯法；問題不在友善言語本身，而在表裡不一。"
        },
        {
          "id": "c",
          "text": "只求把話說得動聽，即使內容不實也不肯修正",
          "why": "此項以空談和不實掩蓋內容，不能把口才本身當可靠證據。"
        },
        {
          "id": "d",
          "text": "為討好你，明知你有錯也附和，拒絕任何實事求是的提醒",
          "why": "此項是明知而逢迎，不等於顧場合、尊重地提醒。"
        }
      ],
      "answerId": "a",
      "explanation": "交友可留意正直、信實與見聞，不必把令人舒服、口才好或懂禮貌視為有害。坦誠也須有事實並願意更正，不能將尖刻或令人難受本身當成益友的證明。",
      "review": {
        "version": "editorial-serial28-47e0b49db9a76672",
        "sha256": "47e0b49db9a7667220603eb7b3dd6088f21afe85ffb371ede7c7c8d8c0cfca9b",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-xue-4",
      "type": "application",
      "refs": [
        172,
        83
      ],
      "concepts": [
        "xue",
        "zhiren"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "見不賢而內自省",
      "stem": "看到同學有誇大自身表現的行為，你想把見不賢而內自省用於自己。下列哪項最直接落實內自省？",
      "options": [
        {
          "id": "a",
          "text": "拿他當鏡子，查自己有無同類毛病"
        },
        {
          "id": "b",
          "text": "確認自己比他強，因此可以放心",
          "why": "「內自省」的方向是向內查自己，不是向外做比較。"
        },
        {
          "id": "c",
          "text": "提醒他改掉這個毛病",
          "why": "提醒可能適當，但此項沒有描述檢查自己是否也有相似行為，與本題所問不同。"
        },
        {
          "id": "d",
          "text": "遠離他，避免受影響",
          "why": "保持距離可以有理由，但不是內自省這個動作；兩者亦可並行。"
        }
      ],
      "answerId": "a",
      "explanation": "可由具體行為反照自己有無相似問題，並採取改進；不因討厭一人就判其全部不賢。自省也不取消合理提醒或必要界線，沒有證據說它在每種情況都比處理他人的行為更優先。",
      "review": {
        "version": "editorial-serial29-337eed1c60f6a86b",
        "sha256": "337eed1c60f6a86b13bfdb02c67537256d39aab31ecb89e04391e20ee7184579",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-ren-3",
      "type": "application",
      "refs": [
        338
      ],
      "concepts": [
        "ren",
        "junzi"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "成人之美的具體做法",
      "stem": "你與同學都想爭取一個競賽名額。以君子成人之美、不成人之惡作為啟發，哪種做法較合適？",
      "options": [
        {
          "id": "a",
          "text": "公平爭取、不拆台，並可分享應公開的有用資訊支持彼此"
        },
        {
          "id": "b",
          "text": "退讓並從此不再爭取這類機會",
          "why": "成人之美不要求放棄自己；下次條件不同，該爭仍可爭。"
        },
        {
          "id": "c",
          "text": "散布不實消息讓對方落選，再說自己只是公平競爭",
          "why": "公平競爭本無不可，但散布不實資訊是另一回事，不能以競爭之名合理化。"
        },
        {
          "id": "d",
          "text": "交換條件：這次幫他造假入選，下次由他幫自己造假",
          "why": "此項所幫的是不正當行為；問題不在所有互惠本身，而在是否助成惡事。"
        }
      ],
      "answerId": "a",
      "explanation": "成全好事可以與自己公平爭取並行，不必將希望自己成功視為小人。具體情境中應分清支持、正當競爭與破壞或造假，不能由一句話推出必須讓出名額。",
      "review": {
        "version": "editorial-serial29-e154de5329e19270",
        "sha256": "e154de5329e192700fcee45fb289d0eea4f04df2c44ce743b7a1523302569964",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-junzi-3",
      "type": "application",
      "refs": [
        403,
        88,
        90,
        29
      ],
      "concepts": [
        "junzi",
        "xin"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "檢查言行是否相符並落實可行承諾",
      "stem": "你在群裡宣布了一個很大的計畫，還沒開始做就收到很多稱讚。依「君子恥其言而過其行」與「先行其言而後從之」，此刻該？",
      "options": [
        {
          "id": "a",
          "text": "核對可行性、說明需調整的承諾，開始落實並回報實際進度"
        },
        {
          "id": "b",
          "text": "不評估資源就繼續加碼承諾，把稱讚當作已能完成的證據",
          "why": "他人稱讚不是可行性或完成證據，追加承諾仍須核對能否履行。"
        },
        {
          "id": "c",
          "text": "悄悄改掉原承諾，卻繼續讓大家相信已全部做到",
          "why": "合理縮小計畫可以有幫助，但此項保留誤導，沒有使言語與實際一致。"
        },
        {
          "id": "d",
          "text": "只要把計畫說出口，就已等於完成承諾，不必再落實",
          "why": "說出口是作出承諾，不等於履行；4.22警惕行動不及言語，2.13要求落實所言。"
        }
      ],
      "answerId": "a",
      "explanation": "可借言行章句檢查宣告是否超出實際，並把重點放回可行步驟與真實回報。事前討論、修正範圍與尋求協助都可必要，不等於必須沉默；也不能從稱讚早來就預言行動必然停止。",
      "review": {
        "version": "editorial-serial29-d857e39b07f7ecca",
        "sha256": "d857e39b07f7ecca128ada13f1b06eb6fca34a3022f1de2bc4cd0fe9ea4fd9a6",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-li-3",
      "type": "application",
      "refs": [
        55,
        261
      ],
      "concepts": [
        "li",
        "xue"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "以慎重請教處理不確定",
      "stem": "新加入一個團隊，很多流程你不清楚。有人說「問這麼多顯得不專業」。依「子入太廟，每事問」，該怎麼做？",
      "options": [
        {
          "id": "a",
          "text": "先查可靠流程，仍不清楚就適時請教，對重要步驟核實而不裝懂"
        },
        {
          "id": "b",
          "text": "怕被看輕，明知不清楚也不查不問，直接假裝會做",
          "why": "自主查閱本可合理；此項卻拒絕任何確認並裝懂，未處理已知不確定。"
        },
        {
          "id": "c",
          "text": "凡看起來是小事，不管是否清楚或有何影響，一律靠猜",
          "why": "是否需要確認要看實際不確定與影響，不是把一切看似小事交給猜測。"
        },
        {
          "id": "d",
          "text": "既然問就是禮，即使已查清也要不分場合反覆打斷別人來問",
          "why": "太廟中每事問的具體記述不能直接化為所有現代場合一律反覆提問的命令；請教應回應實際不確定並尊重情境。"
        }
      ],
      "answerId": "a",
      "explanation": "3.15把適當場合的請教本身視為合禮，可以啟發慎重確認。現代團隊也可先讀文件、整理問題或選合適時機；不必機械照搬成每件事立即問人，更不能以面子為由假裝已知。",
      "review": {
        "version": "editorial-serial29-e8438463c0b6754a",
        "sha256": "e8438463c0b6754ada3889ee723bf9f51e9384b7d5ce7584e3fb07c4f4fb1335",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "ap-zhongyong-2",
      "type": "application",
      "refs": [
        489,
        370
      ],
      "concepts": [
        "zhongyong",
        "zhiren"
      ],
      "difficulty": 1,
      "cognitive": "apply",
      "purpose": "辨明一致好評與不表態是否足以定德行",
      "stem": "一個人常受好評，也少在公開爭議中表態；除此之外資料不多。依13.24並參17.13，哪種評價較審慎？",
      "options": [
        {
          "id": "a",
          "text": "好評與少表態都不足定其德行，還需看具體言行及處境"
        },
        {
          "id": "b",
          "text": "人緣好說明德行好，值得學習",
          "why": "13.24 明說「鄉人皆好之，未可也」，一面倒的好評不是合格證明。"
        },
        {
          "id": "c",
          "text": "只要少表態，就能證明他在所有事情上必然公正",
          "why": "少表態可能有多種原因，不能直接證明公正，也不能反向直接證明虛偽。"
        },
        {
          "id": "d",
          "text": "應該直接指責他虛偽",
          "why": "資料不足時直接斷其虛偽超過證據；應先具體核對，而非永遠不能對行為提出批評。"
        }
      ],
      "answerId": "a",
      "explanation": "13.24提醒一致好評尚不足以定論，17.13批評的鄉愿也不能簡化為所有不公開表態者。可據具體言行與處境判斷，不把受歡迎當合格證，也不把受歡迎本身當有罪證據。",
      "review": {
        "version": "editorial-serial29-3c20f0f0bd7c6a7f",
        "sha256": "3c20f0f0bd7c6a7fa40ea47cd0c333f212fcb6233ce26d5ee37c0ab2184de9bd",
        "gate": "context",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-1-3",
      "type": "misread",
      "refs": [
        3,
        493
      ],
      "concepts": [
        "ren",
        "xin"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "區分花言偽善與一般言辭儀容",
      "stem": "依本頁楊譯及注釋，巧言令色鮮矣仁所批評的重點是？",
      "options": [
        {
          "id": "a",
          "text": "以花言巧語與偽善面貌取悅人，而不只是口才或儀容好"
        },
        {
          "id": "b",
          "text": "會說話、儀容好的人都不可信",
          "why": "口才與整潔儀容本身不等於花言偽善，不能只由外在表現便判所有人不可信。"
        },
        {
          "id": "c",
          "text": "君子應當木訥少言，不修邊幅",
          "why": "本句批評巧言令色，沒有規定人人必須少言或不修邊幅。"
        },
        {
          "id": "d",
          "text": "外表和言辭都不重要，只看內心",
          "why": "批評偽善的表現，不等於宣稱言辭和外在行為都毫無意義。"
        }
      ],
      "answerId": "a",
      "explanation": "現頁以花言巧語、偽善面貌釋巧言令色，注中又有務以說人的說法。應辨其批評對象，不把良好的表達與儀容一概定罪；對具體人物仍需言行證據，不能只憑臉色推定其內心。",
      "review": {
        "version": "editorial-serial29-d9122fafe61c1648",
        "sha256": "d9122fafe61c1648edc2cddc4c6251c923238cc539b7707037e9d7513c873a7a",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-1-11",
      "type": "misread",
      "refs": [
        11,
        86,
        531
      ],
      "concepts": [
        "xiao"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "區分指定頁內讀法與未證外加解釋",
      "stem": "依1.11本頁楊譯注，並參看19.18，哪項最不符合本頁對1.11採取的讀法？",
      "options": [
        {
          "id": "a",
          "text": "無論對錯，三年內一概不許改動"
        },
        {
          "id": "b",
          "text": "道在此按積極義解作父親做法中的合理部分",
          "why": "現注明道可有一般義，但此處採善的好的意思，譯作合理部分。"
        },
        {
          "id": "c",
          "text": "三年在此不必機械限為整整三個年頭，可表示較長時期",
          "why": "現注明古代數字有時指很長期間，不要看得太機械。"
        },
        {
          "id": "d",
          "text": "19.18留父臣父政可作相關個案，但不等於所有做法一概凍結",
          "why": "19.18現注確實連到1.11，仍不能取消1.11本頁对合理部分的限定。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁明確選擇道的積極義並不機械解三年，所以一概不分對錯、整整三年不得變更不合這份注解。這是對指定頁內讀法的核對，不冒稱已排除全部歷代不同解釋。",
      "review": {
        "version": "editorial-serial29-f1f04b3d7f73a51a",
        "sha256": "f1f04b3d7f73a51a71828f1190df2d59187cf10d91f09a0dc8881bf6fdae3893",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-2-11",
      "type": "misread",
      "refs": [
        27
      ],
      "concepts": [
        "xue",
        "jiaoxue"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "分辨溫故知新的主譯與頁內承認的異解",
      "stem": "依2.11本頁譯文與注釋，哪項較完整地說明溫故而知新的讀法？",
      "options": [
        {
          "id": "a",
          "text": "主譯著重溫故中得新體會，注釋也承認溫習舊知與增長新知的另解可通"
        },
        {
          "id": "b",
          "text": "主譯只要求記牢舊內容，完全不涉及新的體會",
          "why": "主譯明說新體會、新發現，不能刪去知新。"
        },
        {
          "id": "c",
          "text": "注釋明確否定皇侃的溫故、知新兩面讀法",
          "why": "注釋在引皇侃說後寫也通，並沒有將它排除。"
        },
        {
          "id": "d",
          "text": "此句已列出所有時代教師資格的唯一完整規則",
          "why": "章句表達可以為師的判斷，不能直接當成跨時代全部資格的完整制度。"
        }
      ],
      "answerId": "a",
      "explanation": "可分清此頁的主譯和注者承認可通的另一解釋。主譯強調溫習舊知時得到新體會，並不代表注者否定一切舊知與新知並進之說；可以為師也不能被擴張為唯一的現代資格規範。",
      "review": {
        "version": "editorial-serial29-89fd8b923c08ee7e",
        "sha256": "89fd8b923c08ee7ee19a9a1497a9e7567a8119b1b6a1a0ac311df046e1869344",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-2-12",
      "type": "misread",
      "refs": [
        28,
        96
      ],
      "concepts": [
        "junzi",
        "xue"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "「君子不器」不是輕視專業",
      "stem": "依2.12本頁譯注，並參看5.4的瑚璉之喻，哪種推論最缺乏依據？",
      "options": [
        {
          "id": "a",
          "text": "君子不該學專門技術，那是工匠的事"
        },
        {
          "id": "b",
          "text": "器皿有一定用途，此句以不受其局限比喻君子",
          "why": "現譯以不像器皿只有一定用途解不器，注亦談通達範圍。"
        },
        {
          "id": "c",
          "text": "5.4瑚璉之喻可供比較，但須分清各章比喻的語境",
          "why": "5.4稱相當尊貴的器，兩章可以比較，但不能只憑器字就決定同一褒貶等級。"
        },
        {
          "id": "d",
          "text": "不局限某種用途，不等於一切專門能力都沒有價值",
          "why": "本句沒有宣布所有具體本領都應放棄，不能由比喻擴成技術禁令。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁用器皿用途的局限說明不器，並非要求不學任何具體技術。5.4另有尊貴器物之喻，可討論兩章如何評人，但不宜補出文本未明示的最高等級或以此定下完整的人格價值理論。",
      "review": {
        "version": "editorial-serial29-a235357052e802ac",
        "sha256": "a235357052e802aca6f1ef33feca0224b1354b7bbc45123236628609c811d2c5",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-2-16",
      "type": "misread",
      "refs": [
        32
      ],
      "concepts": [
        "xue",
        "zhiren"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "準確辨識本頁對攻、斯、已的句法選擇",
      "stem": "攻乎異端斯害也已有不同讀法。以下哪項準確說明本頁楊注採取的解釋？",
      "options": [
        {
          "id": "a",
          "text": "取攻為批判攻擊、斯為承接、已為止，並不採攻作專治的通常讀法"
        },
        {
          "id": "b",
          "text": "它把所有相異主張都列成無差別打擊的固定清單",
          "why": "現譯是批判不正確的議論，並未在此列出一份所有異說一概打擊的清單。"
        },
        {
          "id": "c",
          "text": "它以孔子全書必定沒有分歧作前提，因此不用分析字義句法",
          "why": "此頁實際比較攻的他例及斯、已的功能，不能用預設和諧替代其訓釋論證。"
        },
        {
          "id": "d",
          "text": "它認定異端只能指一份後世各家各教的專名名單",
          "why": "現頁未作這種專名限定，而以主張、言論解釋；不能跨時代直接套用名單。"
        }
      ],
      "answerId": "a",
      "explanation": "此頁依攻的他例及斯、已的用法，採批判不正確議論而止害的解釋，並對專治讀法提出批評。可進一步比較注家的論證，但須先準確陳述其立場；不能因想維持一個預設的孔子形象，就把注者不採的說法改成此頁唯一正解。",
      "review": {
        "version": "editorial-serial29-81a63aa9468e0589",
        "sha256": "81a63aa9468e05894d230f757e35c08e73f4fcbc3387876949d1ab6ad8238575",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-4-8",
      "type": "misread",
      "refs": [
        74
      ],
      "concepts": [
        "xue",
        "yili"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "「朝聞道，夕死可矣」不是輕生",
      "stem": "「朝聞道，夕死可矣」的意思最接近？",
      "options": [
        {
          "id": "a",
          "text": "突出聞道的重要，說即使當夕死去也覺得可以，並非要求主動求死"
        },
        {
          "id": "b",
          "text": "人生短暫，應當及時行樂",
          "why": "句中重點在聞道的價值，沒有以人生短暫推導及時享樂。"
        },
        {
          "id": "c",
          "text": "求道者應當不惜自盡以殉道",
          "why": "即使夕死亦可的說法，不等於要求讀者主動求死；原句沒有這種行動命令。"
        },
        {
          "id": "d",
          "text": "它制定所有求學者只能早晨學習、晚上不准學習的時間表",
          "why": "朝夕在此連到聞道與死亡的對比，不是在規定課程作息。"
        }
      ],
      "answerId": "a",
      "explanation": "可從極端的時間對照看出聞道的分量。這是一句價值表述，不是安排作息，也不應把可字轉成對讀者的死亡要求。是否再作修辭或思想上的延伸，仍須清楚標為解讀。",
      "review": {
        "version": "editorial-serial29-867ffdab3717e9f1",
        "sha256": "867ffdab3717e9f19597e005e7d7f9d459941f3053975657682433e29f4d302a",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-4-15",
      "type": "misread",
      "refs": [
        81
      ],
      "concepts": [
        "shu",
        "ren"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "準確辨識本頁忠恕訓義與說話者",
      "stem": "4.15曾子以忠恕說明夫子之道。依本頁楊注，它如何解釋這裡的忠？",
      "options": [
        {
          "id": "a",
          "text": "以己欲立而立人、己欲達而達人說明，視為恕的積極一面"
        },
        {
          "id": "b",
          "text": "忠於君主，臣事君以忠",
          "why": "此頁用立人、達人的內容解忠，不能把此處範圍僅限於效忠君主。"
        },
        {
          "id": "c",
          "text": "忠厚老實的性情",
          "why": "現注給出具體的推及他人之行為關係，不只是在描述性格忠厚。"
        },
        {
          "id": "d",
          "text": "忠於學說，不改師門宗旨",
          "why": "章旨在說一貫之道的內容，不在門派立場。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子說一以貫之，曾子在孔子離開後以忠恕解說。此頁注者再用己欲立達而立達人釋忠，以勿施於人釋恕。應分清各層說話者；若採盡己為忠等其他公式，須另明來源，而不能冒充本頁直接採用的解釋。",
      "review": {
        "version": "editorial-serial29-bbbd76b6cddfbead",
        "sha256": "bbbd76b6cddfbead2788f82fc2fcbfa963f6d047666a49cac6ad6cb886279bed",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-4-16",
      "type": "misread",
      "refs": [
        82,
        71
      ],
      "concepts": [
        "yili",
        "junzi"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "喻於義不是禁止談利",
      "stem": "依本頁4.16的譯注及4.5的對照，哪項推論缺乏支持？",
      "options": [
        {
          "id": "a",
          "text": "君子不可談論利益，一談利即為小人"
        },
        {
          "id": "b",
          "text": "喻在此譯為懂得，句中以義與利作對照",
          "why": "這符合現譯用語，但不等於已建立所有判斷的固定先後程序。"
        },
        {
          "id": "c",
          "text": "4.5承認富貴可欲並限制取得方式，可與本章相參",
          "why": "4.5提供欲與取法的區別，不等於談及利益本身一律被禁止。"
        },
        {
          "id": "d",
          "text": "此處君子小人的身分、德行或兼指含義，現注仍保留疑問",
          "why": "現注明言原意不得而知，不能擅自取消其中一種可能。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁沒有把談利定為小人的充分條件。義利對照可與4.5的正當取法相參，同時保留君子、小人所指的注釋疑問；不能把它改成一份已確定身分定義與先後次序的完整判人程序。",
      "review": {
        "version": "editorial-serial29-fcb6610da3543f0d",
        "sha256": "fcb6610da3543f0d86995532cbf21fbe19f6b6a5e5ddae1834cf427211bcb4dc",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-6-29",
      "type": "misread",
      "refs": [
        149,
        489,
        370
      ],
      "concepts": [
        "zhongyong"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "區分有判準的調和與無是非的附和",
      "stem": "依6.29與17.13本頁譯注，把中庸說成不問是非、只求迎合所有人，主要問題是？",
      "options": [
        {
          "id": "a",
          "text": "把無過不及的調和偷換成無是非的附和，不能因此認定所有沉默者都是鄉愿"
        },
        {
          "id": "b",
          "text": "沒有錯，中庸本來就是與人為善",
          "why": "現注對中與庸有具體解釋；善意待人不能被偷換成不問是非、只求迎合。"
        },
        {
          "id": "c",
          "text": "錯在中庸要求永遠站在多數那一邊",
          "why": "13.24說眾人都喜歡還不足下定論，轉而區分善者與不善者的評價；不能把人數多當成唯一判準。"
        },
        {
          "id": "d",
          "text": "錯在中庸只適用於治國，不適用於處世",
          "why": "6.29稱中庸為德，這一章沒有明說只准用於治國，不能自行加上該限制。"
        }
      ],
      "answerId": "a",
      "explanation": "此頁解中為折中、無過不及、調和，不能以口號取消折中二字；但調和也不能被偷換為明知問題仍一味附和。17.13可提供另一種批評面向，並不使是否公開站隊成為判鄉愿的唯一測試。",
      "review": {
        "version": "editorial-serial29-fba712bd5ed274d9",
        "sha256": "fba712bd5ed274d971c4fc6591503c5845f5977fecb3bc90cbb3d2a5204e4e3e",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-7-22",
      "type": "misread",
      "refs": [
        172
      ],
      "concepts": [
        "xue",
        "zhiren"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "把可取法與全人優越、教師身分分開",
      "stem": "「三人行，必有我師焉」常被單獨引用。完整讀下去，重點是？",
      "options": [
        {
          "id": "a",
          "text": "擇善而從，不善者亦可據以自改"
        },
        {
          "id": "b",
          "text": "任何人都比自己強，要保持謙虛",
          "why": "原句沒有說別人都強；它說的是無論善不善，都能取為借鏡。"
        },
        {
          "id": "c",
          "text": "要多結交比自己優秀的朋友",
          "why": "結交值得學習的人可以有益，但本句还說可由不善之處反省改進，並不只談選朋友。"
        },
        {
          "id": "d",
          "text": "每逢恰好三人同行，就證明其中必有一位正式任教的老師",
          "why": "現譯談可取法的人與善不善，不是在推算同行者的職業身分。"
        }
      ],
      "answerId": "a",
      "explanation": "後半句把取法的方式展開：學習善處，也借不善反省改正。無須把別人全人都判得比自己強，亦不以正式教師資格作為能否從中學習的界線。",
      "review": {
        "version": "editorial-serial29-997d3e03f8e0da21",
        "sha256": "997d3e03f8e0da21a33da99f4c44a62e695de56995ae88ae9f32d27bcf85eb0e",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-8-9",
      "type": "misread",
      "refs": [
        197
      ],
      "concepts": [
        "zheng",
        "jiaoxue"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "準確呈現8.9主譯與異解，再區分章句解釋和整體評價",
      "stem": "依本頁8.9譯注，怎樣陳述其解讀與可作的評價較準確？",
      "options": [
        {
          "id": "a",
          "text": "本頁主譯為可以使民循行、不可以使知所以然，並反駁另行斷句；全書評價仍須另行論證"
        },
        {
          "id": "b",
          "text": "只憑這一句即可斷定孔子所有教學都以阻止學生理解為目的",
          "why": "本句可作批評與比較的材料，但把此处民的處置擴成所有教學的唯一目的，超過此章所能證明。"
        },
        {
          "id": "c",
          "text": "本頁已證明百姓天生沒有理解道理的能力",
          "why": "現譯陳述使由而不使知，沒有證明天生能力不足，不能把政治或教育安排偷換成先天事實。"
        },
        {
          "id": "d",
          "text": "此句是後人竄入，不必理會",
          "why": "沒有版本證據支持刪削，迴避也不是讀法。"
        }
      ],
      "answerId": "a",
      "explanation": "先忠實辨明所讀版本的選擇：本頁主譯說可以使民照道路走、不可以使他們知道為什麼，且從詞義、語法反駁若干回護式改讀。讀者可以批評或比較這一解讀；保留異解並不等於注者都接受。不能以預設孔子必定一致來改寫注釋，也不能用單句完成對全書的總判。",
      "review": {
        "version": "editorial-serial29-1903286f24b0bfe8",
        "sha256": "1903286f24b0bfe8e10f3e5f3e10a16425f0dcfeae44472fc316883defc4b095",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-8-14",
      "type": "misread",
      "refs": [
        202,
        402
      ],
      "concepts": [
        "chushi",
        "zheng"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨別職位與政務範圍，不擴寫成言論或兼職禁令",
      "stem": "連讀8.14與14.26，哪項最貼近本頁譯文而不增添額外禁令？",
      "options": [
        {
          "id": "a",
          "text": "不在那個職位，便不考慮其政務；曾子又以思不出位強調職務範圍"
        },
        {
          "id": "b",
          "text": "不在位就不必關心公共事務，明哲保身即可",
          "why": "現譯針對那個職位及其政務，沒有推成對所有公共事務一概不必關心。"
        },
        {
          "id": "c",
          "text": "沒有職位的人沒有資格發表意見",
          "why": "本章沒有直接制定只有任職者才有發言資格的普遍規則。"
        },
        {
          "id": "d",
          "text": "做官要專心本職，不可兼任他職",
          "why": "講的是謀與不謀，不是兼職制度。"
        }
      ],
      "answerId": "a",
      "explanation": "位與其政相連，曾子的思不出位也延續職務範圍的意思。可以由此討論分際，但不應直接加上禁止公共評論或禁止兼職等原章沒有寫出的規定。其政治含義仍可另作有依據的討論。",
      "review": {
        "version": "editorial-serial29-e4328fb555a25bca",
        "sha256": "e4328fb555a25bca06acadc66e305530906aa61b8ade32de44bd4825eb17703c",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-9-25",
      "type": "misread",
      "refs": [
        8,
        234
      ],
      "concepts": [
        "xin",
        "zhiren"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "分清字面主譯、異解與交友條件的邏輯推論",
      "stem": "對1.8及9.25「無／毋友不如己者」，哪項最符合本頁注釋與句中條件？",
      "options": [
        {
          "id": "a",
          "text": "本頁就字面譯出並承認異解；排除不如者，不能直接推出只准高攀或無人可交"
        },
        {
          "id": "b",
          "text": "不如自己等於沒有勝過自己，因此連與自己相當者也一律不得交友",
          "why": "不如與未勝過並非同一條件，後者還包含相當者；不能由原句直接加上只許高攀。"
        },
        {
          "id": "c",
          "text": "問題在於孔子看不起窮人",
          "why": "這一句沒有直接把不如限定為財富較少，不能據此斷言排斥窮人。"
        },
        {
          "id": "d",
          "text": "問題在於這句是子夏說的，不能代表孔子",
          "why": "1.8與9.25都以子曰引出，並未繫於子夏。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁的主譯採字面意思，注釋同時承認古今有疑問與異解，沒有在此確立志趣相類為唯一解。討論時也要檢查推論：排除不如者，不等於排除相當者，因而不能直接宣稱必然人人高攀、全無可交。",
      "review": {
        "version": "editorial-serial29-3d43e9f76700168e",
        "sha256": "3d43e9f76700168e893b37c894cfdae3325315d864268de474ee451b0eefcf83",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-11-16",
      "type": "misread",
      "refs": [
        286
      ],
      "concepts": [
        "zhongyong",
        "jiaoxue"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "依問答理解過與不及的比較，避免人物全盤定級",
      "stem": "子貢問師與商孰賢，孔子說「過猶不及」。這句話的意思是？",
      "options": [
        {
          "id": "a",
          "text": "在這項比較中，過分與趕不上同樣不好，不能因過就認定師更好"
        },
        {
          "id": "b",
          "text": "子張勝過子夏，因為過總比不及好",
          "why": "子貢正是這樣追問「然則師愈與」，孔子當即否定。"
        },
        {
          "id": "c",
          "text": "兩人一樣好，各有長處",
          "why": "本頁譯作同樣不好，不能把此處的比較轉成兩端同樣可取；這也不等於否定兩人全部長處。"
        },
        {
          "id": "d",
          "text": "凡事取兩人的中間值就對了",
          "why": "此章沒有提供數值或求平均的規則，不能把兩人的表現直接換成固定中間值。"
        }
      ],
      "answerId": "a",
      "explanation": "孔子先指出師過、商不及，再以過猶不及回應師是否更強的追問。判斷重點是兩端都存在偏失，不應擴成對兩人一切品行或能力的不合格認定。",
      "review": {
        "version": "editorial-serial29-dd22ba015225ae01",
        "sha256": "dd22ba015225ae011d31025a25e8f15cd8d281209a7fb185345a119f46395329",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-12-1",
      "type": "misread",
      "refs": [
        323
      ],
      "concepts": [
        "ren",
        "li"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "克己不是滅己",
      "stem": "依12.1本頁譯文與四勿的上下文，哪項解釋增加了原章未說的要求？",
      "options": [
        {
          "id": "a",
          "text": "徹底消滅個人欲望，不再有所想要"
        },
        {
          "id": "b",
          "text": "抑制自己，使言語行動合於禮",
          "why": "現譯以抑制自己、使言語行動合禮解釋克己復禮，與後文四勿相連。"
        },
        {
          "id": "c",
          "text": "下文非禮勿視聽言動即其操作清單",
          "why": "顏淵請問其目之後，孔子列出視、聽、言、動四項行動綱領。"
        },
        {
          "id": "d",
          "text": "為仁由己表明此事由自己發動",
          "why": "同章下句明言「為仁由己，而由人乎哉」，不誤。"
        }
      ],
      "answerId": "a",
      "explanation": "讀克己須連到復禮、四勿與為仁由己：本頁要求言行合禮，且實踐由自己承擔，並沒有命令一切欲求都消失。這是依本章譯文所作的範圍辨析，不靠取消自我便沒有語法主語之類推論。",
      "review": {
        "version": "editorial-serial29-ddb43c97d29de0d3",
        "sha256": "ddb43c97d29de0d3f6a8b7f63cad2cd1f344ccb465b76a8778945c94adc3b72b",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-12-11",
      "type": "misread",
      "refs": [
        333
      ],
      "concepts": [
        "zhengming",
        "zheng"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨明君臣父子各受角色要求，不推成完全對等",
      "stem": "只依12.11本章，「君君，臣臣，父父，子子」是否只要求臣與子？",
      "options": [
        {
          "id": "a",
          "text": "不是：君與父也在要求之列；各方應符合自身角色，但本句未說責任完全對等"
        },
        {
          "id": "b",
          "text": "是：這是等級秩序的宣示，下位者須絕對服從",
          "why": "君君與父父同樣對上位角色提出要求，不能把四項濃縮成下位者的無條件服從。"
        },
        {
          "id": "c",
          "text": "是：孔子答齊景公，就是勸他加強統治",
          "why": "回答景公的問題不等於提出加強壓制；本章明列君臣父子各自應有的表現。"
        },
        {
          "id": "d",
          "text": "不是：這句其實在勸君主放權",
          "why": "本章提出角色要求，沒有直接規定如何分配或轉讓權力。"
        }
      ],
      "answerId": "a",
      "explanation": "四項都在說相應角色應有的表現，所以不能只剩臣與子的義務。這一點也不等於已證明現代意義的完全平等、附條件服從，或某方失職便取消另一方的身分；延伸論證須另有依據。",
      "review": {
        "version": "editorial-serial29-d46a73e1f3aa0cd1",
        "sha256": "d46a73e1f3aa0cd168be2355bc7e4f4ab4079ee62604cb8afdc6b4fb9b5b8ce3",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-12-5",
      "type": "misread",
      "refs": [
        327
      ],
      "concepts": [
        "tianming",
        "junzi"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨識本章直接發言者與未指明的所聞來源",
      "stem": "「死生有命，富貴在天」「四海之內，皆兄弟也」——這些話是誰說的？",
      "context": "司马牛忧曰：“人皆有兄弟，我独亡。”子夏曰：“商闻之矣：死生有命，富贵在天……”",
      "options": [
        {
          "id": "a",
          "text": "子夏說的，且自稱是「商聞之矣」"
        },
        {
          "id": "b",
          "text": "孔子親口對司馬牛說的",
          "why": "這個話輪以子夏曰引出，並非本章記孔子當面向司馬牛說；所聞的原始來源則未交代。"
        },
        {
          "id": "c",
          "text": "司馬牛的自我寬解",
          "why": "司馬牛只說了「人皆有兄弟，我獨亡」，安慰是子夏給的。"
        },
        {
          "id": "d",
          "text": "《論語》編者的按語",
          "why": "正文以子夏曰引出這段話，足以判定是人物發言，不能改稱編者在此所加的按語。"
        }
      ],
      "answerId": "a",
      "explanation": "引用時先說清楚這段是子夏對司馬牛的回應，且以商聞之矣引入所聞。文本沒有指明聽自誰，不能把直接說話者與思想的最初來源混為一談，也不能從這一章斷言其與孔子思想全然無關。",
      "review": {
        "version": "editorial-serial29-dfeb05d3abcc1171",
        "sha256": "dfeb05d3abcc1171ccd9e344adeb302360b29bd200092c6c495599ade4750819",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-13-5",
      "type": "misread",
      "refs": [
        351
      ],
      "concepts": [
        "shijiao",
        "xue"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "背得多不等於學會",
      "stem": "「誦《詩》三百，授之以政，不達；使於四方，不能專對；雖多，亦奚以為？」批評的是？",
      "options": [
        {
          "id": "a",
          "text": "背熟卻不能用於政事與應對"
        },
        {
          "id": "b",
          "text": "《詩》本身沒有實用價值，不必多讀",
          "why": "注釋說明當時外交常用詩篇交涉，正呈現詩在此情境的用途；批評熟讀卻不能辦事，不等於否定讀詩。"
        },
        {
          "id": "c",
          "text": "背誦數量不夠，三百篇還太少",
          "why": "「雖多」正說明數量已經不少，問題不在多寡。"
        },
        {
          "id": "d",
          "text": "應當專攻政事，不必學文學",
          "why": "他要的正是《詩》能用於政事，不是二選一。"
        }
      ],
      "answerId": "a",
      "explanation": "本章以政務能否辦通、出使能否獨立應對，檢查熟讀是否能在相應任務中運用。這說明單靠篇數不足以證明這些能力，不表示背誦毫無價值，更不是所有學習只能採用同一評分尺度。",
      "review": {
        "version": "editorial-serial29-f5f64325d2b749e2",
        "sha256": "f5f64325d2b749e2468572c28a0d6db04130ec4441356530b980d62f5e8ff8bd",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-14-38",
      "type": "misread",
      "refs": [
        414
      ],
      "concepts": [
        "chushi",
        "tianming"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "辨識晨門評語的發言者與內容，不預判褒貶",
      "stem": "「是知其不可而為之者與？」這句話的性質是？",
      "options": [
        {
          "id": "a",
          "text": "守門人的評語，點出他明知不可仍為"
        },
        {
          "id": "b",
          "text": "孔子的自述，表明他固執不通",
          "why": "此話出自晨門，不是孔子自述；其褒貶語氣仍須另論，不能只因發言者判對便一併定案。"
        },
        {
          "id": "c",
          "text": "子路對老師的抱怨",
          "why": "子路只回答「自孔氏」，評語出自晨門。"
        },
        {
          "id": "d",
          "text": "讚美孔子有先見之明，早知不可",
          "why": "評語同時說知不可與仍為，不能只保留預知；本頁也未明定這必是讚美。"
        }
      ],
      "answerId": "a",
      "explanation": "先沿話輪確認：子路答自孔氏，晨門再問是知其不可而為之者與。這足以辨明發言者與所說內容；若要判定讚賞、譏評或與其他人物立場的關係，仍需更多論據。",
      "review": {
        "version": "editorial-serial29-9518d8a90a49da23",
        "sha256": "9518d8a90a49da23ef917f38f1ffb148d5a41766c02b52c2b1aebfabffbc0d9d",
        "gate": "recall",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-15-39",
      "type": "misread",
      "refs": [
        459,
        141
      ],
      "concepts": [
        "jiaoxue"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "區分教育對象與教學內容，判斷是否必然矛盾",
      "stem": "依15.39與6.21本頁譯文，如何判斷兩句是否必然矛盾？",
      "options": [
        {
          "id": "a",
          "text": "未必：一處說教育對象不分貧富地域等，一處說高深內容是否適合其水平"
        },
        {
          "id": "b",
          "text": "矛盾：孔子前後主張不一",
          "why": "兩句分別涉及誰受教育及是否講高深內容，不能不作區分便斷言前後互相否定。"
        },
        {
          "id": "c",
          "text": "不矛盾：後一句是說中人以下不必教",
          "why": "現譯不可以告以高深學問，並未說不再給予任何教育。"
        },
        {
          "id": "d",
          "text": "矛盾：所以「有教無類」應解作按類施教",
          "why": "本頁把無類譯成沒有貧富地域等區別，不能為消除矛盾直接改成按類施教。"
        }
      ],
      "answerId": "a",
      "explanation": "可區分教育對象與內容深淺：不以貧富地域等排除教育，不要求所有人立即接受同樣高深的內容。這一文本分析未必能直接回答古代辦學的一切實際限制，更不應據此把人的學習水平判為永遠不可改變。",
      "review": {
        "version": "editorial-serial29-bf0b0ca41b32caad",
        "sha256": "bf0b0ca41b32caad5a6e3700b528ac5de39e6857cbdbdae72187ad3e7bf83f80",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-16-1",
      "type": "misread",
      "refs": [
        463
      ],
      "concepts": [
        "zheng",
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "依現譯注理解均與安，區別平均表述和未明定的分配算法",
      "stem": "依16.1本頁譯文與貧寡校勘說明，哪项對「均」的陳述最準確？",
      "options": [
        {
          "id": "a",
          "text": "本頁以財富平均解說均，並聯繫安定；本章沒有列出人人所得的具體計算規則"
        },
        {
          "id": "b",
          "text": "絕對平均，人人所得完全一樣",
          "why": "現譯確有財富平均，卻沒有給出任何時地人人數量完全一致的分配算法；不能把具體制度直接補入。"
        },
        {
          "id": "c",
          "text": "均衡發展，各行各業並重",
          "why": "本章圍繞財富、人民、安定與是否用兵展開，未提出各行各業並重的產業政策。"
        },
        {
          "id": "d",
          "text": "平均主義的最早主張，反對一切差等",
          "why": "本章不能獨自證明某思想最早出現，也沒有直接宣布取消所有差等。"
        }
      ],
      "answerId": "a",
      "explanation": "先準確讀出本頁：譯文使用財富平均，注釋另提出貧寡字序的校勘。應分清原句、校勘意見與譯文，不能把校語當成孔子原話；同時，本章並未列出分配算法，不能僅以平均或各得其分的口號代替完整論證。",
      "review": {
        "version": "editorial-serial29-89d468d6dcc16fe2",
        "sha256": "89d468d6dcc16fe22701a52585443092f86592e1862c24b3d76eb4afcb1e0ae4",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-17-4",
      "type": "misread",
      "refs": [
        480
      ],
      "concepts": [
        "jiaoxue",
        "li"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "「割雞焉用牛刀」是玩笑而非否定",
      "stem": "子游在武城以禮樂為治，孔子笑說「割雞焉用牛刀」。這句話該怎麼看？",
      "options": [
        {
          "id": "a",
          "text": "是玩笑話，孔子隨即自承前言戲之"
        },
        {
          "id": "b",
          "text": "孔子認為小地方不必行禮樂，是嚴肅的批評",
          "why": "他隨即自承是開玩笑，並肯定子游說得對。"
        },
        {
          "id": "c",
          "text": "前言戲之耳是子游替老師辯解，孔子本人沒有回應",
          "why": "前言戲之耳位於子曰所引話輪，明確是孔子本人的回應。"
        },
        {
          "id": "d",
          "text": "此句在教授宰雞的技術，和武城所聞的弦歌及教學無關",
          "why": "上下文由弦歌轉到子游引述學道之效，再由孔子肯定，不能只當作烹飪技術。"
        }
      ],
      "answerId": "a",
      "explanation": "讀到偃之言是也、前言戲之耳，才能確認前句在此章的語氣與結論。末句明確肯定子游，並把割雞牛刀的話說成戲語；可以討論師生互動，不必再補成原文沒有記載的正式道歉。",
      "review": {
        "version": "editorial-serial29-9a2236e81babdbcb",
        "sha256": "9a2236e81babdbcb5224c309dafb7be78b0d3646812cacde1679c59e96f3aef9",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-17-25",
      "type": "misread",
      "refs": [
        501
      ],
      "concepts": [
        "zhiren"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "忠實呈現有爭議文本，區分批評、異解證據和刪削",
      "stem": "本頁17.25譯文對女子與小人作負面概括，且沒有列出實質注釋。下列處理哪項較有文本依據？",
      "options": [
        {
          "id": "a",
          "text": "準確呈現現譯並允許批評其中的性別概括；其他解釋或時代背景須另附證據"
        },
        {
          "id": "b",
          "text": "只憑本章便能證明全書每一句都在論證女性與小人難以共處",
          "why": "本章可以受到批評，但不能由此推得全書所有句子都有同一內容；讀者是否繼續閱讀則是另一回事。"
        },
        {
          "id": "c",
          "text": "強行解釋成褒義，證明孔子並無此意",
          "why": "本頁譯文是負面概括，不能只為維護作者形象就無證改成讚美女性。"
        },
        {
          "id": "d",
          "text": "此句必為後人竄入，應當刪去",
          "why": "無版本依據的刪削，是用主觀取代考證。"
        }
      ],
      "answerId": "a",
      "explanation": "先把實際文本說準：本頁如此翻譯，且未附實質異解說明。讀者可批評其對女性的概括；若提出不同詞義、歷史背景或版本問題，須提供相應證據。背景可以幫助理解，並不自動使負面概括合理。",
      "review": {
        "version": "editorial-serial29-32911dbdc176a91c",
        "sha256": "32911dbdc176a91c581f3e557d5374ee2273940ffbbc7e4f294756c0f7e217a4",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-19-13",
      "type": "misread",
      "refs": [
        526
      ],
      "concepts": [
        "xue",
        "chushi"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "「學而優則仕」的優不是優秀",
      "stem": "依19.13本頁譯文，「仕而優則學，學而優則仕」的優怎麼講？",
      "options": [
        {
          "id": "a",
          "text": "有餘力：任官而有餘力可學，學習而有餘力可仕"
        },
        {
          "id": "b",
          "text": "優秀：學得好就可以做官",
          "why": "本頁兩處均譯為有餘力，不是以成績優秀作為自動取得官職的規則。"
        },
        {
          "id": "c",
          "text": "優先：應當先學後仕",
          "why": "優在本頁表有餘力，不是優先；兩句各說在一種活動之外仍有餘力時的選擇。"
        },
        {
          "id": "d",
          "text": "優待：學得好的人應受優待",
          "why": "本頁解作餘力，没有提出給學習優秀者特別待遇。"
        }
      ],
      "answerId": "a",
      "explanation": "這是子夏的話。本頁把兩處優都譯為有餘力，應把仕而優則學與學而優則仕一併讀出。可由此討論學習與任事的關係，但不要把互相補給等延伸概括當成優字本身的訓釋。",
      "review": {
        "version": "editorial-serial29-d0e889c2b4027aab",
        "sha256": "d0e889c2b4027aab5d7b25b81be60f33ba0eaa777fbe3e3ad81b0095a762dfd8",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-10-8",
      "type": "misread",
      "refs": [
        248
      ],
      "concepts": [
        "li"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "依10.8具體飲食細則判斷推論範圍",
      "stem": "連讀10.8飲食細則及本頁注釋，哪項說法最有依據？",
      "options": [
        {
          "id": "a",
          "text": "此段兼列精細、腐敗不食與飲食節制等細則，未限定全是祭食，也不足單憑此段斷定生活奢侈"
        },
        {
          "id": "b",
          "text": "孔子確實生活奢侈，講究飲食精細",
          "why": "精細飲食可作討論材料，但不足獨自證明整體生活奢侈；同段還有肉不超主食、飲酒不至亂等限制。"
        },
        {
          "id": "c",
          "text": "這是後人偽託，用以貶低孔子",
          "why": "本頁未提供偽託或刪削的版本證據，不能因不合預期就宣布後人杜撰。"
        },
        {
          "id": "d",
          "text": "現注已排除所有關乎身體的考量，只許解為祭祀儀式",
          "why": "本頁未把全段限於祭食，且不時的注釋引用食能以時身必無災，不能說身體考量已被完全排除。"
        }
      ],
      "answerId": "a",
      "explanation": "先逐項辨認這段說了什麼，再評估推論。它既有精細飲食，也有腐敗不食、份量與飲酒的限制。這些可以引出禮儀或身體等討論，但沒有證據可把整段一律限定為祭食，或單憑兩句就定出整體生活是否奢侈。",
      "review": {
        "version": "editorial-serial29-d4316ec06d1ecc54",
        "sha256": "d4316ec06d1ecc541bf9d6d4c1d991aac688db7cc3d4d437aa586b131b4fb497",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-6-27",
      "type": "misread",
      "refs": [
        147,
        337
      ],
      "concepts": [
        "xue",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "understand",
      "purpose": "辨明約的字義，保留之所指的兩種註解",
      "stem": "依6.27本頁譯注，「約之以禮」中的約及之應怎樣理解？",
      "options": [
        {
          "id": "a",
          "text": "約指約束；之有指君子或指文兩說，本頁注釋把兩者分開討論"
        },
        {
          "id": "b",
          "text": "簡約：學問要學得少而精",
          "why": "本句以博學於文為前提，約並非要求把廣泛學習改成只學少數內容。"
        },
        {
          "id": "c",
          "text": "約定：與人約定共同守禮",
          "why": "本頁譯約束，注釋爭議在之所指的人或文，不在是否與別人訂約。"
        },
        {
          "id": "d",
          "text": "節約：學習要節省時間與精力",
          "why": "本句以禮為約束依據，沒有節省學習時數的安排。"
        }
      ],
      "answerId": "a",
      "explanation": "约的基本方向是約束，但之指誰或什麼仍要辨明。本頁列出指君子的通常讀法，也列毛奇齡所說以禮約文；它更提醒不要把此句與博我以文、約我以禮直接當成完全相同。",
      "review": {
        "version": "editorial-serial29-3bcdc8312cd4968f",
        "sha256": "3bcdc8312cd4968f9181832506f442fc32a1400e60f0ab60551c5e555dafc384",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-7-1b",
      "type": "misread",
      "refs": [
        151,
        39,
        212
      ],
      "concepts": [
        "xue",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "好古不等於反對變革",
      "stem": "連讀7.1、2.23與9.3，「信而好古」是否足以推出孔子反對一切變革？",
      "options": [
        {
          "id": "a",
          "text": "不是：他明說禮有損益，也接受變通"
        },
        {
          "id": "b",
          "text": "是：他主張完全恢復周制，不容更改",
          "why": "9.3「麻冕，禮也；今也純，儉，吾從眾」正是他自己接受更改的例子。"
        },
        {
          "id": "c",
          "text": "是：所以他說「述而不作」",
          "why": "7.1現注說作大概涉及不知而作，且不認為可斷孔子全無創造；不能只憑不作兩字排除所有變通。"
        },
        {
          "id": "d",
          "text": "不是：他其實不重視古制，只是說說",
          "why": "他確實重古，只是重古與可損益並不衝突。"
        }
      ],
      "answerId": "a",
      "explanation": "2.23談歷代禮制的沿襲與損益，9.3則記孔子本人的不同取捨：絲冕省儉而從眾，拜下因禮意而不從眾。這足以否定一切不得改，卻不表示所有改變都受肯定，亦不表示他不再重視古代文化。",
      "review": {
        "version": "editorial-serial29-6be439b95cb857d9",
        "sha256": "6be439b95cb857d9998978503a7f297e71d7bc40bbe566e028a1d27af90416af",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-9-11",
      "type": "misread",
      "refs": [
        220
      ],
      "concepts": [
        "jiaoxue",
        "xue"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "「循循然善誘」的具體所指",
      "stem": "顏淵說孔子「循循然善誘人，博我以文，約我以禮」。「善誘」具體指？",
      "options": [
        {
          "id": "a",
          "text": "有步驟地引導，以文獻豐富知識，以禮約束行為"
        },
        {
          "id": "b",
          "text": "只靠口才使人心服，與文獻學習和禮的約束無關",
          "why": "後句明列文與禮如何作用於顏淵，不能把善誘縮成只靠口才使人心服。"
        },
        {
          "id": "c",
          "text": "善於誘導學生說出自己的想法",
          "why": "引出學生想法可以是一種教法，但此段具體提到的是文獻豐富知識與禮約束行為，沒有展示那種提問過程。"
        },
        {
          "id": "d",
          "text": "循規蹈矩地按課本教學",
          "why": "「循循」是有次序，不是守成規。"
        }
      ],
      "answerId": "a",
      "explanation": "顏淵先說善誘，再以博我以文、約我以禮說明自己的學習經驗。本頁譯作有步驟地引導，不必再補成兩種活動永遠不能交錯的固定課程，也不能把欲罷不能當作每位學生必有的效果。",
      "review": {
        "version": "editorial-serial29-51724b6fb9b345d7",
        "sha256": "51724b6fb9b345d7f44f65731acdf994c3f865e4d4c66b10164c3591bc259ffd",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-15-9",
      "type": "misread",
      "refs": [
        429
      ],
      "concepts": [
        "ren",
        "yili"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "忠實理解殺身成仁的倫理表述，避免擴成日常傷害指令",
      "stem": "依15.9原文與本頁譯文，哪項表述既忠實又不作過度推論？",
      "options": [
        {
          "id": "a",
          "text": "本章把守仁置於求生之上並肯定為仁犧牲，卻未說日常遇困難應求死，或只有死亡才成仁"
        },
        {
          "id": "b",
          "text": "任何日常挫折都應主動求死，以此證明自己的仁德",
          "why": "原文談求生害仁與殺身成仁的倫理取捨，沒有把任何日常挫折變成主動求死的要求。"
        },
        {
          "id": "c",
          "text": "它證明生命在任何情境都毫無價值，不值得保護",
          "why": "此處對仁與求生的取捨，不足以推出生命在所有情境均無價值。"
        },
        {
          "id": "d",
          "text": "只有死了才能成就仁",
          "why": "有殺身以成仁沒有說只有如此才成仁，不能把一種表述改成唯一必要途徑。"
        }
      ],
      "answerId": "a",
      "explanation": "不應為緩和古文而抹去其肯定犧牲的內容，也不應把古代倫理表述當成日常行動指令。可以分析它如何排列仁與求生的價值，但不能由此要求遇到挫折的人傷害自己，或把死亡當成證明品德的唯一方式。",
      "review": {
        "version": "editorial-serial29-69e90d2f0dddbbf3",
        "sha256": "69e90d2f0dddbbf337bb4f8e44df22adf74df0f7592c5bcf0e93982a56024c2e",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-3-1",
      "type": "misread",
      "refs": [
        41
      ],
      "concepts": [
        "li",
        "zhengming"
      ],
      "difficulty": 1,
      "cognitive": "understand",
      "purpose": "依八佾等級註解理解孔子對季氏的批評",
      "stem": "「八佾舞於庭，是可忍也，孰不可忍也？」——依本頁譯注，孔子這段話主要批評什麼？",
      "options": [
        {
          "id": "a",
          "text": "以大夫之身用天子之樂，是僭越"
        },
        {
          "id": "b",
          "text": "季氏舞蹈的動作不合規矩，跳得難看",
          "why": "問題在規格等級（八佾為天子之數），不在舞得好不好。"
        },
        {
          "id": "c",
          "text": "孔子不喜歡樂舞這種娛樂",
          "why": "本章批評季氏使用的規格，並未說一切樂舞都不可取；不能把對特定行為的批評擴為全面反樂舞。"
        },
        {
          "id": "d",
          "text": "季氏在自家庭院辦活動擾民",
          "why": "本頁未提供擾民的具體證據；所列八佾與四佾規格指向逾越禮制等級。"
        }
      ],
      "answerId": "a",
      "explanation": "本頁注釋說八佾是天子規格，季氏作為大夫只應用四佾，因此批評指向逾越其禮制等級。忍字本頁採狠心做得出的解釋，並反對容忍讀法；其他解釋可另作比較，但不應把它們說成本頁同時採納。",
      "review": {
        "version": "editorial-serial29-eb8897fa0b3ca346",
        "sha256": "eb8897fa0b3ca346d0e8ffd45d922cf6c07f4ce5bec31d2bdee6214cfe6de6dd",
        "gate": "meaning",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    },
    {
      "id": "mr-11-26",
      "type": "misread",
      "refs": [
        296
      ],
      "concepts": [
        "chushi",
        "li"
      ],
      "difficulty": 2,
      "cognitive": "analyze",
      "purpose": "「吾與點也」不是否定其他三人",
      "stem": "四子言志，孔子喟然嘆「吾與點也」。這是否表示他否定了子路、冉有、公西華的志向？",
      "options": [
        {
          "id": "a",
          "text": "不能如此推斷：後文區分子路言不讓、冉有所言邦事及公西華可任大相，並非全盤否定"
        },
        {
          "id": "b",
          "text": "是：他認為從政都不足取，只有隱逸可貴",
          "why": "章末仍討論三人所言的邦事和禮讓，並肯定公西華的能力，不能概括為全部從政都不足取。"
        },
        {
          "id": "c",
          "text": "是：曾晳的答案最高明，其餘都錯",
          "why": "吾與點也表示贊同曾點，並不等於其他三人全部錯；應連讀後面的分別評論。"
        },
        {
          "id": "d",
          "text": "不是：他只是喜歡春天的景色",
          "why": "本頁譯同意曾點主張，不只是對景色的喜好；至於贊同的完整理由，仍要結合章內證據討論。"
        }
      ],
      "answerId": "a",
      "explanation": "讀到吾與點也不能就停止。後文指出子路說話不謙讓，辨明冉有、公西華同樣談邦事，又肯定公西華可任大相。這些差別評語既不是全盤否定，也不是對三人不加區別的褒獎。",
      "review": {
        "version": "editorial-serial29-3d889146bcd68262",
        "sha256": "3d889146bcd682626e45249bbacab65170bc09f8d520a755a5be4d88aacae0bf",
        "gate": "misread",
        "sourceCorpusSha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1"
      }
    }
  ]
}
